import React from "react";

export const IconTruckDriver = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9091 1H2C1.44772 1 1 1.44771 1 2V10.4545H11.9091V2C11.9091 1.44772 11.4614 1 10.9091 1Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9092 4.63638H14.8183L17.0001 6.8182V10.4546H11.9092V4.63638Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.09144 12.2727C6.09144 13.2769 5.27741 14.0909 4.27326 14.0909C3.26911 14.0909 2.45508 13.2769 2.45508 12.2727"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5455 12.2727C15.5455 13.2769 14.7315 14.0909 13.7274 14.0909C12.7232 14.0909 11.9092 13.2769 11.9092 12.2727"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDargUpload = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg width="117" height="91" className={`cicon ${className}`} viewBox="0 0 117 91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M58.9053 73.8454C77.5114 73.8454 92.672 58.7475 92.672 40.204C92.6093 21.5979 77.5114 6.5 58.9053 6.5C40.2366 6.5 25.1387 21.5979 25.1387 40.1414C25.1387 58.7475 40.2366 73.8454 58.9053 73.8454Z" fill="#EAEEF9" />
    <g filter="url(#filter0_d_11454_52444)">
      <path d="M94.9277 44.464C94.9277 51.6684 89.1016 57.4945 81.8345 57.4945C81.7092 57.4945 80.6442 57.4945 72.8134 57.4945C67.3631 57.4945 58.6552 57.4945 44.7476 57.4945H38.107C29.3991 57.6825 22.4453 50.7287 22.4453 42.334C22.4453 33.8767 29.4618 26.8602 38.295 27.2988C45.8752 3.61825 80.5816 6.93854 83.526 31.4334C90.0413 32.2479 94.9277 37.7608 94.9277 44.464Z" fill="url(#paint0_linear_11454_52444)" />
    </g>
    <path d="M81.8354 57.4946C89.0398 57.4946 94.9286 51.6684 94.9286 44.464C94.9286 37.2596 89.0398 31.4335 81.8354 31.4335C74.631 31.4335 68.7422 37.2596 68.7422 44.464C68.7422 51.6684 74.631 57.4946 81.8354 57.4946Z" fill="url(#paint1_linear_11454_52444)" />
    <path d="M60.4726 57.6198C73.3152 57.6198 83.7772 47.2204 83.7772 34.3778C83.7772 21.5352 73.3152 11.1359 60.4726 11.1359C47.63 11.1359 37.168 21.5352 37.168 34.3778C37.168 47.2204 47.5673 57.6198 60.4726 57.6198Z" fill="url(#paint2_linear_11454_52444)" />
    <path d="M47.9754 35.0565C51.1848 32.9904 54.9703 31.8334 59.0027 31.8334C70.03 31.8334 79 40.759 79 51.8334C79 62.9077 70.03 71.8334 59.0027 71.8334C47.9754 71.8334 39.0054 62.9077 39.0054 51.8334C38.8408 44.8086 42.4617 38.6929 47.9754 35.0565Z" fill="url(#paint3_linear_11454_52444)" />
    <path d="M60.3364 44.4195L65.8465 50.1136C66.4947 50.7835 66.4947 51.9558 65.8465 52.6256C65.1982 53.2955 64.0638 53.2955 63.3345 52.6256L60.8226 50.1136V59.3245C60.8226 60.3293 60.0122 61.1667 59.0399 61.1667C58.0675 61.1667 57.2572 60.3293 57.2572 59.3245V50.1136L54.7452 52.6256C54.097 53.2955 52.9625 53.2955 52.2332 52.6256C51.8281 52.207 51.666 51.7883 51.666 51.3696C51.666 50.9509 51.8281 50.3648 52.2332 50.1136L57.7434 44.4195C57.9865 44.1683 58.5537 43.8334 58.9588 43.8334C59.364 43.8334 60.0933 44.0008 60.3364 44.4195Z" fill="white" />
    <path d="M93.4865 28.4263C94.905 28.4263 96.055 27.2764 96.055 25.8578C96.055 24.4393 94.905 23.2893 93.4865 23.2893C92.0679 23.2893 90.918 24.4393 90.918 25.8578C90.918 27.2764 92.0679 28.4263 93.4865 28.4263Z" fill="#EAEEF9" />
    <path d="M97.2463 18.4029C98.2151 18.4029 99.0004 17.6175 99.0004 16.6488C99.0004 15.68 98.2151 14.8947 97.2463 14.8947C96.2775 14.8947 95.4922 15.68 95.4922 16.6488C95.4922 17.6175 96.2775 18.4029 97.2463 18.4029Z" fill="#EAEEF9" />
    <path d="M26.2053 24.1664C27.1741 24.1664 27.9594 23.3811 27.9594 22.4123C27.9594 21.4435 27.1741 20.6582 26.2053 20.6582C25.2365 20.6582 24.4512 21.4435 24.4512 22.4123C24.4512 23.3811 25.2365 24.1664 26.2053 24.1664Z" fill="#EAEEF9" />
    <path d="M22.2576 62.7569C24.0568 62.7569 25.5153 61.2984 25.5153 59.4992C25.5153 57.7001 24.0568 56.2416 22.2576 56.2416C20.4585 56.2416 19 57.7001 19 59.4992C19 61.2984 20.4585 62.7569 22.2576 62.7569Z" fill="#EAEEF9" />
    <defs>
      <filter id="filter0_d_11454_52444" x="0.445312" y="0.192505" width="116.482" height="90.3058" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11454_52444" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11454_52444" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_11454_52444" x1="58.6865" y1="30.3278" x2="58.6629" y2="57.9975" gradientUnits="userSpaceOnUse">
        <stop stop-color="white" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient id="paint1_linear_11454_52444" x1="67.3489" y1="28.628" x2="78.9559" y2="41.3226" gradientUnits="userSpaceOnUse">
        <stop stop-color="#BCCBE1" />
        <stop offset="0.9942" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient id="paint2_linear_11454_52444" x1="34.9857" y1="23.7127" x2="53.2794" y2="30.8716" gradientUnits="userSpaceOnUse">
        <stop stop-color="#E2E8F0" />
        <stop offset="0.9942" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient id="paint3_linear_11454_52444" x1="59.0032" y1="33.2229" x2="59.0032" y2="55.6745" gradientUnits="userSpaceOnUse">
        <stop stop-color="#B0BACC" />
        <stop offset="1" stop-color="#969EAE" />
      </linearGradient>
    </defs>
  </svg>
)

export const IconTruck = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2933 3.33057C12.2933 2.98539 12.0135 2.70557 11.6683 2.70557C11.3231 2.70557 11.0433 2.98539 11.0433 3.33057V11.0424H1.66411C1.31894 11.0424 1.03911 11.3222 1.03911 11.6674C1.03911 12.0126 1.31894 12.2924 1.66411 12.2924H11.6683C12.0135 12.2924 12.2933 12.0126 12.2933 11.6674V5.62293H15.6395C16.0342 5.62293 16.3951 5.84595 16.5717 6.19901L16.9093 6.87398H15.003C14.6578 6.87398 14.378 7.1538 14.378 7.49898V10.4169C14.378 10.9923 14.8445 11.4587 15.4199 11.4587H17.7127V14.5853C17.7127 14.7005 17.6193 14.7939 17.504 14.7939H16.1449C16.0535 14.5352 15.9047 14.2948 15.7026 14.0927L15.7003 14.0904C15.3489 13.7401 14.8729 13.5434 14.3767 13.5433C13.8793 13.5433 13.402 13.7411 13.0503 14.0928C12.8657 14.2774 12.7256 14.494 12.6331 14.7272H7.3041C7.21159 14.4939 7.0715 14.2773 6.88687 14.0927L6.88458 14.0904C6.53316 13.7401 6.05718 13.5434 5.5609 13.5433C5.06502 13.5433 4.58909 13.7399 4.23769 14.0896C3.88634 13.7398 3.41071 13.5434 2.9148 13.5433C2.41741 13.5433 1.9401 13.7411 1.58838 14.0928C1.05201 14.6292 0.891589 15.4359 1.18192 16.1368C1.47225 16.8376 2.15616 17.2945 2.9147 17.2945C3.4204 17.2945 3.89289 17.0914 4.2377 16.7483C4.58255 17.0914 5.05509 17.2945 5.5608 17.2945C6.31942 17.2945 7.00328 16.8374 7.29353 16.1366C7.3153 16.084 7.33454 16.0308 7.35127 15.9772H12.586C12.6027 16.0309 12.622 16.0841 12.6438 16.1368C12.9341 16.8376 13.618 17.2945 14.3766 17.2945C15.1352 17.2945 15.819 16.8374 16.1093 16.1366C16.122 16.1059 16.1339 16.075 16.1448 16.0439H17.504C18.3097 16.0439 18.9627 15.3909 18.9627 14.5853V10.8372L18.9627 10.8337L18.9627 10.8302V8.72639C18.9627 8.37041 18.8798 8.01931 18.7206 7.70092L18.486 7.23188C18.4821 7.22375 18.4781 7.21571 18.4739 7.20778L17.6897 5.63985C17.3013 4.86338 16.5077 4.37293 15.6395 4.37293H12.2933V3.33057ZM15.628 8.12398H17.5345L17.6026 8.26011C17.675 8.40487 17.7127 8.56451 17.7127 8.72639V10.2087H15.628V8.12398ZM14.9544 15.6583C15.0512 15.4246 14.9976 15.1554 14.8187 14.9765C14.7014 14.8592 14.5424 14.7933 14.3766 14.7933C14.2107 14.7933 14.0517 14.8592 13.9344 14.9764C13.7555 15.1553 13.7018 15.4246 13.7986 15.6583C13.8954 15.8921 14.1235 16.0445 14.3766 16.0445C14.6295 16.0445 14.8576 15.8921 14.9544 15.6583ZM3.49256 15.6583C3.58936 15.4246 3.53573 15.1554 3.35682 14.9765C3.23957 14.8592 3.08053 14.7933 2.91469 14.7933C2.74885 14.7933 2.5898 14.8592 2.47253 14.9764C2.29366 15.1553 2.23992 15.4246 2.33674 15.6583C2.43356 15.8921 2.66165 16.0445 2.9147 16.0445C3.16765 16.0445 3.39574 15.8921 3.49256 15.6583ZM6.13866 15.6583C6.23547 15.4246 6.18183 15.1554 6.00292 14.9765C5.88568 14.8592 5.72663 14.7933 5.56079 14.7933C5.39496 14.7933 5.2359 14.8592 5.11863 14.9764C4.93976 15.1553 4.88602 15.4246 4.98285 15.6583C5.07967 15.8921 5.30776 16.0445 5.5608 16.0445C5.81376 16.0445 6.04184 15.8921 6.13866 15.6583Z"
      fill="currentColor"
    />
    <path
      d="M1.66411 2.70558C1.31894 2.70558 1.03911 2.9854 1.03911 3.33058C1.03911 3.67576 1.31894 3.95558 1.66411 3.95558H8.33358C8.44815 3.95558 8.54116 4.04791 8.54225 4.16223L8.54224 4.16424V9.16633C8.54224 9.5115 8.82206 9.79133 9.16724 9.79133C9.51242 9.79133 9.79224 9.5115 9.79224 9.16633V4.16888L9.79226 4.16426C9.79226 3.35865 9.13916 2.70558 8.33356 2.70558H1.66411Z"
      fill="currentColor"
    />
  </svg>
);

export const IconMinus = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="10"
    height="2"
    viewBox="0 0 10 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.74229e-08 2L0 4.37114e-07L10 0V2L8.74229e-08 2Z"
      fill="currentColor"
    />
  </svg>
);
export const IconPlus = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0H5V5H0V7H5V12H7V7H12V5H7V0Z"
      fill="currentColor"
    />
  </svg>
);

export const IconFilter = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 4H3L8.6 10.622V15.2L11.4 16.6V10.622L17 4Z"
      fill="currentColor"
    />
  </svg>
);

export const IconColumn = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3V17M10 3H15.4444C15.857 3 16.2527 3.16389 16.5444 3.45561C16.8361 3.74733 17 4.143 17 4.55556V15.4444C17 15.857 16.8361 16.2527 16.5444 16.5444C16.2527 16.8361 15.857 17 15.4444 17H10V3ZM10 3H4.55556C4.143 3 3.74733 3.16389 3.45561 3.45561C3.16389 3.74733 3 4.143 3 4.55556V15.4444C3 15.857 3.16389 16.2527 3.45561 16.5444C3.74733 16.8361 4.143 17 4.55556 17H10V3Z"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAngleArrowLeft = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.39924 9.39909L11.7984 5.99997L13.0001 7.20174L10.2019 9.99997L13.0001 12.7982L11.7984 14L8.39924 10.6009C8.06738 10.269 8.06738 9.73094 8.39924 9.39909Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAngleArrowRight = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5395 10.6009L9.18574 14L8 12.7982L10.7609 10L8 7.20177L9.18574 6L12.5395 9.39912C12.867 9.73097 12.867 10.269 12.5395 10.6009Z"
      fill="currentColor"
    />
  </svg>
);
export const IconAngleArrowTop = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.601 8.10621L14.0001 11.5053L12.7984 12.7071L10.0001 9.90886L7.20189 12.7071L6.00012 11.5053L9.39924 8.10621C9.7311 7.77435 10.2691 7.77435 10.601 8.10621Z"
      fill="currentColor"
    />
  </svg>
);
export const IconAngleArrowDown = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.39899 12.8938L5.99988 9.49468L7.20165 8.29291L9.99988 11.0911L12.7981 8.29291L13.9999 9.49468L10.6008 12.8938C10.2689 13.2257 9.73085 13.2257 9.39899 12.8938Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCaretDown = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 12L13 8H7L10 12Z" fill="currentColor"></path>
  </svg>
);

export const IconCalendar = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2.66666H3.33333C2.59695 2.66666 2 3.26361 2 3.99999V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V3.99999C14 3.26361 13.403 2.66666 12.6667 2.66666Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M10.6665 1.33334V4.00001"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M5.3335 1.33334V4.00001"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M2 6.66666H14"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const IconWarning = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.76427 12.1512L6.95263 3.48964C7.06183 3.30961 7.21558 3.16077 7.39906 3.05747C7.58254 2.95417 7.78954 2.8999 8.0001 2.8999C8.21065 2.8999 8.41766 2.95417 8.60113 3.05747C8.78461 3.16077 8.93837 3.30961 9.04757 3.48964L14.2359 12.1512C14.3429 12.3364 14.3995 12.5465 14.4001 12.7604C14.4007 12.9743 14.3453 13.1846 14.2393 13.3705C14.1334 13.5563 13.9807 13.7112 13.7963 13.8197C13.6119 13.9282 13.4024 13.9865 13.1884 13.9889H2.81175C2.59784 13.9865 2.38828 13.9282 2.20391 13.8197C2.01954 13.7112 1.86679 13.5563 1.76086 13.3705C1.65493 13.1846 1.5995 12.9743 1.6001 12.7604C1.6007 12.5465 1.6573 12.3364 1.76427 12.1512ZM8.00007 6.02562C8.33837 6.02562 8.61262 6.29987 8.61262 6.63818V9.0884C8.61262 9.42671 8.33837 9.70096 8.00007 9.70096C7.66176 9.70096 7.38751 9.42671 7.38751 9.0884V6.63818C7.38751 6.29987 7.66176 6.02562 8.00007 6.02562ZM7.38751 11.5386C7.38751 11.2003 7.66176 10.9261 8.00007 10.9261H8.00619C8.3445 10.9261 8.61875 11.2003 8.61875 11.5386C8.61875 11.8769 8.3445 12.1512 8.00619 12.1512H8.00007C7.66176 12.1512 7.38751 11.8769 7.38751 11.5386Z"
      fill="currentColor"
    ></path>
  </svg>
);
export const IconMapMarker = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.6429C8 14.6429 13 11.3312 13 7.46753C13 6.15006 12.4732 4.88655 11.5355 3.95496C10.5979 3.02336 9.32608 2.5 8 2.5C6.67392 2.5 5.40215 3.02336 4.46447 3.95496C3.52678 4.88655 3 6.15006 3 7.46753C3 11.3312 8 14.6429 8 14.6429ZM10.1428 7.5C10.1428 8.68347 9.18342 9.64286 7.99996 9.64286C6.81649 9.64286 5.8571 8.68347 5.8571 7.5C5.8571 6.31653 6.81649 5.35714 7.99996 5.35714C9.18342 5.35714 10.1428 6.31653 10.1428 7.5Z"
      fill="currentColor"
    ></path>
  </svg>
);
export const IconWeightTool = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3.5H13V4.5C13 5.05228 12.5523 5.5 12 5.5H9V6.5H12L12.8595 13.376C12.9341 13.9728 12.4687 14.5 11.8672 14.5H4.13278C3.53128 14.5 3.0659 13.9728 3.1405 13.376L4 6.5H7V5.5H4C3.44772 5.5 3 5.05228 3 4.5V3.5ZM11 10.5C11 12.1569 9.65685 13.5 8 13.5C6.34315 13.5 5 12.1569 5 10.5C5 8.84315 6.34315 7.5 8 7.5C8.6544 7.5 9.25986 7.70953 9.75295 8.06515C9.71483 8.08684 9.67896 8.11393 9.64645 8.14645L7.64645 10.1464C7.45118 10.3417 7.45118 10.6583 7.64645 10.8536C7.84171 11.0488 8.15829 11.0488 8.35355 10.8536L10.3536 8.85355C10.3861 8.82104 10.4132 8.78517 10.4348 8.74705C10.7905 9.24014 11 9.8456 11 10.5Z"
      fill="currentColor"
    />
  </svg>
);
export const IconFile = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.66882 3.36853C3.96888 3.06847 4.37585 2.8999 4.8002 2.8999H9.06673H9.06686L9.08089 2.90009C9.17973 2.90266 9.27188 2.93213 9.35028 2.98144C9.38396 3.00257 9.41543 3.02755 9.44399 3.05611L12.644 6.25611C12.685 6.29709 12.7186 6.34404 12.744 6.39493C12.7608 6.42861 12.7742 6.46431 12.7837 6.50159C12.7946 6.54426 12.8002 6.58846 12.8002 6.63324V13.0332C12.8002 13.4576 12.6316 13.8645 12.3316 14.1646C12.0315 14.4647 11.6245 14.6332 11.2002 14.6332H4.8002C4.37585 14.6332 3.96888 14.4647 3.66882 14.1646C3.36877 13.8645 3.2002 13.4576 3.2002 13.0332V4.4999C3.2002 4.07556 3.36877 3.66859 3.66882 3.36853ZM4.8002 3.96657H8.5334V6.63324C8.5334 6.92779 8.77218 7.16657 9.06673 7.16657H11.7335V13.0332C11.7335 13.1747 11.6773 13.3103 11.5773 13.4104C11.4773 13.5104 11.3416 13.5666 11.2002 13.5666H4.8002C4.65875 13.5666 4.52309 13.5104 4.42307 13.4104C4.32305 13.3103 4.26686 13.1747 4.26686 13.0332V4.4999C4.26686 4.35845 4.32305 4.2228 4.42307 4.12278C4.52309 4.02276 4.65875 3.96657 4.8002 3.96657ZM9.60007 4.72069L10.9793 6.0999H9.60007V4.72069ZM5.86673 8.76656C5.57218 8.76656 5.3334 9.00534 5.3334 9.29989C5.3334 9.59444 5.57218 9.83322 5.86673 9.83322H10.1334C10.4279 9.83322 10.6667 9.59444 10.6667 9.29989C10.6667 9.00534 10.4279 8.76656 10.1334 8.76656H5.86673ZM5.3334 11.4332C5.3334 11.1387 5.57218 10.8999 5.86673 10.8999H10.1334C10.4279 10.8999 10.6667 11.1387 10.6667 11.4332C10.6667 11.7278 10.4279 11.9666 10.1334 11.9666H5.86673C5.57218 11.9666 5.3334 11.7278 5.3334 11.4332ZM5.86673 6.63323C5.57218 6.63323 5.3334 6.87201 5.3334 7.16656C5.3334 7.46112 5.57218 7.6999 5.86673 7.6999H6.9334C7.22795 7.6999 7.46673 7.46112 7.46673 7.16656C7.46673 6.87201 7.22795 6.63323 6.9334 6.63323H5.86673Z"
      fill="currentColor"
    />
  </svg>
);
export const IconSnowFlake = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1974 10.7549L12.5597 10.3905L12.7874 10.2994C13.1063 10.1627 13.2429 9.79832 13.1063 9.47946C12.9696 9.1606 12.6052 9.02394 12.2864 9.16059L11.2387 9.61611L9.1433 8.43177L11.1931 7.24743L12.2408 7.70294C12.3319 7.7485 12.423 7.7485 12.5141 7.7485C12.7419 7.7485 12.9696 7.61184 13.0607 7.38408C13.1974 7.06522 13.0607 6.70081 12.7419 6.56415L12.5141 6.4275L13.1518 6.06309C13.4251 5.88088 13.5618 5.51647 13.3796 5.24316C13.1974 4.96985 12.833 4.83319 12.5597 5.0154L11.9219 5.42536L11.9675 5.15206C12.0131 4.8332 11.7397 4.51433 11.4209 4.46878C11.102 4.42323 10.7832 4.69654 10.7376 5.0154L10.6465 6.15419L8.55113 7.33853V4.9243L9.46216 4.28658C9.73547 4.10437 9.78102 3.6944 9.59881 3.42109C9.41661 3.14778 9.00664 3.10224 8.73333 3.28444L8.50558 3.42109V2.69227C8.50558 2.37341 8.23227 2.1001 7.91341 2.1001C7.59455 2.1001 7.32124 2.37341 7.32124 2.69227V3.42109L7.09348 3.28444C6.82017 3.10224 6.45575 3.14778 6.228 3.42109C6.04579 3.6944 6.09134 4.05882 6.36465 4.28658L7.27568 4.9243V7.33853L5.22586 6.15419L5.13476 5.0154C5.08921 4.69654 4.8159 4.42323 4.45149 4.46878C4.13263 4.51433 3.85931 4.78764 3.90487 5.15206L3.95042 5.42536L3.3127 5.06095C3.03939 4.87874 2.62942 5.0154 2.49277 5.28871C2.31056 5.56202 2.40166 5.97198 2.72053 6.10864L3.35825 6.47305L3.13049 6.56415C2.81163 6.70081 2.67497 7.06522 2.81163 7.38408C2.90273 7.61184 3.13049 7.7485 3.35825 7.7485C3.44935 7.7485 3.54045 7.7485 3.63156 7.70294L4.67924 7.24743L6.77462 8.43177L4.7248 9.61611L3.67711 9.16059C3.35825 9.02394 2.99384 9.1606 2.85718 9.47946C2.72053 9.79832 2.85718 10.1627 3.17604 10.2994L3.4038 10.436L2.76608 10.8005C2.49277 10.9827 2.35611 11.3471 2.53832 11.6204C2.62942 11.8026 2.85718 11.9392 3.08494 11.9392C3.17604 11.9392 3.3127 11.8937 3.4038 11.8481L4.04152 11.4837L3.99597 11.757C3.95042 12.0759 4.22373 12.3948 4.54259 12.4403H4.58814C4.907 12.4403 5.18031 12.2126 5.18031 11.8937L5.27141 10.7549L7.36679 9.57056V11.9848L6.45575 12.6681C6.18244 12.8503 6.13689 13.2602 6.3191 13.5335C6.45576 13.7158 6.63796 13.8069 6.82017 13.8069C6.95682 13.8069 7.04793 13.7613 7.18458 13.7158L7.41234 13.5791V14.3079C7.41234 14.6268 7.68565 14.9001 8.00451 14.9001C8.32337 14.9001 8.59668 14.6268 8.59668 14.3079V13.5791L8.82444 13.7158C8.91554 13.8069 9.0522 13.8069 9.18885 13.8069C9.37106 13.8069 9.55327 13.7158 9.68992 13.5335C9.87213 13.2602 9.82657 12.8958 9.55326 12.6681L8.64223 12.0303V9.61611L10.6921 10.8005L10.7832 11.9392C10.8287 12.2581 11.0565 12.4859 11.3753 12.4859H11.4209C11.7397 12.4403 12.0131 12.167 11.9675 11.8026L11.9219 11.5293L12.5597 11.8937C12.6508 11.9392 12.7419 11.9848 12.8785 11.9848C13.1063 11.9848 13.2885 11.8937 13.4251 11.6659C13.5618 11.3015 13.4707 10.9371 13.1974 10.7549Z"
      fill="currentColor"
    />
  </svg>
);
export const IconFire = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.397 6.59747C10.3787 6.89781 10.3399 7.19724 10.2786 7.49027C10.1922 7.90581 9.82602 8.19153 9.41734 8.19153C9.35791 8.19153 9.29711 8.18558 9.23722 8.17324C8.76042 8.07404 8.45505 7.60775 8.5538 7.13187C8.61734 6.82787 8.64888 6.51564 8.64888 6.2025C8.64888 4.4009 7.59791 2.84021 6.077 2.1001C7.12842 6.75061 3.2002 6.7657 3.2002 10.6592C3.2002 12.6194 4.45551 14.2825 6.20362 14.9001C5.93802 14.5691 5.77254 14.155 5.77254 13.6978C5.77254 12.986 6.20591 12.3488 6.54557 11.9575C6.56568 12.272 6.63882 12.5783 6.76454 12.8681C6.82762 13.0103 6.9666 13.0958 7.11197 13.0958C7.16271 13.0958 7.21208 13.0857 7.26191 13.0642C7.45254 12.9806 7.53985 12.7588 7.45894 12.5678C7.34968 12.3209 7.29528 12.059 7.29528 11.7883C7.29528 11.0158 7.74602 10.3474 8.39928 10.0302C7.94762 12.0233 9.63082 12.0297 9.63082 13.6978C9.63082 14.155 9.46534 14.5696 9.19974 14.9001C10.9483 14.2825 12.2032 12.6194 12.2032 10.6596C12.2032 8.99747 11.192 7.51038 10.397 6.59747Z"
      fill="currentColor"
    />
  </svg>
);
export const IconChat = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 10.0833C18.0028 11.1832 17.7459 12.2682 17.25 13.25C16.662 14.4265 15.7581 15.416 14.6395 16.1077C13.5209 16.7995 12.2319 17.1662 10.9167 17.1667C9.81677 17.1695 8.73175 16.9126 7.74999 16.4167L3 18L4.58333 13.25C4.08744 12.2682 3.83046 11.1832 3.83333 10.0833C3.83384 8.76815 4.20051 7.47906 4.89226 6.36048C5.58402 5.2419 6.57354 4.338 7.74999 3.75002C8.73175 3.25413 9.81677 2.99716 10.9167 3.00003H11.3333C13.0703 3.09585 14.7109 3.82899 15.9409 5.05907C17.171 6.28915 17.9041 7.92973 18 9.66668V10.0833Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPrinter = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6V3H14V6"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.4 13.6667C4.0287 13.6667 3.6726 13.5262 3.41005 13.2762C3.1475 13.0261 3 12.687 3 12.3334V9.00002C3 8.6464 3.1475 8.30726 3.41005 8.05721C3.6726 7.80716 4.0287 7.66669 4.4 7.66669H15.6C15.9713 7.66669 16.3274 7.80716 16.5899 8.05721C16.8525 8.30726 17 8.6464 17 9.00002V12.3334C17 12.687 16.8525 13.0261 16.5899 13.2762C16.3274 13.5262 15.9713 13.6667 15.6 13.6667"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 11H7V16H13V11Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconClone = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5286 4.5286C4.65362 4.40357 4.82319 4.33333 5 4.33333H11C11.1768 4.33333 11.3464 4.40357 11.4714 4.5286C11.5964 4.65362 11.6667 4.82319 11.6667 5V5.66667C11.6667 6.03486 11.9651 6.33333 12.3333 6.33333C12.7015 6.33333 13 6.03486 13 5.66667V5C13 4.46957 12.7893 3.96086 12.4142 3.58579C12.0391 3.21071 11.5304 3 11 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V11C3 11.5304 3.21071 12.0391 3.58579 12.4142C3.96086 12.7893 4.46957 13 5 13H5.66667C6.03486 13 6.33333 12.7015 6.33333 12.3333C6.33333 11.9651 6.03486 11.6667 5.66667 11.6667H5C4.82319 11.6667 4.65362 11.5964 4.5286 11.4714C4.40357 11.3464 4.33333 11.1768 4.33333 11V5C4.33333 4.82319 4.40357 4.65362 4.5286 4.5286Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.66675 7.66663C8.56218 7.66663 7.66675 8.56206 7.66675 9.66663V15.6666C7.66675 16.7712 8.56218 17.6666 9.66675 17.6666H15.6667C16.7713 17.6666 17.6667 16.7712 17.6667 15.6666V9.66663C17.6667 8.56206 16.7713 7.66663 15.6667 7.66663H9.66675ZM9.00008 9.66663C9.00008 9.29844 9.29856 8.99996 9.66675 8.99996H15.6667C16.0349 8.99996 16.3334 9.29844 16.3334 9.66663V15.6666C16.3334 16.0348 16.0349 16.3333 15.6667 16.3333H9.66675C9.29856 16.3333 9.00008 16.0348 9.00008 15.6666V9.66663Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTrash = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.53411 2.01001C7.16052 2.01001 6.85767 2.31286 6.85767 2.68645C6.85767 3.06003 7.16052 3.36289 7.53411 3.36289H12.9456C13.3192 3.36289 13.622 3.06003 13.622 2.68645C13.622 2.31286 13.3192 2.01001 12.9456 2.01001H7.53411ZM3.25 5.60865C3.25 5.23506 3.55285 4.93221 3.92644 4.93221H4.82835H15.6514H16.5533C16.9269 4.93221 17.2297 5.23506 17.2297 5.60865C17.2297 5.98224 16.9269 6.28509 16.5533 6.28509H16.3278V15.5297C16.3278 16.8999 15.2177 18.01 13.8475 18.01H6.63219C5.26198 18.01 4.15192 16.8999 4.15192 15.5297V6.28509H3.92644C3.55285 6.28509 3.25 5.98224 3.25 5.60865ZM5.50479 15.5297V6.28509H14.9749V15.5297C14.9749 16.1528 14.4706 16.6571 13.8475 16.6571H6.63219C6.00916 16.6571 5.50479 16.1528 5.50479 15.5297ZM8.07397 9.30622C8.33814 9.04205 8.76643 9.04205 9.0306 9.30622L10.2389 10.5145L11.4471 9.30622C11.7113 9.04205 12.1396 9.04205 12.4038 9.30622C12.6679 9.57038 12.6679 9.99868 12.4038 10.2628L11.1955 11.4711L12.4038 12.6794C12.6679 12.9436 12.6679 13.3718 12.4038 13.636C12.1396 13.9002 11.7113 13.9002 11.4471 13.636L10.2389 12.4277L9.0306 13.636C8.76643 13.9002 8.33814 13.9002 8.07397 13.636C7.80981 13.3718 7.80981 12.9436 8.07397 12.6794L9.28224 11.4711L8.07397 10.2628C7.80981 9.99868 7.80981 9.57038 8.07397 9.30622Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPhone = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5647 17C15.4976 17 15.4402 17 15.3827 16.9904C13.3239 16.7702 11.3225 16.052 9.58929 14.9316C7.98054 13.907 6.59203 12.5185 5.56741 10.9097C4.43745 9.16689 3.72883 7.15595 3.50858 5.09713C3.4607 4.58003 3.61392 4.08208 3.94908 3.68947C4.27466 3.29685 4.7343 3.05746 5.2514 3.00958C5.2897 3 5.35674 3 5.41419 3H7.32938C8.3157 3 9.10092 3.69904 9.23498 4.64706C9.31159 5.21204 9.44565 5.77702 9.64675 6.30369C9.9053 7.00274 9.74251 7.78796 9.21583 8.32421L8.75619 8.78386C9.50311 9.9617 10.5086 10.9672 11.6864 11.7141L12.1461 11.2544C12.6823 10.7278 13.4675 10.5554 14.1666 10.8235C14.6933 11.0246 15.2582 11.1587 15.8232 11.2353C16.7904 11.3694 17.499 12.2025 17.4799 13.1696V15.0752C17.4799 15.5828 17.2883 16.0616 16.9245 16.4254C16.5606 16.7989 16.0722 17 15.5647 17ZM7.33895 4.2736H5.41419C5.18437 4.29275 5.03115 4.36936 4.92582 4.50342C4.81091 4.63748 4.76303 4.80027 4.78218 4.97264C4.9737 6.83037 5.61529 8.64022 6.63991 10.2202C7.56877 11.6758 8.82322 12.9302 10.2788 13.8591C11.8492 14.8741 13.6591 15.5253 15.5168 15.7264C15.919 15.7264 16.2063 15.4391 16.1967 15.0848V13.1696C16.1967 13.1601 16.1967 13.1601 16.1967 13.1505C16.2063 12.8249 15.9669 12.5472 15.6509 12.4993C14.9997 12.4131 14.3485 12.2503 13.7261 12.0205C13.4867 11.9343 13.2281 11.9918 13.0462 12.1642L12.2418 12.9685C12.0407 13.1696 11.7247 13.2079 11.4758 13.0739C9.77124 12.1067 8.36358 10.699 7.39641 9.0041C7.25277 8.75513 7.30065 8.43912 7.50174 8.23803L8.3157 7.42408C8.48806 7.25171 8.54552 6.98358 8.45933 6.75376C8.21994 6.13133 8.05715 5.48016 7.97096 4.81943C7.92308 4.513 7.65496 4.2736 7.33895 4.2736Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAt = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3334 2.52524C9.72164 2.14909 8.02999 2.32925 6.53356 3.03642C5.03713 3.7436 3.82393 4.93619 3.09123 6.42029C2.35852 7.90438 2.14941 9.5927 2.49789 11.2107C2.84637 12.8287 3.73195 14.2813 5.01063 15.3322C6.28931 16.383 7.88589 16.9705 9.54075 16.9989C11.1956 17.0274 12.8115 16.4952 14.1255 15.4889C14.4178 15.265 14.4733 14.8466 14.2495 14.5543C14.0256 14.2619 13.6072 14.2064 13.3148 14.4303C12.2397 15.2536 10.9177 15.6891 9.56368 15.6658C8.2097 15.6425 6.90341 15.1619 5.85721 14.3021C4.81102 13.4422 4.08646 12.2538 3.80134 10.93C3.51622 9.60615 3.68731 8.2248 4.28679 7.01054C4.88627 5.79628 5.87889 4.82052 7.10325 4.24193C8.3276 3.66333 9.71167 3.51593 11.0304 3.82368C12.3492 4.13144 13.525 4.87626 14.3668 5.93702C15.2086 6.99778 15.6667 8.31214 15.6668 9.66631V10.3329C15.6668 10.6866 15.5264 11.0257 15.2763 11.2757C15.0263 11.5258 14.6871 11.6663 14.3335 11.6663C13.9799 11.6663 13.6407 11.5258 13.3907 11.2757C13.1406 11.0257 13.0002 10.6866 13.0002 10.3329V6.9996C13.0002 6.63141 12.7017 6.33293 12.3335 6.33293C11.9654 6.33293 11.667 6.63127 11.6668 6.99935C11.1097 6.58089 10.4172 6.33292 9.66683 6.33292C7.82588 6.33292 6.3335 7.8253 6.3335 9.66625C6.3335 11.5072 7.82588 12.9996 9.66683 12.9996C10.6589 12.9996 11.5497 12.5662 12.1603 11.8784C12.246 11.9988 12.342 12.1127 12.4479 12.2185C12.948 12.7186 13.6263 12.9996 14.3335 12.9996C15.0407 12.9996 15.719 12.7186 16.2191 12.2185C16.7192 11.7185 17.0002 11.0402 17.0002 10.3329V9.66622C17.0001 8.01111 16.4401 6.40471 15.4112 5.10821C14.3824 3.81172 12.9452 2.90139 11.3334 2.52524ZM7.66683 9.66625C7.66683 8.56168 8.56226 7.66625 9.66683 7.66625C10.7714 7.66625 11.6668 8.56168 11.6668 9.66625C11.6668 10.7708 10.7714 11.6663 9.66683 11.6663C8.56226 11.6663 7.66683 10.7708 7.66683 9.66625Z"
      fill="currentColor"
    />
  </svg>
);

export const IconInfoFocus = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16667 1.875C2.90066 1.875 1.875 2.90066 1.875 4.16667V6.25C1.875 6.59518 2.15482 6.875 2.5 6.875C2.84518 6.875 3.125 6.59518 3.125 6.25V4.16667C3.125 3.59101 3.59101 3.125 4.16667 3.125H6.25C6.59518 3.125 6.875 2.84518 6.875 2.5C6.875 2.15482 6.59518 1.875 6.25 1.875H4.16667Z"
      fill="currentColor"
    />
    <path
      d="M3.125 13.75C3.125 13.4048 2.84518 13.125 2.5 13.125C2.15482 13.125 1.875 13.4048 1.875 13.75V15.8333C1.875 17.0993 2.90066 18.125 4.16667 18.125H6.25C6.59518 18.125 6.875 17.8452 6.875 17.5C6.875 17.1548 6.59518 16.875 6.25 16.875H4.16667C3.59101 16.875 3.125 16.409 3.125 15.8333V13.75Z"
      fill="currentColor"
    />
    <path
      d="M17.5 13.125C17.8452 13.125 18.125 13.4048 18.125 13.75V15.8333C18.125 17.0993 17.0993 18.125 15.8333 18.125H13.75C13.4048 18.125 13.125 17.8452 13.125 17.5C13.125 17.1548 13.4048 16.875 13.75 16.875H15.8333C16.409 16.875 16.875 16.409 16.875 15.8333V13.75C16.875 13.4048 17.1548 13.125 17.5 13.125Z"
      fill="currentColor"
    />
    <path
      d="M13.75 1.875C13.4048 1.875 13.125 2.15482 13.125 2.5C13.125 2.84518 13.4048 3.125 13.75 3.125H15.8333C16.409 3.125 16.875 3.59101 16.875 4.16667V6.25C16.875 6.59518 17.1548 6.875 17.5 6.875C17.8452 6.875 18.125 6.59518 18.125 6.25V4.16667C18.125 2.90066 17.0993 1.875 15.8333 1.875H13.75Z"
      fill="currentColor"
    />
    <path
      d="M10 9.375C10.3452 9.375 10.625 9.65482 10.625 10V14.1667C10.625 14.5118 10.3452 14.7917 10 14.7917C9.65482 14.7917 9.375 14.5118 9.375 14.1667V10C9.375 9.65482 9.65482 9.375 10 9.375Z"
      fill="currentColor"
    />
    <path
      d="M9.99917 6.04167C9.54062 6.04167 9.16455 6.41373 9.16668 6.87726C9.1679 7.3364 9.54058 7.70833 10 7.70833C10.4602 7.70833 10.8333 7.33518 10.8333 6.875C10.8333 6.4132 10.4586 6.04167 9.99917 6.04167Z"
      fill="currentColor"
    />
  </svg>
);
export const IconBilling = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.47302 13.5503C7.47302 13.1361 7.80881 12.8003 8.22302 12.8003H11.7769C12.1911 12.8003 12.5269 13.1361 12.5269 13.5503C12.5269 13.9645 12.1911 14.3003 11.7769 14.3003H8.22302C7.80881 14.3003 7.47302 13.9645 7.47302 13.5503Z"
      fill="currentColor"
    />
    <path
      d="M12.0849 9.64985C12.3778 9.35703 12.378 8.88215 12.0851 8.58919C11.7923 8.29622 11.3175 8.2961 11.0245 8.58892L9.76019 9.8526L9.4188 9.51225C9.12546 9.21981 8.65059 9.22053 8.35814 9.51387C8.0657 9.80722 8.06642 10.2821 8.35977 10.5745L9.23135 11.4435C9.52432 11.7355 9.99847 11.7352 10.2911 11.4428L12.0849 9.64985Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.78075 1.25C3.76302 1.25 3.7453 1.25063 3.72762 1.25188C2.27597 1.35498 1.17678 2.60239 1.25381 4.05255V7.05609C1.17679 8.5062 2.27629 9.75341 3.72794 9.85588C3.74552 9.85712 3.76313 9.85774 3.78075 9.85774H4.80762V17.104C4.80762 17.3742 4.95295 17.6235 5.18806 17.7567C5.42318 17.8898 5.71173 17.8862 5.94343 17.7472L7.03858 17.0902L8.1329 17.7471C8.3704 17.8897 8.66715 17.8897 8.9047 17.7472L9.99996 17.0902L11.0952 17.7472C11.3328 17.8897 11.6295 17.8897 11.867 17.7471L12.9613 17.0902L14.0565 17.7472C14.2882 17.8862 14.5767 17.8898 14.8118 17.7567C15.047 17.6235 15.1923 17.3742 15.1923 17.104V9.85774H16.2193C16.237 9.85774 16.2548 9.85712 16.2724 9.85586C17.7241 9.75276 18.8233 8.50535 18.7462 7.05519V4.05256C18.8233 2.60239 17.7241 1.35498 16.2724 1.25188C16.2548 1.25063 16.237 1.25 16.2193 1.25H3.78075ZM15.1923 8.35774H16.1895C16.8166 8.3008 17.2871 7.75472 17.2477 7.12344C17.2467 7.10788 17.2462 7.0923 17.2462 7.07671V4.03104C17.2462 4.01545 17.2467 3.99986 17.2477 3.9843C17.2871 3.35303 16.8166 2.80695 16.1895 2.75H3.81059C3.18349 2.80695 2.71294 3.35303 2.75236 3.9843C2.75333 3.99986 2.75381 4.01545 2.75381 4.03104V7.07759C2.75381 7.09318 2.75333 7.10877 2.75236 7.12433C2.71296 7.75536 3.1835 8.30116 3.81041 8.35774H4.80762V5.55396C4.80762 5.13974 5.1434 4.80396 5.55762 4.80396H14.4423C14.8565 4.80396 15.1923 5.13974 15.1923 5.55396V8.35774ZM6.30762 9.11793L6.30768 9.10774L6.30762 9.09756V6.30396H13.6923V15.7795L13.347 15.5724C13.1095 15.4299 12.8127 15.43 12.5752 15.5725L11.4809 16.2294L10.3858 15.5724C10.1483 15.43 9.85163 15.43 9.61414 15.5724L8.519 16.2294L7.42468 15.5725C7.18717 15.43 6.89042 15.4299 6.65288 15.5724L6.30762 15.7795V9.11793Z"
      fill="currentColor"
    />
  </svg>
);

export const IconDocument = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66602 8.54167C6.32084 8.54167 6.04102 8.82149 6.04102 9.16667C6.04102 9.51184 6.32084 9.79167 6.66602 9.79167H11.666C12.0112 9.79167 12.291 9.51184 12.291 9.16667C12.291 8.82149 12.0112 8.54167 11.666 8.54167H6.66602Z"
      fill="currentColor"
    />
    <path
      d="M6.04102 11.6667C6.04102 11.3215 6.32084 11.0417 6.66602 11.0417H11.666C12.0112 11.0417 12.291 11.3215 12.291 11.6667C12.291 12.0118 12.0112 12.2917 11.666 12.2917H6.66602C6.32084 12.2917 6.04102 12.0118 6.04102 11.6667Z"
      fill="currentColor"
    />
    <path
      d="M6.66602 13.5417C6.32084 13.5417 6.04102 13.8215 6.04102 14.1667C6.04102 14.5118 6.32084 14.7917 6.66602 14.7917H10.2743C10.6195 14.7917 10.8993 14.5118 10.8993 14.1667C10.8993 13.8215 10.6195 13.5417 10.2743 13.5417H6.66602Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.54102 4.16667C3.54102 2.90066 4.56667 1.875 5.83268 1.875H11.8094C12.417 1.875 13 2.11681 13.4296 2.54639L15.7863 4.90306C16.2159 5.33264 16.4577 5.91572 16.4577 6.52333V15.8333C16.4577 17.0993 15.432 18.125 14.166 18.125H5.83268C4.56667 18.125 3.54102 17.0993 3.54102 15.8333V4.16667ZM5.83268 3.125H11.041V5.83333C11.041 6.63851 11.6942 7.29167 12.4993 7.29167H15.2077V15.8333C15.2077 16.409 14.7417 16.875 14.166 16.875H5.83268C5.25703 16.875 4.79102 16.409 4.79102 15.8333V4.16667C4.79102 3.59101 5.25703 3.125 5.83268 3.125ZM12.4993 6.04167H15.0894C15.0408 5.9486 14.978 5.86254 14.9024 5.78694L12.5457 3.43028C12.4701 3.35467 12.3841 3.29188 12.291 3.24329V5.83333C12.291 5.94816 12.3845 6.04167 12.4993 6.04167Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPayment = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.20145 3.88937C6.62788 1.41844 10.3536 0.756691 13.4825 2.2409C16.6115 3.72511 18.456 7.02917 18.0775 10.4715C17.6989 13.9138 15.1804 16.7381 11.8037 17.5069C11.4672 17.5835 11.1322 17.3728 11.0556 17.0362C10.979 16.6997 11.1897 16.3647 11.5262 16.2881C14.3835 15.6375 16.5146 13.2477 16.835 10.3349C17.1553 7.42202 15.5945 4.62619 12.9468 3.37028C10.2992 2.11437 7.14653 2.67433 5.09333 4.76519C3.04014 6.85604 2.53757 10.0184 3.8414 12.6427C3.99498 12.9519 3.86888 13.327 3.55975 13.4805C3.25062 13.6341 2.87552 13.508 2.72194 13.1989C1.1811 10.0975 1.77503 6.3603 4.20145 3.88937Z"
      fill="currentColor"
    />
    <path
      d="M7.10696 14.1433C6.86288 13.8992 6.46715 13.8992 6.22308 14.1433C5.979 14.3874 5.979 14.7831 6.22308 15.0272L6.82349 15.6276H3.33026C2.98508 15.6276 2.70526 15.9074 2.70526 16.2526C2.70526 16.5978 2.98508 16.8776 3.33026 16.8776H6.8235L6.22308 17.478C5.979 17.7221 5.979 18.1178 6.22308 18.3619C6.46715 18.606 6.86288 18.606 7.10696 18.3619L8.77432 16.6945C8.84649 16.6224 8.89732 16.5369 8.92681 16.4461C8.93915 16.4082 8.94796 16.3687 8.95285 16.3279C8.95881 16.2786 8.95889 16.2287 8.95309 16.1793C8.94793 16.1351 8.93815 16.0923 8.92426 16.0514C8.89443 15.9634 8.84445 15.8808 8.77432 15.8107L7.10696 14.1433Z"
      fill="currentColor"
    />
    <path
      d="M10.6247 6.24316C10.6247 5.89799 10.3449 5.61816 9.99973 5.61816C9.65455 5.61816 9.37473 5.89799 9.37473 6.24316V6.45526C8.51912 6.50849 7.81253 7.16554 7.70817 8.02886C7.59874 8.93414 8.18648 9.77694 9.0731 9.98755L10.6311 10.3791L10.6474 10.383C10.9198 10.4437 11.1016 10.7013 11.0675 10.9783C11.0335 11.2553 10.7947 11.4612 10.5157 11.4541L10.4999 11.4539H9.58593C9.38298 11.4515 9.19606 11.3429 9.0934 11.1677C8.91891 10.8699 8.53603 10.7699 8.2382 10.9444C7.94037 11.1189 7.84039 11.5018 8.01488 11.7996C8.3058 12.2962 8.81096 12.6233 9.37473 12.691V12.9126C9.37473 13.2578 9.65455 13.5376 9.99973 13.5376C10.3449 13.5376 10.6247 13.2578 10.6247 12.9126V12.7018C11.4854 12.6567 12.2014 11.9995 12.3082 11.1308C12.4203 10.2182 11.8238 9.36941 10.9285 9.16499L9.37345 8.77408L9.36368 8.77179C9.09455 8.70872 8.91597 8.45329 8.94914 8.17887C8.98231 7.90445 9.21662 7.69893 9.49302 7.70181L9.99494 7.70183L9.99973 7.70184L10.0045 7.70183L10.4141 7.70184C10.6171 7.70382 10.8041 7.81231 10.9067 7.98761C11.0809 8.28557 11.4637 8.38586 11.7617 8.2116C12.0597 8.03734 12.1599 7.65453 11.9857 7.35657C11.6949 6.85927 11.1891 6.53181 10.6247 6.46462V6.24316Z"
      fill="currentColor"
    />
  </svg>
);

export const IconStatus = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4167 14.5L12.4167 12.5C12.6667 12.3333 13.0833 12.25 13.3333 12.5C13.5833 12.75 13.5833 13.1667 13.3333 13.4167L11.3333 15.4167C10.8333 15.9167 10.0833 16.1667 9.41668 16.1667C8.75001 16.1667 8.00001 15.9167 7.50001 15.4167C6.41668 14.3333 6.41668 12.6667 7.50001 11.5833L11.1667 7.83332C11.75 7.33332 11.75 6.41666 11.1667 5.83332C10.9167 5.58332 10.5833 5.41666 10.1667 5.41666C9.83334 5.41666 9.41668 5.58332 9.16668 5.83332L6.91668 8.16666C6.66668 8.41666 6.25001 8.41666 6.00001 8.16666C5.75001 7.91666 5.75001 7.49999 6.00001 7.24999L8.33334 4.91666C8.83334 4.41666 9.50001 4.16666 10.1667 4.16666C10.9167 4.16666 11.5833 4.41666 12.1667 4.91666C13.25 5.99999 13.25 7.66666 12.1667 8.74999L8.41668 12.5C7.83334 13 7.83334 13.9167 8.41668 14.5C8.91668 15.0833 9.83334 15.0833 10.4167 14.5Z"
      fill="currentColor"
    />
    <path
      d="M17.25 9.16665H16.6667V8.49998C16.6667 8.16665 16.4167 7.83332 16 7.83332C15.5833 7.83332 15.3333 8.08332 15.3333 8.49998V9.16665H14.6667C14.4167 9.16665 14.1667 9.41665 14.1667 9.74998C14.1667 10.0833 14.4167 10.4167 14.8333 10.4167H15.5V11.0833C15.5 11.4167 15.75 11.6667 16.1667 11.6667C16.5833 11.6667 16.6667 11.3333 16.6667 11V10.4167H17.3333C17.6667 10.4167 18 10.1667 18 9.74998C18 9.33332 17.6667 9.16665 17.25 9.16665Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 9.24999C1.5 9.99999 1.5 11.1667 2.25 11.9167C2.58333 12.25 3.08333 12.5 3.58333 12.5C4.08333 12.5 4.58333 12.3333 4.91667 11.9167C5.66667 11.1667 5.66667 9.99999 4.91667 9.24999C4.16667 8.58332 2.91667 8.58332 2.25 9.24999ZM4 11.0833C3.75 11.25 3.33333 11.25 3.08333 11.0833C2.83333 10.8333 2.83333 10.4167 3.08333 10.1667C3.12799 10.1443 3.16667 10.122 3.20257 10.1013C3.30064 10.0446 3.37799 9.99999 3.5 9.99999C3.66667 9.99999 3.83333 10.0833 3.91667 10.1667C4.25 10.4167 4.25 10.8333 4 11.0833Z"
      fill="currentColor"
    />
  </svg>
);
export const IconTrack = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09435 4.79167C7.427 4.79167 6.82399 5.18971 6.56173 5.80335L6.29241 6.43357C6.12653 6.82173 6.04102 7.23948 6.04102 7.66161V11.25C6.04102 12.0554 6.69393 12.7083 7.49935 12.7083H12.5919C13.3462 12.7083 13.9577 12.0969 13.9577 11.3426V7.66255C13.9577 7.24003 13.872 6.82191 13.7059 6.43347L13.4361 5.80282C13.1737 5.18947 12.5709 4.79167 11.9037 4.79167H8.09435ZM7.29102 8.65742L7.29692 8.62083C7.31223 8.57484 7.35562 8.54167 7.40676 8.54167H12.5919L12.6285 8.54757C12.6745 8.56289 12.7077 8.60628 12.7077 8.65742V11.3426C12.7077 11.4065 12.6559 11.4583 12.5919 11.4583H7.49935C7.38429 11.4583 7.29102 11.3651 7.29102 11.25V8.65742ZM7.40676 7.29167H9.37435V6.04167H8.09435C7.92748 6.04167 7.77672 6.14119 7.71116 6.29457L7.44185 6.92478C7.39081 7.04421 7.35245 7.16832 7.32719 7.29506L7.40676 7.29167ZM12.5919 7.29167H10.6243V6.04167H11.9037C12.0705 6.04167 12.2212 6.14112 12.2868 6.29446L12.5566 6.92509C12.6075 7.04406 12.6458 7.16768 12.6711 7.29393C12.6449 7.29243 12.6185 7.29167 12.5919 7.29167Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.54969 3.29172L4.36427 3.48295C3.02993 4.91085 2.29102 6.78231 2.29102 8.72726C2.29102 10.7674 3.10386 12.7235 4.54973 14.1628L7.49218 17.0957C8.88789 18.4721 11.1291 18.4668 12.5166 17.0857L15.4493 14.1625L15.6344 13.9715C16.9687 12.5436 17.7077 10.6722 17.7077 8.72724C17.7077 6.77579 16.964 4.90127 15.6339 3.48235L15.4232 3.26621C12.4055 0.290266 7.55343 0.301647 4.54969 3.29172ZM14.5455 4.15624L14.5682 4.17871C15.7773 5.38233 16.4577 7.0196 16.4577 8.72724C16.4577 10.3552 15.8392 11.9216 14.7288 13.1099L14.5592 13.2849L11.6344 16.2001C10.7709 17.0597 9.39763 17.0987 8.48763 16.3144L8.36363 16.1995L5.4319 13.2772C4.22138 12.0721 3.54102 10.4349 3.54102 8.72726C3.54102 7.0993 4.15951 5.53284 5.26982 4.34455L5.4395 4.16956C7.94923 1.6714 12.0161 1.66186 14.5455 4.15624Z"
      fill="currentColor"
    />
  </svg>
);
export const IconMessage = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5992 14.3978C10.9478 14.4448 11.304 14.4692 11.666 14.4692C12.1073 14.4692 12.5387 14.432 12.9579 14.3629L15.3899 15.5607C15.5836 15.6561 15.8128 15.6447 15.9962 15.5307C16.1795 15.4166 16.291 15.2159 16.291 15C16.291 14.6276 16.2913 14.2618 16.2916 13.916L16.2916 13.9059C16.2919 13.5631 16.2921 13.2401 16.2921 12.9503C17.9013 11.7433 18.9577 9.90598 18.9577 7.81083C18.9577 4.05916 15.6174 1.1525 11.666 1.1525C7.71461 1.1525 4.37435 4.05916 4.37435 7.81083C4.37435 8.41304 4.46259 8.99552 4.62629 9.54851C2.64142 10.1034 1.18603 11.9253 1.18603 14.0867C1.18603 14.0872 1.18603 14.0876 1.18603 14.0881C1.18622 14.7218 1.31189 15.3274 1.53932 15.8808L1.0542 18.2057C1.01106 18.4124 1.07526 18.627 1.22487 18.7761C1.37449 18.9251 1.58927 18.9886 1.79588 18.9447L4.11516 18.4521C4.66669 18.6778 5.26992 18.8025 5.90186 18.8025C5.92841 18.8025 5.95458 18.8008 5.98027 18.7976C8.43993 18.7553 10.4408 16.8275 10.5992 14.3978ZM11.666 2.4025C8.28075 2.4025 5.62435 4.8675 5.62435 7.81083C5.62435 8.35524 5.71486 8.87993 5.88236 9.37502C5.88747 9.37501 5.89258 9.375 5.89769 9.375C8.16876 9.375 10.0638 10.9814 10.51 13.1193C10.8841 13.1847 11.2705 13.2192 11.666 13.2192C12.099 13.2192 12.5221 13.1766 12.9325 13.0979C13.066 13.0722 13.2043 13.0909 13.3263 13.151L15.0415 13.9957L15.0416 13.8923C15.042 13.4217 15.0423 12.9904 15.0419 12.63C15.0416 12.4228 15.144 12.229 15.3153 12.1124C16.7815 11.1147 17.7077 9.55578 17.7077 7.81083C17.7077 4.8675 15.0513 2.4025 11.666 2.4025ZM9.33655 13.6871C9.33765 13.7028 9.33933 13.7183 9.34159 13.7337C9.35334 13.8498 9.35936 13.9675 9.35936 14.0867C9.35936 15.9982 7.80918 17.5483 5.89769 17.5483C5.87534 17.5483 5.85325 17.5495 5.83151 17.5518C5.33557 17.5419 4.8669 17.4281 4.4438 17.2321C4.32116 17.1753 4.1834 17.1597 4.05118 17.1878L2.4736 17.5229L2.80368 15.941C2.8312 15.8091 2.81537 15.6719 2.75857 15.5498C2.55187 15.1053 2.43603 14.6101 2.43603 14.0867C2.43603 14.0862 2.43603 14.0858 2.43603 14.0854C2.43667 12.3078 3.7771 10.8431 5.50294 10.6473C5.52036 10.6462 5.5378 10.6443 5.55522 10.6417C5.66788 10.6307 5.78212 10.625 5.89769 10.625C7.67476 10.625 9.1385 11.9637 9.33655 13.6871Z"
      fill="#687D96"
    />
  </svg>
);
export const IconSearchData = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.55648 16.4033C5.77464 16.4033 2.70898 13.3377 2.70898 9.55584C2.70898 5.774 5.77464 2.70834 9.55648 2.70834C13.3383 2.70834 16.404 5.774 16.404 9.55584C16.404 11.2217 15.8091 12.7486 14.8203 13.9358L17.1093 16.2247C17.3533 16.4688 17.3533 16.8645 17.1093 17.1086C16.8652 17.3527 16.4695 17.3527 16.2254 17.1086L13.9364 14.8196C12.7493 15.8085 11.2224 16.4033 9.55648 16.4033ZM3.99348 8.93085C4.30424 6.13354 6.67627 3.95834 9.55648 3.95834C12.648 3.95834 15.154 6.46435 15.154 9.55584C15.154 12.6473 12.648 15.1533 9.55648 15.1533C6.67627 15.1533 4.30424 12.9781 3.99348 10.1808H6.01898C6.22793 10.1808 6.42306 10.0764 6.53898 9.90258L7.29817 8.76403L8.68868 11.893C8.78121 12.1012 8.97974 12.2426 9.20678 12.2619C9.43383 12.2813 9.6534 12.1755 9.77982 11.9859L10.9834 10.1808H12.5007C12.8458 10.1808 13.1257 9.90102 13.1257 9.55585C13.1257 9.21067 12.8458 8.93085 12.5007 8.93085H10.649C10.44 8.93085 10.2449 9.03526 10.129 9.20911L9.3698 10.3477L7.97929 7.2187C7.88675 7.01047 7.68823 6.8691 7.46118 6.84977C7.23414 6.83043 7.01457 6.93619 6.88815 7.12578L5.68453 8.93085H3.99348Z"
      fill="currentColor"
    />
  </svg>
);
export const IconNotes = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16667 1.875C2.90066 1.875 1.875 2.90066 1.875 4.16667V15.8333C1.875 17.0993 2.90066 18.125 4.16667 18.125H9.16667C9.51184 18.125 9.79167 17.8452 9.79167 17.5C9.79167 17.1548 9.51184 16.875 9.16667 16.875H4.16667C3.59101 16.875 3.125 16.409 3.125 15.8333V4.16667C3.125 3.59101 3.59101 3.125 4.16667 3.125H13.3333C13.909 3.125 14.375 3.59101 14.375 4.16667V7.5C14.375 7.84518 14.6548 8.125 15 8.125C15.3452 8.125 15.625 7.84518 15.625 7.5V4.16667C15.625 2.90066 14.5993 1.875 13.3333 1.875H4.16667Z"
      fill="currentColor"
    />
    <path
      d="M5.20833 6.66667C5.20833 6.32149 5.48816 6.04167 5.83333 6.04167H11.6667C12.0118 6.04167 12.2917 6.32149 12.2917 6.66667C12.2917 7.01185 12.0118 7.29167 11.6667 7.29167H5.83333C5.48816 7.29167 5.20833 7.01185 5.20833 6.66667Z"
      fill="currentColor"
    />
    <path
      d="M5.83333 9.375C5.48816 9.375 5.20833 9.65482 5.20833 10C5.20833 10.3452 5.48816 10.625 5.83333 10.625H11.6667C12.0118 10.625 12.2917 10.3452 12.2917 10C12.2917 9.65482 12.0118 9.375 11.6667 9.375H5.83333Z"
      fill="currentColor"
    />
    <path
      d="M16.25 11.4583C15.9052 11.4583 15.625 11.7385 15.625 12.0833V15C15.625 15.3452 15.3452 15.625 15 15.625C14.6548 15.625 14.375 15.3452 14.375 15V12.0833C14.375 11.0482 15.2148 10.2083 16.25 10.2083C17.2852 10.2083 18.125 11.0482 18.125 12.0833V15.8333C18.125 17.5593 16.726 18.9583 15 18.9583C13.274 18.9583 11.875 17.5593 11.875 15.8333V13.3333C11.875 12.9882 12.1548 12.7083 12.5 12.7083C12.8452 12.7083 13.125 12.9882 13.125 13.3333V15.8333C13.125 16.869 13.9643 17.7083 15 17.7083C16.0357 17.7083 16.875 16.869 16.875 15.8333V12.0833C16.875 11.7385 16.5948 11.4583 16.25 11.4583Z"
      fill="currentColor"
    />
    <path
      d="M5.20833 13.3333C5.20833 12.9882 5.48816 12.7083 5.83333 12.7083H9.16667C9.51184 12.7083 9.79167 12.9882 9.79167 13.3333C9.79167 13.6785 9.51184 13.9583 9.16667 13.9583H5.83333C5.48816 13.9583 5.20833 13.6785 5.20833 13.3333Z"
      fill="currentColor"
    />
  </svg>
);
export const IconDownload = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2409 16.9999C15.3401 17.0014 15.4386 16.9821 15.5306 16.9431C15.6227 16.9041 15.7064 16.8463 15.7771 16.7729C15.8477 16.6995 15.9038 16.612 15.9421 16.5155C15.9804 16.4191 16.0001 16.3156 16.0001 16.211C16.0001 16.1065 15.9804 16.003 15.9421 15.9066C15.9038 15.8101 15.8477 15.7226 15.7771 15.6492C15.7064 15.5758 15.6227 15.518 15.5306 15.479C15.4386 15.44 15.3401 15.4207 15.2409 15.4222L4.75922 15.4222C4.66003 15.4207 4.56156 15.44 4.46952 15.479C4.37748 15.518 4.29371 15.5758 4.22308 15.6492C4.15245 15.7226 4.09636 15.8101 4.05807 15.9066C4.01979 16.003 4.00008 16.1065 4.00008 16.211C4.00008 16.3156 4.01979 16.4191 4.05807 16.5155C4.09636 16.612 4.15245 16.6995 4.22308 16.7729C4.29371 16.8463 4.37748 16.9041 4.46952 16.9431C4.56156 16.9821 4.66003 17.0014 4.75922 16.9999H15.2409ZM9.9397 14.5574C10.1346 14.5545 10.3208 14.4716 10.4587 14.3263L14.9496 9.59302C15.0214 9.52033 15.0788 9.43326 15.1183 9.33692C15.1578 9.24057 15.1787 9.13689 15.1797 9.03193C15.1807 8.92698 15.1618 8.82287 15.1242 8.72569C15.0866 8.62852 15.0309 8.54024 14.9605 8.46602C14.8901 8.3918 14.8063 8.33314 14.7141 8.29347C14.6219 8.2538 14.5231 8.23391 14.4235 8.23498C14.324 8.23605 14.2256 8.25805 14.1342 8.29969C14.0428 8.34134 13.9602 8.40179 13.8912 8.4775L10.678 11.8641L10.678 3.72424C10.6794 3.6197 10.661 3.51592 10.624 3.41891C10.5871 3.3219 10.5322 3.23361 10.4625 3.15917C10.3929 3.08472 10.3099 3.02561 10.2184 2.98526C10.1269 2.94491 10.0287 2.92413 9.92947 2.92413C9.83028 2.92413 9.73207 2.94491 9.64057 2.98526C9.54906 3.02561 9.46607 3.08472 9.39643 3.15917C9.32679 3.23361 9.27188 3.3219 9.23489 3.41891C9.19791 3.51592 9.17958 3.6197 9.18098 3.72424L9.18098 11.8641L5.96776 8.4775C5.89879 8.40179 5.81618 8.34134 5.72477 8.29969C5.63336 8.25805 5.53498 8.23605 5.4354 8.23498C5.33582 8.23391 5.23704 8.2538 5.14484 8.29347C5.05264 8.33314 4.96888 8.3918 4.89847 8.46602C4.82805 8.54024 4.77239 8.62852 4.73475 8.72569C4.69711 8.82287 4.67824 8.92698 4.67926 9.03193C4.68027 9.13689 4.70115 9.24057 4.74066 9.33692C4.78017 9.43326 4.83752 9.52033 4.90936 9.59302L9.40027 14.3263C9.47098 14.4008 9.55514 14.4597 9.64779 14.4994C9.74044 14.5391 9.8397 14.5588 9.9397 14.5574Z"
      fill="currentColor"
    />
  </svg>
);
export const IconUpload = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75914 15.6334C4.65996 15.6319 4.56149 15.6512 4.46945 15.6902C4.37741 15.7292 4.29364 15.7871 4.223 15.8605C4.15237 15.9339 4.09628 16.0213 4.058 16.1178C4.01971 16.2142 4 16.3177 4 16.4223C4 16.5268 4.01971 16.6303 4.058 16.7268C4.09628 16.8232 4.15237 16.9107 4.223 16.9841C4.29364 17.0575 4.37741 17.1154 4.46945 17.1543C4.56149 17.1933 4.65996 17.2126 4.75914 17.2112H15.2409C15.34 17.2126 15.4385 17.1933 15.5306 17.1543C15.6226 17.1154 15.7064 17.0575 15.777 16.9841C15.8476 16.9107 15.9037 16.8232 15.942 16.7268C15.9803 16.6303 16 16.5268 16 16.4223C16 16.3177 15.9803 16.2142 15.942 16.1178C15.9037 16.0213 15.8476 15.9339 15.777 15.8605C15.7064 15.7871 15.6226 15.7292 15.5306 15.6902C15.4385 15.6512 15.34 15.6319 15.2409 15.6334H4.75914ZM9.98977 3.00004C9.79482 3.00291 9.60863 3.08583 9.47079 3.23116L4.97988 7.96443C4.90805 8.03712 4.85069 8.12419 4.81118 8.22053C4.77167 8.31688 4.7508 8.42056 4.74978 8.52552C4.74877 8.63047 4.76763 8.73458 4.80527 8.83176C4.84291 8.92893 4.89857 9.01721 4.96899 9.09143C5.03941 9.16565 5.12317 9.22431 5.21537 9.26398C5.30756 9.30366 5.40635 9.32354 5.50593 9.32247C5.60551 9.3214 5.70388 9.2994 5.7953 9.25776C5.88671 9.21611 5.96932 9.15566 6.03829 9.07995L9.25151 5.69332V13.8332C9.25011 13.9378 9.26843 14.0415 9.30542 14.1385C9.3424 14.2356 9.39731 14.3238 9.46696 14.3983C9.5366 14.4727 9.61959 14.5318 9.71109 14.5722C9.8026 14.6125 9.9008 14.6333 10 14.6333C10.0992 14.6333 10.1974 14.6125 10.2889 14.5722C10.3804 14.5318 10.4634 14.4727 10.533 14.3983C10.6027 14.3238 10.6576 14.2356 10.6946 14.1385C10.7316 14.0415 10.7499 13.9378 10.7485 13.8332V5.69332L13.9617 9.07995C14.0307 9.15566 14.1133 9.21611 14.2047 9.25776C14.2961 9.2994 14.3945 9.3214 14.4941 9.32247C14.5936 9.32354 14.6924 9.30366 14.7846 9.26398C14.8768 9.22431 14.9606 9.16565 15.031 9.09143C15.1014 9.01721 15.1571 8.92893 15.1947 8.83176C15.2324 8.73458 15.2512 8.63047 15.2502 8.52552C15.2492 8.42056 15.2283 8.31688 15.1888 8.22053C15.1493 8.12419 15.0919 8.03712 15.0201 7.96443L10.5292 3.23116C10.4585 3.15661 10.3743 3.09774 10.2817 3.05805C10.189 3.01835 10.0898 2.99863 9.98977 3.00004Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTimes = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99983 7.3687L4.79983 4.1687L3.66846 5.30007L6.86846 8.50007L3.66846 11.7001L4.79983 12.8314L7.99983 9.63144L11.1998 12.8314L12.3312 11.7001L9.1312 8.50007L12.3312 5.30007L11.1998 4.1687L7.99983 7.3687Z"
      fill="currentColor"
    />
  </svg>
);

export const IconInfo = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.05859 8.56953L2.05 8.35859V4.84062L0.953125 4.62969V3.39219H4.10312V8.35859L5.0875 8.56953V9.8H1.05859V8.56953ZM4.10312 1.57109H2.05V0.03125H4.10312V1.57109Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPen = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 11.0837V14H3.41626L12.0173 5.39897L9.10103 2.48271L0.5 11.0837ZM14.2725 3.14373C14.5758 2.84044 14.5758 2.35051 14.2725 2.04722L12.4528 0.227468C12.1495 -0.0758228 11.6596 -0.0758228 11.3563 0.227468L9.93314 1.6506L12.8494 4.56687L14.2725 3.14373Z"
      fill="currentColor"
    />
  </svg>
);

export const IconDrag = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 5H3V7H5V5Z" fill="currentColor" />
    <path d="M5 9H3V11H5V9Z" fill="currentColor" />
    <path d="M3 13H5V15H3V13Z" fill="currentColor" />
    <path d="M9 5H7V7H9V5Z" fill="currentColor" />
    <path d="M7 9H9V11H7V9Z" fill="currentColor" />
    <path d="M9 13H7V15H9V13Z" fill="currentColor" />
  </svg>
);

export const IconLoadCartRight = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2754 2.0007L14.7578 4.98673L11.2754 7.97276"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.31061 4.98669L14.7578 4.98669"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.65234 12.0623H9.00189"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="11"
      cy="12.0007"
      r="2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="5"
      cy="12.0007"
      r="2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.41043 12.0785H1.64928C1.29069 12.0785 1 11.7878 1 11.4293V4.0007M15 10.5689C15 11.3937 14.3314 12.0623 13.5067 12.0623H13.3867"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconLoadCartRight2 = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.86261 0.999998L13.5938 4.19932L9.86261 7.39864"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.40032 4.19928L13.5938 4.19929"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.98047 11.7803H10.7979"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="11.9969"
      cy="11.7976"
      r="1.2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="4.77812"
      cy="11.7976"
      r="1.2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5787 11.7977H1.69175C1.30755 11.7977 0.996094 11.4862 0.996094 11.102M15.9961 10.1802C15.9961 11.0639 15.2797 11.7802 14.3961 11.7802H13.1961"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconLoadCartLeft = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.72459 1.99998L1.24219 4.98601L4.72459 7.97205"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6894 4.98597L1.24219 4.98598"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.34766 12.0616H6.99811"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      r="2"
      transform="matrix(-1 0 0 1 5 12)"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      r="2"
      transform="matrix(-1 0 0 1 11 12)"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5896 12.0778H14.3507C14.7093 12.0778 15 11.7871 15 11.4285V3.99997M1 10.5682C1 11.393 1.66859 12.0615 2.49333 12.0615H2.61333"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconLoadCaretLeftRight = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.75272 4.17573C4.98703 4.41004 4.98703 4.78994 4.75272 5.02426L3.94852 5.82845H8.9854C9.31677 5.82845 9.5854 6.09708 9.5854 6.42845C9.5854 6.75982 9.31677 7.02845 8.9854 7.02845H3.94858L4.75272 7.83258C4.98703 8.0669 4.98703 8.4468 4.75272 8.68111C4.5184 8.91542 4.1385 8.91542 3.90419 8.68111L2.07576 6.85268C1.84145 6.61837 1.84145 6.23847 2.07576 6.00416L3.90419 4.17573C4.1385 3.94141 4.5184 3.94141 4.75272 4.17573Z"
      fill="currentColor"
    />
    <path
      d="M15.7034 4.17573C15.9377 3.94141 16.3176 3.94141 16.5519 4.17573L18.3803 6.00416C18.6146 6.23847 18.6146 6.61837 18.3803 6.85268L16.5519 8.68111C16.3176 8.91542 15.9377 8.91542 15.7034 8.68111C15.4691 8.4468 15.4691 8.0669 15.7034 7.83258L16.5075 7.02845H11.4707C11.1393 7.02845 10.8707 6.75982 10.8707 6.42845C10.8707 6.09708 11.1393 5.82845 11.4707 5.82845H16.5076L15.7034 5.02426C15.4691 4.78994 15.4691 4.41004 15.7034 4.17573Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.48675 12.4508L5.48439 12.4484C5.09077 12.056 4.55757 11.8355 4.00163 11.8354C3.44455 11.8354 2.90994 12.057 2.51601 12.4509C1.91527 13.0517 1.73559 13.9552 2.06076 14.7402C2.38595 15.5251 3.15194 16.0368 4.00152 16.0368C4.6216 16.0368 5.19708 15.7642 5.58916 15.3118C5.9813 15.7642 6.55685 16.0368 7.17694 16.0368C8.0266 16.0368 8.79254 15.5249 9.11763 14.74C9.14648 14.6703 9.17136 14.5997 9.19231 14.5285H14.5852C14.6062 14.5998 14.6311 14.6705 14.66 14.7402C14.9852 15.5251 15.7512 16.0368 16.6008 16.0368C17.4504 16.0368 18.2164 15.5249 18.5415 14.74C18.8666 13.955 18.6868 13.0515 18.086 12.4508L18.0836 12.4484C17.69 12.056 17.1568 11.8355 16.6009 11.8354C16.0438 11.8354 15.5092 12.057 15.1153 12.4509C14.8651 12.7011 14.688 13.0038 14.5899 13.3285H9.18768C9.08958 13.0037 8.91239 12.701 8.66216 12.4508L8.6598 12.4484C8.26618 12.056 7.73299 11.8355 7.17705 11.8354C6.61996 11.8354 6.08535 12.057 5.69143 12.4509C5.65586 12.4865 5.62176 12.5231 5.58916 12.5607C5.55651 12.5231 5.52237 12.4864 5.48675 12.4508ZM4.83354 14.2808C4.97292 13.9443 4.89574 13.5568 4.63815 13.2992C4.46933 13.1304 4.24032 13.0355 4.00153 13.0354C3.76273 13.0354 3.53371 13.1303 3.36486 13.2991C3.10731 13.5567 3.02999 13.9444 3.1694 14.2809C3.3088 14.6174 3.63721 14.8368 4.00152 14.8368C4.36575 14.8368 4.69414 14.6174 4.83354 14.2808ZM7.81357 13.2992C8.07116 13.5568 8.14833 13.9443 8.00895 14.2808C7.86956 14.6174 7.54116 14.8368 7.17694 14.8368C6.81262 14.8368 6.48422 14.6174 6.34481 14.2809C6.2054 13.9444 6.28272 13.5567 6.54027 13.2991C6.70913 13.1303 6.93815 13.0354 7.17694 13.0354C7.41574 13.0355 7.64474 13.1304 7.81357 13.2992ZM17.4328 14.2808C17.5722 13.9443 17.495 13.5568 17.2374 13.2992C17.0686 13.1304 16.8396 13.0355 16.6008 13.0354C16.362 13.0354 16.133 13.1303 15.9641 13.2991C15.7066 13.5567 15.6292 13.9444 15.7686 14.2809C15.908 14.6174 16.2365 14.8368 16.6008 14.8368C16.965 14.8368 17.2934 14.6174 17.4328 14.2808Z"
      fill="currentColor"
    />
  </svg>
);
export const IconNoteArrowRight = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 4C11 2.895 10.105 2 9 2H4C2.895 2 2 2.895 2 4V11C2 12.105 2.895 13 4 13H6H9C10.105 13 11 12.105 11 11"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2V4C8 4.552 7.552 5 7 5H6C5.448 5 5 4.552 5 4V2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5 10.5L16.5 7.5L13.5 4.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 7.5L9.5 7.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconUploadAlt = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15C7.69479 15 7.44737 14.7526 7.44737 14.4474L7.44737 5.75233L6.24168 6.95802C6.02587 7.17383 5.67596 7.17383 5.46014 6.95802C5.24433 6.7422 5.24433 6.39229 5.46014 6.17648L7.60927 4.02736C7.82508 3.81154 8.17499 3.81154 8.39081 4.02736L10.5399 6.17648C10.7557 6.39229 10.7557 6.7422 10.5399 6.95802C10.3241 7.17383 9.97421 7.17383 9.75839 6.95802L8.55263 5.75226L8.55263 14.4474C8.55263 14.7526 8.30521 15 8 15Z"
      fill="currentColor"
    />
    <path
      d="M13.0146 9.98538C14.1114 9.98538 15 9.0968 15 8L15 2.98538C15 1.88858 14.1114 1 13.0146 1L2.98538 0.999999C1.88858 0.999999 0.999998 1.88858 0.999998 2.98538L0.999998 8C0.999998 9.0968 1.88858 9.98538 2.98538 9.98538L5.1345 9.98538C5.43971 9.98538 5.68713 9.73796 5.68713 9.43275C5.68713 9.12754 5.43971 8.88012 5.1345 8.88012L2.98538 8.88012C2.499 8.88012 2.10526 8.48638 2.10526 8L2.10526 2.98538C2.10526 2.499 2.499 2.10526 2.98538 2.10526L13.0146 2.10526C13.501 2.10526 13.8947 2.499 13.8947 2.98538L13.8947 8C13.8947 8.48638 13.501 8.88012 13.0146 8.88012L10.8655 8.88012C10.5603 8.88012 10.3129 9.12754 10.3129 9.43275C10.3129 9.73796 10.5603 9.98538 10.8655 9.98538L13.0146 9.98538Z"
      fill="currentColor"
    />
  </svg>
);
export const IconMapMarkerLoad = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.80407 3.68627C3.13188 1.49163 5.78716 0.488061 8.23462 1.25583C10.6821 2.0236 12.2883 4.36403 12.1247 6.92386C12.1035 7.25456 11.8183 7.5055 11.4876 7.48435C11.1569 7.4632 10.906 7.17798 10.9271 6.84729C11.0555 4.83914 9.79542 3.00312 7.87544 2.40082C5.95545 1.79851 3.87242 2.5858 2.83078 4.30746C1.78914 6.02911 2.05845 8.23961 3.48298 9.66081L3.48384 9.66167L6.99518 13.179C7.22929 13.4135 7.22897 13.7934 6.99445 14.0275C6.75994 14.2616 6.38004 14.2613 6.14593 14.0268L2.63545 10.5103C0.81983 8.69868 0.476345 5.88079 1.80407 3.68627Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.31635 6.52557C4.31635 5.27998 5.3261 4.27023 6.57169 4.27023C7.81728 4.27023 8.82702 5.27998 8.82702 6.52557C8.82702 7.77115 7.81728 8.7809 6.57169 8.7809C5.3261 8.7809 4.31635 7.77115 4.31635 6.52557ZM6.57169 5.47023C5.98884 5.47023 5.51636 5.94272 5.51636 6.52557C5.51636 7.10841 5.98884 7.5809 6.57169 7.5809C7.15453 7.5809 7.62702 7.10841 7.62702 6.52557C7.62702 5.94272 7.15453 5.47023 6.57169 5.47023Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1986 12.9362C14.1986 13.6358 13.6315 14.2029 12.932 14.2029H9.59865C8.89909 14.2029 8.33198 13.6358 8.33198 12.9362V10.5589C8.33204 10.2079 8.40305 9.86043 8.54073 9.53755L8.72559 9.10511C8.92496 8.63867 9.38367 8.33612 9.89092 8.33624H12.64C13.1467 8.33652 13.6049 8.63879 13.8042 9.10466L13.9895 9.53733C14.1272 9.8602 14.1986 10.2085 14.1986 10.5595V12.9362ZM10.6653 9.53624H9.89037C9.86367 9.53623 9.83953 9.55215 9.82904 9.57671L9.64456 10.0083C9.59965 10.1136 9.56789 10.2237 9.5498 10.3362H10.6653V9.53624ZM9.53198 11.5362L11.2653 11.5362L12.9986 11.5362V12.9362C12.9986 12.9731 12.9688 13.0029 12.932 13.0029H9.59865C9.56183 13.0029 9.53198 12.9731 9.53198 12.9362V11.5362ZM12.9807 10.3362H11.8653V9.53624H12.6397C12.6664 9.53628 12.6906 9.55264 12.7011 9.57716L12.8862 10.0093C12.931 10.1143 12.9626 10.2241 12.9807 10.3362Z"
      fill="currentColor"
    />
  </svg>
);
export const IconReturn = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.36282 1.17574C5.59714 1.41005 5.59714 1.78995 5.36282 2.02426L4.72047 2.66662H7.93333C11.2102 2.66662 13.8667 5.32306 13.8667 8.59995C13.8667 11.8768 11.2102 14.5333 7.93333 14.5333C4.65644 14.5333 2 11.8768 2 8.59995C2 8.26858 2.26863 7.99995 2.6 7.99995C2.93137 7.99995 3.2 8.26858 3.2 8.59995C3.2 11.2141 5.31919 13.3333 7.93333 13.3333C10.5475 13.3333 12.6667 11.2141 12.6667 8.59995C12.6667 5.9858 10.5475 3.86662 7.93333 3.86662H4.72041L5.36282 4.50903C5.59714 4.74334 5.59714 5.12324 5.36282 5.35756C5.12851 5.59187 4.74861 5.59187 4.51429 5.35756L2.89212 3.73539C2.75469 3.62544 2.66667 3.45631 2.66667 3.26662C2.66667 3.0768 2.75481 2.90757 2.8924 2.79763L4.51429 1.17574C4.74861 0.941421 5.12851 0.941421 5.36282 1.17574Z"
      fill="currentColor"
    />
  </svg>
);
export const IconDownloadAlt = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59844 2.6C2.59844 1.82637 3.22481 1.2 3.99844 1.2H5.39844V3.6C5.39844 4.48337 6.11507 5.2 6.99844 5.2H8.99844C9.88181 5.2 10.5984 4.48337 10.5984 3.6V1.2H11.9984C12.7721 1.2 13.3984 1.82637 13.3984 2.6V7.6C13.3984 8.37363 12.7721 9 11.9984 9C11.6671 9 11.3984 9.26863 11.3984 9.6C11.3984 9.93137 11.6671 10.2 11.9984 10.2C13.4348 10.2 14.5984 9.03637 14.5984 7.6V2.6C14.5984 1.16363 13.4348 0 11.9984 0H9.99844H5.99844H3.99844C2.56207 0 1.39844 1.16363 1.39844 2.6V7.6C1.39844 9.03637 2.56207 10.2 3.99844 10.2C4.32981 10.2 4.59844 9.93137 4.59844 9.6C4.59844 9.26863 4.32981 9 3.99844 9C3.22481 9 2.59844 8.37363 2.59844 7.6V2.6ZM6.59844 1.2V3.6C6.59844 3.82063 6.77781 4 6.99844 4H8.99844C9.21907 4 9.39844 3.82063 9.39844 3.6V1.2H6.59844ZM7.57365 15.0237L4.57413 12.0242C4.33981 11.7899 4.33981 11.41 4.57413 11.1757C4.80844 10.9414 5.18834 10.9414 5.42265 11.1757L7.39839 13.1514V7.59995C7.39839 7.26858 7.66702 6.99995 7.99839 6.99995C8.32976 6.99995 8.59839 7.26858 8.59839 7.59995L8.59839 13.1514L10.5741 11.1757C10.8084 10.9414 11.1883 10.9414 11.4227 11.1757C11.657 11.41 11.657 11.7899 11.4227 12.0242L8.42313 15.0237M7.57365 15.0237C7.57511 15.0252 7.57658 15.0267 7.57806 15.0281C7.63467 15.0837 7.69956 15.1258 7.76872 15.1544C7.83946 15.1838 7.91704 15.2 7.99839 15.2C8.16208 15.2 8.31046 15.1344 8.41872 15.0281"
      fill="currentColor"
    />
  </svg>
);
export const IconFlag = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.32034 8.86667H5.13962L6.65425 13.4103C6.75904 13.7246 6.58915 14.0644 6.27479 14.1692C5.96043 14.274 5.62063 14.1041 5.51584 13.7897L3.74357 8.47328C3.73951 8.46222 3.73577 8.451 3.73235 8.43964L2.10041 3.54414C1.6838 2.29236 2.6156 1 3.93504 1H8.13038C9.19841 1 10.0637 1.8653 10.0637 2.93333V3.10339H12.7528C13.8208 3.10339 14.6861 3.96869 14.6861 5.03673V8.93339C14.6861 10.0014 13.8208 10.8667 12.7528 10.8667H8.38081C7.54882 10.8667 6.80935 10.3344 6.54627 9.54446L6.32034 8.86667ZM4.7396 7.66667L3.23901 3.16519C3.08102 2.69033 3.43451 2.2 3.93504 2.2H8.13038C8.53567 2.2 8.86371 2.52804 8.86371 2.93333V6.93333C8.86371 7.33863 8.53567 7.66667 8.13038 7.66667H6.76393C6.75659 7.66653 6.74923 7.66653 6.74186 7.66667H4.7396ZM7.58525 8.86667L7.68469 9.16499C7.78433 9.46428 8.06488 9.66673 8.38081 9.66673H12.7528C13.1581 9.66673 13.4861 9.33869 13.4861 8.93339V5.03673C13.4861 4.63143 13.1581 4.30339 12.7528 4.30339H10.0637V6.93333C10.0637 8.00137 9.19841 8.86667 8.13038 8.86667H7.58525Z"
      fill="currentColor"
    />
  </svg>
);

export const IconDelete = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.53411 0.00976562C4.16052 0.00976562 3.85767 0.312617 3.85767 0.686203C3.85767 1.05979 4.16052 1.36264 4.53411 1.36264H9.94561C10.3192 1.36264 10.622 1.05979 10.622 0.686203C10.622 0.312617 10.3192 0.00976562 9.94561 0.00976562H4.53411ZM0.25 3.60841C0.25 3.23482 0.552851 2.93197 0.926438 2.93197H1.82835H12.6514H13.5533C13.9269 2.93197 14.2297 3.23482 14.2297 3.60841C14.2297 3.98199 13.9269 4.28484 13.5533 4.28484H13.3278V13.5295C13.3278 14.8997 12.2177 16.0098 10.8475 16.0098H3.63219C2.26198 16.0098 1.15192 14.8997 1.15192 13.5295V4.28484H0.926438C0.552851 4.28484 0.25 3.98199 0.25 3.60841ZM2.50479 13.5295V4.28484H11.9749V13.5295C11.9749 14.1525 11.4706 14.6569 10.8475 14.6569H3.63219C3.00916 14.6569 2.50479 14.1525 2.50479 13.5295ZM5.07397 7.30597C5.33814 7.04181 5.76643 7.04181 6.0306 7.30597L7.23887 8.51424L8.44714 7.30597C8.71131 7.04181 9.1396 7.04181 9.40377 7.30597C9.66794 7.57014 9.66794 7.99843 9.40377 8.2626L8.1955 9.47087L9.40377 10.6791C9.66794 10.9433 9.66794 11.3716 9.40377 11.6358C9.1396 11.8999 8.71131 11.8999 8.44714 11.6358L7.23887 10.4275L6.0306 11.6358C5.76643 11.8999 5.33814 11.8999 5.07397 11.6358C4.80981 11.3716 4.80981 10.9433 5.07397 10.6791L6.28224 9.47087L5.07397 8.2626C4.80981 7.99843 4.80981 7.57014 5.07397 7.30597Z"
      fill="#687D96"
    />
  </svg>
);

export const IconCheck = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3803 5.0243L7.01944 12.0973L4 9.07783L5.13137 7.94646L6.91193 9.72702L11.1511 4L12.3803 5.0243Z"
      fill="currentColor"
    />
  </svg>
);

export const IconNotesPen = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.062 12.505C19.734 11.833 20.824 11.832 21.496 12.505V12.505C22.168 13.177 22.168 14.267 21.495 14.939L15.721 20.708C15.534 20.895 15.28 21 15.015 21H13V18.985C13 18.72 13.105 18.466 13.293 18.278L19.062 12.505V12.505Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 9H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 13H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 17H10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.2213 16.22L17.7812 13.78"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 9V6C19 4.895 18.105 4 17 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 3V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 3V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 3V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSendEmail = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83398 7.49998L8.40173 9.47981C9.28208 10.1586 10.5049 10.1746 11.4027 9.51893L14.1673 7.49998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 16.6667H6.66667C4.36548 16.6667 2.5 14.8012 2.5 12.5V7.49999C2.5 5.19881 4.36548 3.33333 6.66667 3.33333H13.3333C15.6345 3.33333 17.5 5.19881 17.5 7.49999V10.8333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8418 14.1667L17.5085 15.8333L15.8418 17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 15.8333H17.5007"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSort = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 5L13 9H7L10 5Z" fill="#BFCCDA" />
    <path d="M10 15L13 11H7L10 15Z" fill="#BFCCDA" />
  </svg>
);
export const IconSortUp = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 5L13 9H7L10 5Z" fill="currentColor" />
    <path d="M10 15L13 11H7L10 15Z" fill="#BFCCDA" />
  </svg>
);
export const IconSortDown = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 5L13 9H7L10 5Z" fill="#BFCCDA" />
    <path d="M10 15L13 11H7L10 15Z" fill="currentColor" />
  </svg>
);

export const Icondots = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="4"
    height="15"
    viewBox="0 0 4 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.66667C0 0.746192 0.746192 0 1.66667 0C2.58714 0 3.33333 0.746192 3.33333 1.66667C3.33333 2.58714 2.58714 3.33333 1.66667 3.33333C0.746192 3.33333 0 2.58714 0 1.66667Z"
      fill="currentColor"
    />
    <path
      d="M0 7.50004C0 6.57957 0.746192 5.83337 1.66667 5.83337C2.58714 5.83337 3.33333 6.57957 3.33333 7.50004C3.33333 8.42052 2.58714 9.16671 1.66667 9.16671C0.746192 9.16671 0 8.42052 0 7.50004Z"
      fill="currentColor"
    />
    <path
      d="M1.66667 11.6667C0.746192 11.6667 0 12.4129 0 13.3334C0 14.2538 0.746192 15 1.66667 15C2.58714 15 3.33333 14.2538 3.33333 13.3334C3.33333 12.4129 2.58714 11.6667 1.66667 11.6667Z"
      fill="currentColor"
    />
  </svg>
);

export const IconInvoiceAlt = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0023 8.99992H17.0031C18.1847 8.916 19.0778 7.89524 19.004 6.71296V3.28353C19.0778 2.10126 18.1847 1.0805 17.0031 0.996582H2.99729C1.81568 1.0805 0.922633 2.10126 0.996453 3.28353V6.71396C0.922648 7.89605 1.81583 8.91652 2.99729 8.99992H4.99812"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3345 17.003L11.6678 18.0035L10.0001 17.003L8.33244 18.0035L6.66574 17.003L4.99805 18.0035V4.99805H15.0022V18.0035L13.3345 17.003Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99902 14.0017H12.0007"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7513 9.0127L9.73141 11.0315L8.75 10.0531"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconDelivery = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 13.7042V6.29566C1.75 5.64024 2.09925 5.03524 2.66667 4.70799L9.08333 1.00374C9.65075 0.676488 10.3493 0.676488 10.9167 1.00374L17.3333 4.70799C17.9008 5.03524 18.25 5.64116 18.25 6.29566V13.7051C18.25 14.3605 17.9008 14.9655 17.3333 15.2927L10.9167 18.997C10.3493 19.3242 9.65075 19.3242 9.08333 18.997L2.66667 15.2927C2.09925 14.9646 1.75 14.3596 1.75 13.7042Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1158 10.7883V7.61297L5.875 2.85547"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.28667 14.5835L4.5 12.9702"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0003 10V19.24"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99609 5.37891L10.0004 9.99982L18.0048 5.37891"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconGate = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 11V8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 3V1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 3H15.185C15.474 3 15.748 3.125 15.938 3.342L17.255 4.851C17.58 5.223 17.58 5.777 17.255 6.149L15.938 7.658C15.748 7.875 15.474 8 15.185 8H4.5C3.948 8 3.5 7.552 3.5 7V4C3.5 3.448 3.948 3 4.5 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4987 16H4.81375C4.52475 16 4.25075 15.875 4.06075 15.658L2.74375 14.149C2.41875 13.777 2.41875 13.223 2.74375 12.851L4.06075 11.342C4.24975 11.125 4.52475 11 4.81375 11H15.4987C16.0507 11 16.4987 11.448 16.4987 12V15C16.4987 15.552 16.0507 16 15.4987 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 19V16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const IconDoumentAlt = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.414 4.414L13.586 1.586C13.211 1.211 12.702 1 12.172 1H5C3.895 1 3 1.895 3 3V17C3 18.105 3.895 19 5 19H15C16.105 19 17 18.105 17 17V5.828C17 5.298 16.789 4.789 16.414 4.414V4.414Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 14.5V14.5C11 13.672 11.672 13 12.5 13V13C13.328 13 14 13.672 14 14.5V14.5C14 15.328 13.328 16 12.5 16V16C11.672 16 11 15.328 11 14.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 7H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 13H8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBundle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8838 5.3615H10.4849C10.1815 5.3615 9.89733 5.21117 9.72683 4.96L8.43892 3.06709C8.26842 2.81684 7.98517 2.6665 7.68175 2.6665H3.58333C2.57042 2.6665 1.75 3.48692 1.75 4.49984V15.4998C1.75 16.5128 2.57042 17.3332 3.58333 17.3332H16.4167C17.4296 17.3332 18.25 16.5128 18.25 15.4998V9.50759"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4167 2.6665C14.3917 2.6665 12.75 4.30825 12.75 6.33317C12.75 8.35809 14.3917 9.99984 16.4167 9.99984C18.4425 9.99984 20.0833 8.35809 20.0833 6.33317C20.0833 4.30825 18.4425 2.6665 16.4167 2.6665"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6839 5.69971L16.099 7.28462L15.1484 6.33312"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconInvoice = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="2" fill="currentColor" />
    <rect x="4" y="5" width="8" height="2" rx="1" fill="#F8F9FD" />
    <rect x="4" y="9" width="6" height="2" rx="1" fill="#F8F9FD" />
  </svg>
);

export const IconClock = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4453 5.55566V10.4446H6.44531"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconInfoCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={`cicon ${className}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 10.25C12.4142 10.25 12.75 10.5858 12.75 11V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V11C11.25 10.5858 11.5858 10.25 12 10.25Z"
      fill="currentColor"
    />
    <path
      d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 12C2.25 6.61478 6.61481 2.25 12 2.25C17.3852 2.25 21.75 6.61478 21.75 12C21.75 17.3852 17.3852 21.75 12 21.75C6.61481 21.75 2.25 17.3852 2.25 12ZM12 3.75C7.44324 3.75 3.75 7.44321 3.75 12C3.75 16.5568 7.44324 20.25 12 20.25C16.5568 20.25 20.25 16.5568 20.25 12C20.25 7.44321 16.5568 3.75 12 3.75Z"
      fill="currentColor"
    />
  </svg>
);

export const IconInfoCircleFilled = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 10L4.00019 10.0194C4.00063 10.0427 4.00189 10.066 4.00397 10.0893L4 10C4 10.0506 4.00376 10.1004 4.01102 10.149C4.01363 10.1659 4.0167 10.1834 4.02024 10.2007C4.02464 10.2227 4.02983 10.2444 4.03572 10.2658C4.0401 10.2815 4.04473 10.2969 4.04974 10.3121C4.05612 10.3318 4.06332 10.3516 4.0711 10.3711C4.0782 10.3888 4.08568 10.4061 4.09367 10.4232C4.10338 10.4439 4.11379 10.4643 4.12488 10.4843C4.1315 10.4964 4.13861 10.5086 4.146 10.5207C4.16172 10.5463 4.17849 10.5711 4.19631 10.5952C4.20072 10.6012 4.20517 10.6071 4.2097 10.6129C4.21507 10.6197 4.21737 10.6226 4.21969 10.6254L4.29289 10.7071L7.29289 13.7071C7.68342 14.0976 8.31658 14.0976 8.70711 13.7071C9.06759 13.3466 9.09532 12.7794 8.7903 12.3871L8.70711 12.2929L7.415 11H16C16.5523 11 17 10.5523 17 10C17 9.48716 16.614 9.06449 16.1166 9.00673L16 9H7.415L8.70711 7.70711C9.06759 7.34662 9.09532 6.77939 8.7903 6.3871L8.70711 6.29289C8.34662 5.93241 7.77939 5.90468 7.3871 6.2097L7.29289 6.29289L4.29289 9.29289L4.21969 9.37455C4.21737 9.37744 4.21507 9.38034 4.21279 9.38325L4.29289 9.29289C4.2575 9.32829 4.22531 9.36567 4.19633 9.40469C4.17849 9.42887 4.16172 9.45372 4.14607 9.47934C4.13861 9.49139 4.1315 9.50361 4.12467 9.51594C4.11379 9.53571 4.10338 9.55611 4.09365 9.5769C4.08568 9.5939 4.0782 9.6112 4.07123 9.62866C4.06332 9.64842 4.05612 9.6682 4.04955 9.68826C4.04473 9.70315 4.0401 9.71854 4.03585 9.73401C4.02983 9.75556 4.02464 9.77725 4.02017 9.79921C4.0167 9.81662 4.01363 9.83405 4.01102 9.85153C4.00811 9.8705 4.00577 9.89015 4.004 9.90997C4.00187 9.93433 4.0006 9.95798 4.00017 9.98164C4.00006 9.9872 4 9.99359 4 10Z"
      fill="white"
    />
    <circle cx="10" cy="10" r="8" fill="currentColor" />
    <path
      d="M8.38281 12.9746L9.20898 12.7988V9.86719L8.29492 9.69141V8.66016H10.9199V12.7988L11.7402 12.9746V14H8.38281V12.9746ZM10.9199 7.14258H9.20898V5.85938H10.9199V7.14258Z"
      fill="white"
    />
  </svg>
);

export const IconClock9 = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5733 2.51708C10.63 2.17958 10.9496 1.95195 11.2871 2.00867C15.0951 2.64855 18.0008 5.95227 18.0008 9.94428C18.0008 14.3937 14.3945 18 9.94509 18C5.95308 18 2.64936 15.0943 2.00947 11.2863C1.95276 10.9488 2.18038 10.6292 2.51789 10.5725C2.85539 10.5158 3.17497 10.7434 3.23168 11.0809C3.7733 14.3041 6.57045 16.7607 9.94509 16.7607C13.71 16.7607 16.7615 13.7092 16.7615 9.94428C16.7615 6.56964 14.305 3.77249 11.0817 3.23087C10.7442 3.17416 10.5166 2.85458 10.5733 2.51708Z"
      fill="currentColor"
    />
    <path
      d="M3.19695 6.77495C3.5177 6.89431 3.68095 7.25108 3.56159 7.57183C3.41402 7.96837 3.30279 8.38072 3.23086 8.80851C3.17411 9.14601 2.85452 9.3736 2.51702 9.31686C2.17952 9.26011 1.95193 8.94051 2.00868 8.60301C2.09373 8.09717 2.22541 7.60893 2.40007 7.13958C2.51943 6.81884 2.87621 6.65558 3.19695 6.77495Z"
      fill="currentColor"
    />
    <path
      d="M5.60046 4.69296C5.86431 4.47499 5.90151 4.08441 5.68355 3.82056C5.46559 3.55671 5.075 3.51951 4.81115 3.73747C4.41982 4.06074 4.06069 4.41988 3.73742 4.8112C3.51945 5.07505 3.55665 5.46564 3.8205 5.6836C4.08435 5.90157 4.47494 5.86437 4.6929 5.60052C4.96617 5.26972 5.26967 4.96622 5.60046 4.69296Z"
      fill="currentColor"
    />
    <path
      d="M9.31682 2.51702C9.37357 2.85452 9.14598 3.17411 8.80848 3.23086C8.38116 3.30271 7.96809 3.41466 7.57216 3.56228C7.25149 3.68184 6.89461 3.51881 6.77505 3.19814C6.65548 2.87747 6.81852 2.52059 7.13919 2.40103C7.60749 2.22643 8.09666 2.09381 8.60298 2.00868C8.94047 1.95193 9.26007 2.17952 9.31682 2.51702Z"
      fill="currentColor"
    />
    <path
      d="M10.9433 5.86932C10.9433 5.52709 10.6658 5.24965 10.3236 5.24965C9.98137 5.24965 9.70394 5.52709 9.70394 5.86932V9.70385H6.69564C6.35341 9.70385 6.07597 9.98128 6.07597 10.3235C6.07597 10.6658 6.35341 10.9432 6.69564 10.9432H10.3236C10.6658 10.9432 10.9433 10.6658 10.9433 10.3235V5.86932Z"
      fill="currentColor"
    />
  </svg>
);

export const IconFilePointer = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25641 2C4.00988 2 3 3.00988 3 4.25641V15.7436C3 16.9901 4.00988 18 5.25641 18H8.53846C8.87833 18 9.15385 17.7245 9.15385 17.3846C9.15385 17.0447 8.87833 16.7692 8.53846 16.7692H5.25641C4.68961 16.7692 4.23077 16.3104 4.23077 15.7436V4.25641C4.23077 3.68961 4.68961 3.23077 5.25641 3.23077H10.3846V5.89744C10.3846 6.69023 11.0277 7.33333 11.8205 7.33333H14.4872V9.17949C14.4872 9.51935 14.7627 9.79487 15.1026 9.79487C15.4424 9.79487 15.7179 9.51935 15.7179 9.17949V6.57682C15.7179 5.97855 15.4799 5.40444 15.0569 4.98147L12.7365 2.66106C12.3135 2.23809 11.7394 2 11.1411 2H5.25641ZM11.6154 3.34724V5.89744C11.6154 6.01049 11.7075 6.10256 11.8205 6.10256H14.3707C14.3229 6.01093 14.261 5.9262 14.1866 5.85176L11.8662 3.53135C11.7918 3.45691 11.707 3.39508 11.6154 3.34724Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5591 10.7007C11.7599 10.6005 12 10.6223 12.1795 10.757L16.2787 13.8339C16.4429 13.9571 16.5316 14.1566 16.5131 14.361C16.4947 14.5655 16.3716 14.7458 16.188 14.8376L14.6667 15.5983L15.4274 17.1196C15.5737 17.4123 15.4551 17.7682 15.1624 17.9145C14.8698 18.0608 14.5139 17.9422 14.3676 17.6496L13.6069 16.1282L12.0855 16.8889C11.9018 16.9807 11.6836 16.9709 11.5089 16.8629C11.3342 16.7548 11.2279 16.564 11.2281 16.3586L11.2313 11.2304C11.2315 11.006 11.3584 10.801 11.5591 10.7007ZM13.6041 14.8048L13.6069 14.8034L13.6096 14.802L14.8011 14.2063L12.4155 12.4157L12.4136 15.4001L13.6041 14.8048Z"
      fill="currentColor"
    />
  </svg>
);

export const IconQuickBook = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47711 15.5229 0 10 0C4.47711 0 0 4.47711 0 10C0 15.5229 4.47711 20 10 20Z"
      fill="currentColor"
    />
    <path
      d="M2.77673 9.99979C2.77673 12.1476 4.51784 13.8887 6.66562 13.8887H7.22118V12.4442H6.66562C5.31784 12.4442 4.22118 11.3476 4.22118 9.99979C4.22118 8.65179 5.31784 7.55535 6.66562 7.55535H8.00073V15.1109C8.00073 15.494 8.15292 15.8614 8.4238 16.1323C8.69469 16.4032 9.06209 16.5553 9.44518 16.5553V6.1109H6.66562C4.51784 6.1109 2.77673 7.85201 2.77673 9.99979ZM13.3343 6.11112H12.7787V7.55557H13.3343C14.6823 7.55557 15.7787 8.65224 15.7787 10C15.7787 11.348 14.6823 12.4445 13.3343 12.4445H11.9994V4.8889C11.9994 4.50581 11.8472 4.13841 11.5763 3.86753C11.3054 3.59664 10.938 3.44446 10.555 3.44446V13.8889H13.3343C15.4821 13.8889 17.2232 12.1478 17.2232 10C17.2232 7.85224 15.4821 6.11112 13.3343 6.11112Z"
      fill="white"
    />
  </svg>
);

export const IconCart = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.95899 3.33331C2.69295 3.33331 1.66663 4.35964 1.66663 5.62567V14.3793C1.66663 15.1849 2.3197 15.838 3.12531 15.838H3.42266C3.68008 16.5665 4.37484 17.0885 5.19152 17.0885C6.0082 17.0885 6.70296 16.5665 6.96038 15.838H13.5464C13.8916 15.838 14.1714 15.5582 14.1714 15.213C14.1714 14.8678 13.8916 14.588 13.5464 14.588H6.96038C6.70297 13.8595 6.0082 13.3375 5.19152 13.3375C4.37484 13.3375 3.68008 13.8595 3.42266 14.588H3.12531C3.01006 14.588 2.91663 14.4946 2.91663 14.3793V11.9705H16.8793C17.4547 11.9705 17.9211 11.504 17.9211 10.9286V5.62567C17.9211 4.35964 16.8948 3.33331 15.6288 3.33331H3.95899ZM16.6711 10.7205H2.91663V5.62567C2.91663 5.04999 3.38331 4.58331 3.95899 4.58331H15.6288C16.2045 4.58331 16.6711 5.04999 16.6711 5.62567V10.7205ZM5.19152 14.5875C4.84605 14.5875 4.566 14.8675 4.566 15.213C4.566 15.5585 4.84605 15.8385 5.19152 15.8385C5.53567 15.8385 5.81491 15.5606 5.81703 15.2169L5.81702 15.213L5.81703 15.2091C5.81491 14.8654 5.53567 14.5875 5.19152 14.5875Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSteering = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.79722 4.35604C10.7091 3.94798 12.6974 4.53704 14.0784 5.92064C14.6515 6.49413 15.0974 7.18319 15.3854 7.9413C15.4505 8.11282 15.4272 8.30541 15.323 8.45643C15.2188 8.60746 15.0471 8.69763 14.8636 8.69763H5.13649C4.95294 8.69763 4.78111 8.60737 4.67694 8.45624C4.57277 8.3051 4.54957 8.11241 4.61489 7.94087C5.31061 6.11382 6.88525 4.76414 8.79722 4.35604ZM9.03023 5.44773C10.5718 5.1187 12.1751 5.59373 13.2886 6.70945C13.5512 6.9722 13.7809 7.26533 13.9726 7.58135H6.02787C6.68549 6.49741 7.76647 5.71747 9.03023 5.44773Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.80798 9.81398C4.65328 9.81398 4.50552 9.87818 4.39996 9.99128C4.2944 10.1044 4.24052 10.2562 4.25117 10.4105C4.4213 12.876 6.1495 14.9562 8.54202 15.5754C8.70919 15.6186 8.88697 15.5821 9.02352 15.4764C9.16006 15.3707 9.23999 15.2077 9.23999 15.035V13.3489C9.23999 11.3966 7.65737 9.81398 5.70511 9.81398H4.80798ZM8.12371 14.2534C6.74652 13.6505 5.74285 12.4094 5.44503 10.9303H5.70511C7.04086 10.9303 8.12371 12.0131 8.12371 13.3489V14.2534Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7442 13.3489C10.7442 11.3966 12.3268 9.81398 14.2791 9.81398H15.1921C15.3468 9.81398 15.4945 9.87818 15.6001 9.99127C15.7056 10.1044 15.7595 10.2562 15.7489 10.4105C15.5784 12.8827 13.8414 14.9667 11.4404 15.5797C11.2734 15.6223 11.0961 15.5854 10.96 15.4797C10.8238 15.374 10.7442 15.2113 10.7442 15.0389V13.3489ZM14.2791 10.9303C12.9433 10.9303 11.8605 12.0131 11.8605 13.3489V14.2602C13.2456 13.6601 14.2561 12.4154 14.555 10.9303H14.2791Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM3.11628 10C3.11628 6.19823 6.19823 3.11628 10 3.11628C13.8018 3.11628 16.8837 6.19823 16.8837 10C16.8837 13.8018 13.8018 16.8837 10 16.8837C6.19823 16.8837 3.11628 13.8018 3.11628 10Z"
      fill="currentColor"
    />
  </svg>
);

export const IconChasis = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg className={`cicon ${className}`} width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.25259 0.175736C3.48691 0.410051 3.48691 0.78995 3.25259 1.02426L2.4484 1.82846H7.48528C7.81665 1.82846 8.08528 2.09709 8.08528 2.42846C8.08528 2.75983 7.81665 3.02846 7.48528 3.02846H2.44846L3.25259 3.83259C3.48691 4.0669 3.48691 4.4468 3.25259 4.68112C3.01828 4.91543 2.63838 4.91543 2.40407 4.68112L0.575638 2.85269C0.341324 2.61838 0.341324 2.23848 0.575638 2.00416L2.40407 0.175736C2.63838 -0.0585786 3.01828 -0.0585786 3.25259 0.175736Z" fill="#687D96" />
    <path d="M14.2033 0.175736C14.4376 -0.0585786 14.8175 -0.0585786 15.0518 0.175736L16.8802 2.00416C17.1145 2.23848 17.1145 2.61838 16.8802 2.85269L15.0518 4.68112C14.8175 4.91543 14.4376 4.91543 14.2033 4.68112C13.9689 4.4468 13.9689 4.0669 14.2033 3.83259L15.0074 3.02846H9.97057C9.6392 3.02846 9.37057 2.75983 9.37057 2.42846C9.37057 2.09709 9.6392 1.82846 9.97057 1.82846H15.0074L14.2033 1.02426C13.9689 0.78995 13.9689 0.410051 14.2033 0.175736Z" fill="#687D96" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.98662 8.45078L3.98426 8.44843C3.59064 8.05597 3.05745 7.83551 2.50151 7.83546C1.94443 7.83541 1.40982 8.05701 1.01589 8.45092C0.415146 9.05172 0.235468 9.95525 0.560642 10.7402C0.885824 11.5251 1.65182 12.0368 2.5014 12.0368C3.12147 12.0368 3.69696 11.7642 4.08904 11.3118C4.48118 11.7643 5.05673 12.0368 5.67681 12.0368C6.52648 12.0368 7.29241 11.5249 7.61751 10.74C7.64636 10.6703 7.67123 10.5997 7.69219 10.5285H13.0851C13.1061 10.5998 13.131 10.6705 13.1599 10.7402C13.4851 11.5251 14.2511 12.0368 15.1006 12.0368C15.9503 12.0368 16.7162 11.5249 17.0413 10.74C17.3664 9.95504 17.1867 9.05153 16.5859 8.45078L16.5835 8.44843C16.1899 8.05597 15.6567 7.83551 15.1008 7.83546C14.5437 7.83541 14.0091 8.05701 13.6151 8.45092C13.365 8.7011 13.1878 9.00376 13.0898 9.3285H7.68756C7.58946 9.0037 7.41226 8.70098 7.16204 8.45078L7.15968 8.44843C6.76606 8.05597 6.23287 7.83551 5.67693 7.83546C5.11984 7.83541 4.58523 8.05701 4.19131 8.45092C4.15573 8.4865 4.12164 8.52313 4.08904 8.56075C4.05639 8.52308 4.02225 8.4864 3.98662 8.45078ZM3.33341 10.2808C3.4728 9.94429 3.39562 9.55681 3.13803 9.29924C2.96921 9.13036 2.7402 9.03548 2.5014 9.03546C2.26261 9.03543 2.03359 9.13029 1.86473 9.29914C1.60719 9.55672 1.52986 9.94439 1.66928 10.2809C1.80868 10.6174 2.13709 10.8368 2.5014 10.8368C2.86562 10.8368 3.19402 10.6174 3.33341 10.2808ZM6.31345 9.29924C6.57103 9.55681 6.64821 9.94429 6.50883 10.2808C6.36944 10.6174 6.04104 10.8368 5.67681 10.8368C5.3125 10.8368 4.9841 10.6174 4.84469 10.2809C4.70528 9.94439 4.7826 9.55672 5.04015 9.29914C5.209 9.13029 5.43803 9.03543 5.67682 9.03546C5.91561 9.03548 6.14462 9.13036 6.31345 9.29924ZM15.9327 10.2808C16.072 9.94429 15.9949 9.55681 15.7373 9.29924C15.5684 9.13036 15.3394 9.03548 15.1006 9.03546C14.8619 9.03543 14.6328 9.13029 14.464 9.29914C14.2064 9.55672 14.1291 9.94439 14.2685 10.2809C14.4079 10.6174 14.7363 10.8368 15.1006 10.8368C15.4649 10.8368 15.7933 10.6174 15.9327 10.2808Z" fill="#687D96" />
  </svg>
)
export const IconRates = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg className={`cicon ${className}`} width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.23353 0.351958C8.87462 0.344293 8.57746 0.629028 8.5698 0.987931C8.56213 1.34683 8.84687 1.644 9.20577 1.65166C9.97006 1.66798 10.7279 1.80257 11.4511 2.05041C11.7907 2.16679 12.1603 1.98584 12.2767 1.64625C12.3931 1.30665 12.2121 0.937009 11.8726 0.820626C11.0225 0.529318 10.1319 0.371143 9.23353 0.351958Z" fill="#687D96" />
    <path d="M6.94643 1.95513C7.29057 1.85296 7.48672 1.49116 7.38456 1.14702C7.28239 0.802877 6.92058 0.60672 6.57645 0.708888C6.15078 0.835258 5.73112 0.995375 5.32122 1.18983C4.91132 1.38429 4.52184 1.60802 4.1547 1.85775C3.85787 2.05966 3.78092 2.46396 3.98283 2.76078C4.18473 3.05761 4.58903 3.13456 4.88585 2.93265C5.19798 2.72034 5.52933 2.52997 5.87841 2.36437C6.2275 2.19876 6.58454 2.06256 6.94643 1.95513Z" fill="#687D96" />
    <path d="M14.2443 2.07063C13.9563 1.85621 13.5491 1.9158 13.3347 2.20371C13.1203 2.49163 13.1799 2.89885 13.4678 3.11327C13.7706 3.33874 14.0589 3.58955 14.3296 3.86522C14.6003 4.14089 14.8458 4.43372 15.0658 4.74052C15.2749 5.03228 15.681 5.09925 15.9728 4.89009C16.2645 4.68094 16.3315 4.27486 16.1223 3.9831C15.8636 3.62223 15.575 3.27807 15.2571 2.95436C14.9392 2.63066 14.6004 2.33583 14.2443 2.07063Z" fill="#687D96" />
    <path d="M3.2216 4.49052C3.4427 4.20771 3.39267 3.7992 3.10985 3.5781C2.82703 3.357 2.41853 3.40703 2.19743 3.68985C1.64401 4.39775 1.20309 5.18762 0.890998 6.03022C0.766312 6.36686 0.938131 6.74084 1.27477 6.86552C1.6114 6.99021 1.98538 6.81839 2.11006 6.48175C2.37559 5.76488 2.75076 5.09279 3.2216 4.49052Z" fill="#687D96" />
    <path d="M17.3291 6.3771C17.2189 6.03545 16.8526 5.84782 16.5109 5.95802C16.1693 6.06822 15.9817 6.43452 16.0919 6.77617C16.3265 7.50373 16.4473 8.26391 16.4498 9.02837C16.4509 9.38735 16.7429 9.67743 17.1019 9.67628C17.4609 9.67513 17.7509 9.38319 17.7498 9.0242C17.7469 8.12566 17.6049 7.23227 17.3291 6.3771Z" fill="#687D96" />
    <path d="M1.6575 8.71601C1.67357 8.35739 1.39587 8.05364 1.03725 8.03757C0.678624 8.0215 0.374874 8.2992 0.358805 8.65782C0.338929 9.1014 0.352906 9.55035 0.402525 10.0013C0.452143 10.4523 0.536112 10.8935 0.651956 11.3222C0.745614 11.6687 1.10247 11.8737 1.44903 11.7801C1.79558 11.6864 2.00059 11.3296 1.90693 10.983C1.80845 10.6186 1.73698 10.2432 1.69473 9.85914C1.65247 9.47509 1.6406 9.09313 1.6575 8.71601Z" fill="#687D96" />
    <path d="M17.3447 11.6744C17.4531 11.3321 17.2635 10.9668 16.9213 10.8584C16.5791 10.75 16.2138 10.9396 16.1054 11.2818C15.9914 11.6417 15.8487 11.9962 15.6768 12.3422C15.5171 12.6637 15.6482 13.0538 15.9697 13.2136C16.2912 13.3733 16.6813 13.2422 16.8411 12.9207C17.0429 12.5144 17.2106 12.0977 17.3447 11.6744Z" fill="#687D96" />
    <path d="M2.83444 13.0654C2.63955 12.764 2.23716 12.6776 1.93569 12.8725C1.63422 13.0673 1.54782 13.4697 1.74271 13.7712C2.23054 14.5258 2.83265 15.2009 3.52674 15.7715C3.80404 15.9995 4.21365 15.9595 4.44163 15.6822C4.66961 15.4049 4.62962 14.9953 4.35232 14.7674C3.7618 14.2819 3.24948 13.7074 2.83444 13.0654Z" fill="#687D96" />
    <path d="M6.31548 15.9261C5.98186 15.7936 5.60396 15.9566 5.47143 16.2902C5.33889 16.6238 5.5019 17.0017 5.83553 17.1343C6.24818 17.2982 6.67699 17.4319 7.11936 17.5326C7.4694 17.6122 7.81774 17.3931 7.8974 17.043C7.97707 16.693 7.75789 16.3447 7.40786 16.265C7.03112 16.1793 6.66631 16.0655 6.31548 15.9261Z" fill="#687D96" />
    <path d="M9.05232 8.17874C9.28442 8.17844 9.5071 8.27052 9.67123 8.43464C9.83535 8.59876 9.92742 8.82144 9.92712 9.05355C9.92651 9.53578 9.5353 9.92632 9.05306 9.92612C8.57083 9.92591 8.17995 9.53504 8.17975 9.0528C8.17954 8.57057 8.57008 8.17936 9.05232 8.17874Z" fill="#687D96" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.56723 8.56021C3.86428 9.26315 3.86428 10.4028 4.56723 11.1058L6.99987 13.5384C7.70282 14.2414 8.84251 14.2414 9.54546 13.5384L13.5393 9.54464C14.2422 8.84169 14.2422 7.702 13.5393 6.99905L11.1066 4.56641C10.4037 3.86346 9.26397 3.86346 8.56103 4.56641L4.56723 8.56021ZM5.48646 10.1866C5.2912 9.99129 5.2912 9.67471 5.48646 9.47945L9.48027 5.48564C9.67553 5.29038 9.99211 5.29038 10.1874 5.48564L12.62 7.91829C12.8153 8.11355 12.8153 8.43014 12.62 8.6254L8.62622 12.6192C8.43096 12.8145 8.11438 12.8145 7.91911 12.6192L5.48646 10.1866Z" fill="#687D96" />
    <path d="M13.9621 18.4596C13.7082 18.2058 13.7082 17.7942 13.9621 17.5404L14.642 16.8605H10.8427C10.4837 16.8605 10.1927 16.5695 10.1927 16.2105C10.1927 15.8515 10.4837 15.5605 10.8427 15.5605H14.642L13.9621 14.8806C13.7082 14.6267 13.7082 14.2152 13.9621 13.9613C14.2159 13.7075 14.6275 13.7075 14.8813 13.9613L16.6708 15.7509C16.7346 15.8147 16.7824 15.8884 16.8141 15.9672C16.8433 16.0394 16.8599 16.1181 16.8611 16.2004L16.8612 16.2105L16.8611 16.2205C16.8587 16.3754 16.8014 16.5295 16.689 16.6512C16.6824 16.6584 16.6756 16.6654 16.6687 16.6722L14.8813 18.4596C14.6275 18.7134 14.2159 18.7134 13.9621 18.4596Z" fill="#687D96" />
  </svg>
)
export const IconDriverRates = ({ className }: React.HTMLAttributes<HTMLDivElement>) => (
  <svg className={`cicon ${className}`} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7887 6.05262V4.36841H11.1045" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6.89551 6.29347L7.97846 5.21052L10.2639 6.89473L12.7903 4.36841" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.2627 9.84215L12.789 9.84224" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.2627 12.3685L12.789 12.3686" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1 9.92627V15.6526C1.00096 16.3965 2.5081 17 4.36843 17C6.22876 17 7.7359 16.3965 7.73686 15.6526V9.92627" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.7359 9.92647C7.7359 10.6704 6.2278 11.2738 4.36747 11.2738C2.50714 11.2738 1 10.6704 1 9.92647C1 9.18157 2.50906 8.5791 4.36843 8.5791C6.2278 8.5791 7.7359 9.18253 7.73686 9.92647" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1 12.7896C1 13.5335 2.50714 14.1369 4.36747 14.1369C6.2278 14.1369 7.7359 13.5335 7.7359 12.7896" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.68359 6.05264V2.68421C2.68359 1.75405 3.43764 1 4.36781 1H14.4731C15.4033 1 16.1573 1.75405 16.1573 2.68421V13.6316C16.1573 14.5618 15.4033 15.3158 14.4731 15.3158H10.2626" stroke="#687D96" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const IconHeartRate = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83329 1.16675C8.19198 1.16675 8.51043 1.39627 8.62386 1.73656L12.8333 14.3649L14.5427 9.23656C14.6562 8.89627 14.9746 8.66675 15.3333 8.66675H18.6666C19.1269 8.66675 19.5 9.03984 19.5 9.50008C19.5 9.96032 19.1269 10.3334 18.6666 10.3334H15.9339L13.6239 17.2636C13.5104 17.6039 13.192 17.8334 12.8333 17.8334C12.4746 17.8334 12.1562 17.6039 12.0427 17.2636L7.83329 4.63531L6.12386 9.7636C6.01043 10.1039 5.69198 10.3334 5.33329 10.3334H1.99996C1.53972 10.3334 1.16663 9.96032 1.16663 9.50008C1.16663 9.03984 1.53972 8.66675 1.99996 8.66675H4.73266L7.04272 1.73656C7.15615 1.39627 7.4746 1.16675 7.83329 1.16675Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSun = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7,0c0.2,0,0.4,0.2,0.4,0.4v1.9c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4V0.4C6.6,0.2,6.8,0,7,0z M7,11.2
 c0.2,0,0.4,0.2,0.4,0.4v1.9C7.4,13.8,7.2,14,7,14c-0.2,0-0.4-0.2-0.4-0.4v-1.9C6.6,11.4,6.8,11.2,7,11.2z M10,7c0,1.7-1.3,3-3,3
 S4,8.7,4,7s1.3-3,3-3S10,5.3,10,7z M4,10c0.2,0.2,0.2,0.5,0,0.6L2.7,12c-0.2,0.2-0.5,0.2-0.6,0c-0.2-0.2-0.2-0.5,0-0.6L3.4,10
 C3.5,9.8,3.8,9.8,4,10z M12,2.7c0.2-0.2,0.2-0.5,0-0.6c-0.2-0.2-0.5-0.2-0.6,0L10,3.4C9.8,3.5,9.8,3.8,10,4c0.2,0.2,0.5,0.2,0.6,0
 L12,2.7z M0,7c0-0.2,0.2-0.4,0.4-0.4h1.9c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4H0.4C0.2,7.4,0,7.2,0,7z M11.7,6.6
 c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h1.9C13.8,7.4,14,7.2,14,7c0-0.2-0.2-0.4-0.4-0.4H11.7z M2,2c0.2-0.2,0.5-0.2,0.6,0
 L4,3.4C4.2,3.5,4.2,3.8,4,4C3.8,4.2,3.5,4.2,3.4,4L2,2.7C1.9,2.5,1.9,2.2,2,2z M10.6,10c-0.2-0.2-0.5-0.2-0.6,0
 c-0.2,0.2-0.2,0.5,0,0.6l1.3,1.3c0.2,0.2,0.5,0.2,0.6,0c0.2-0.2,0.2-0.5,0-0.6L10.6,10z"
      fill="currentColor"
    />
  </svg>
);

export const IconMoon = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7,7c1.4-1.5,1.8-3.7,0.9-5.5c-0.1-0.1,0-0.3,0.1-0.4C8,1,8.2,1,8.3,1c1.1,0.3,2,0.8,2.8,1.6
	c2.4,2.4,2.5,6.2,0.1,8.6c-2.4,2.4-6.3,2.3-8.6-0.1C1.8,10.4,1.3,9.4,1,8.3C1,8.2,1,8,1.1,7.9c0.1-0.1,0.3-0.1,0.4-0.1
	C3.3,8.8,5.5,8.4,7,7z"
      fill="currentColor"
    />
  </svg>
);

export const IconCheckCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.666" cy="10.5" r="9" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4194 8.1585L9.49826 14.9255L5.99414 11.7399L7.33949 10.2601L9.33536 12.0745L13.9142 6.84149L15.4194 8.1585Z"
      fill="white"
    />
  </svg>
);

export const IconCancelCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.666" cy="10.5" r="9" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1919 10.5L14.666 8.02595L13.1401 6.5L10.666 8.97408L8.19196 6.50006L6.66602 8.02601L9.14004 10.5L6.66602 12.9741L8.19196 14.5L10.666 12.026L13.1401 14.5001L14.666 12.9741L12.1919 10.5Z"
      fill="#ffffff"
    />
  </svg>
);

export const IconReset = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.18219 3.63468C8.48984 3.43442 7.75803 3.41281 7.05507 3.57186C6.3521 3.73092 5.70088 4.06545 5.16218 4.54426C4.62347 5.02307 4.21483 5.63054 3.9744 6.30999C3.87614 6.58767 3.57138 6.73311 3.2937 6.63485C3.01602 6.53659 2.87058 6.23183 2.96884 5.95415C3.26938 5.10484 3.78017 4.3455 4.45356 3.74699C5.12694 3.14849 5.94096 2.73031 6.81967 2.53149C7.69838 2.33267 8.61313 2.35969 9.47857 2.61002C10.3413 2.85956 11.1269 3.32288 11.7628 3.95697L13.3329 5.37164V3.4654C13.3329 3.17085 13.5717 2.93206 13.8663 2.93206C14.1608 2.93206 14.3996 3.17085 14.3996 3.4654V6.6654C14.3996 6.95995 14.1608 7.19873 13.8663 7.19873H10.6663C10.3717 7.19873 10.1329 6.95995 10.1329 6.6654C10.1329 6.37084 10.3717 6.13206 10.6663 6.13206H12.5838L11.0264 4.72874C11.0223 4.72492 11.0183 4.72104 11.0144 4.7171C10.5049 4.20734 9.87454 3.83495 9.18219 3.63468Z"
      fill="currentColor"
    />
    <path
      d="M3.50375 9.33206H5.33294C5.62749 9.33206 5.86627 9.09328 5.86627 8.79873C5.86627 8.50418 5.62749 8.26539 5.33294 8.26539H2.13294C1.83839 8.26539 1.59961 8.50418 1.59961 8.79873V11.9987C1.59961 12.2933 1.83839 12.5321 2.13294 12.5321C2.42749 12.5321 2.66628 12.2933 2.66628 11.9987V10.0072L4.23647 11.5072C4.87229 12.1413 5.65796 12.6046 6.52065 12.8541C7.3861 13.1044 8.30085 13.1315 9.17956 12.9326C10.0583 12.7338 10.8723 12.3157 11.5457 11.7171C12.2191 11.1186 12.7298 10.3593 13.0304 9.50999C13.1287 9.23231 12.9832 8.92755 12.7055 8.82929C12.4279 8.73103 12.1231 8.87647 12.0248 9.15415C11.7844 9.8336 11.3758 10.4411 10.8371 10.9199C10.2983 11.3987 9.64713 11.7332 8.94416 11.8923C8.2412 12.0513 7.50939 12.0297 6.81704 11.8295C6.12468 11.6292 5.49434 11.2568 4.98483 10.747C4.98089 10.7431 4.97689 10.7392 4.97283 10.7354L3.50375 9.33206Z"
      fill="currentColor"
    />
  </svg>
);

export const IconDotSeperator = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="4"
    height="5"
    viewBox="0 0 4 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4.39773C3.03551 4.39773 3.875 3.55824 3.875 2.52273C3.875 1.48722 3.03551 0.647727 2 0.647727C0.964489 0.647727 0.125 1.48722 0.125 2.52273C0.125 3.55824 0.964489 4.39773 2 4.39773Z"
      fill="currentColor"
    />
  </svg>
);

export const IconClockSnooze = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10,18.7c-3.3,0-6.4-1.9-7.7-5.1C0.6,9.4,2.6,4.5,6.8,2.7c1.6-0.7,3.3-0.8,5-0.4c0.4,0.1,0.7,0.5,0.6,0.9
	s-0.5,0.7-0.9,0.6c-1.4-0.3-2.8-0.2-4.1,0.3C3.9,5.6,2.3,9.6,3.7,13c1.4,3.5,5.4,5.1,8.9,3.7c3.1-1.3,4.8-4.6,4-7.8
	c-0.1-0.4,0.2-0.8,0.6-0.9c0.4-0.1,0.8,0.2,0.9,0.6c0.9,4-1.2,8-4.9,9.5C12.1,18.5,11.1,18.7,10,18.7z M12.8,13.6
	c-0.1,0-0.3,0-0.4-0.1l-3.1-1.9C9.1,11.5,9,11.2,9,11V7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v3.5l2.7,1.7c0.4,0.2,0.5,0.7,0.2,1
	C13.3,13.5,13.1,13.6,12.8,13.6z M17.6,6.1h-2.5c-0.3,0-0.5-0.2-0.7-0.4s-0.1-0.6,0.1-0.8l1.6-2.2h-1c-0.4,0-0.8-0.3-0.8-0.8
	s0.3-0.8,0.8-0.8h2.5c0.3,0,0.5,0.2,0.7,0.4s0.1,0.6-0.1,0.8l-1.6,2.2h1c0.4,0,0.8,0.3,0.8,0.8S18,6.1,17.6,6.1z"
      fill="currentColor"
    />
  </svg>
);

export const IconTags = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.15582 15.9749C7.8559 16.2753 7.4489 16.4442 7.02441 16.4444C6.59993 16.4446 6.19275 16.2762 5.89251 15.9761L2.46891 12.5543C2.16868 12.2542 2 11.8471 2 11.4227C2 10.9982 2.16868 10.5911 2.46891 10.291L8.24222 4.52036C8.57561 4.18716 9.02766 4 9.49901 4H12.6666C13.6485 4 14.4444 4.79594 14.4444 5.77777V8.94085C14.4444 9.41186 14.2575 9.86362 13.9247 10.1969L8.15582 15.9749Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 6.66666V10.0421C18 10.5136 17.8127 10.9658 17.4793 11.2992L12.4463 16.3323"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconFilterBold = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 4H3L8.6 10.622V15.2L11.4 16.6V10.622L17 4Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTimesThin = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 8.58594L6.00015 4.58594L4.58594 6.00015L8.58594 10.0002L4.58594 14.0002L6.00015 15.4144L10.0002 11.4144L14.0002 15.4144L15.4144 14.0002L11.4144 10.0002L15.4144 6.00015L14.0002 4.58594L10.0002 8.58594Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPlay = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3008 7.13397C11.9674 7.51887 11.9674 8.48112 11.3008 8.86602L5.98694 11.934C5.32027 12.3189 4.48694 11.8377 4.48694 11.0679L4.48694 4.93205C4.48694 4.16225 5.32027 3.68112 5.98694 4.06602L11.3008 7.13397Z"
      fill="currentColor"
    />
  </svg>
);

export const IconPause = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 16 16"
  >
    <path d="M7,4H5v8h2V4z" fill="currentColor" />
    <path d="M11,4H9v8h2V4z" fill="currentColor" />
  </svg>
);

export const IconPending = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.47531 11.2533C6.21022 11.2533 5.99531 11.4682 5.99531 11.7333C5.99531 11.9984 6.21022 12.2133 6.47531 12.2133H8.9642C9.2293 12.2133 9.4442 11.9984 9.4442 11.7333C9.4442 11.4682 9.2293 11.2533 8.9642 11.2533H6.47531Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.62175 1.92001C4.01319 1.92001 3.51953 2.41366 3.51953 3.02223V4.50187C3.51953 4.86474 3.6342 5.21914 3.84724 5.51332L5.647 8.00001L3.84724 10.4867C3.63414 10.7809 3.51953 11.1352 3.51953 11.4981V12.9778C3.51953 13.5863 4.01319 14.08 4.62175 14.08H10.8172C11.4258 14.08 11.9194 13.5863 11.9194 12.9778V11.5205C11.9194 11.1374 11.7916 10.7658 11.5574 10.4635L9.64696 8.00002L11.5581 5.53571C11.7923 5.23349 11.9201 4.86197 11.9201 4.47885V3.02223C11.9201 2.41366 11.4264 1.92001 10.8178 1.92001H4.62175ZM4.47953 3.02223C4.47953 2.94386 4.54338 2.88001 4.62175 2.88001H10.8178C10.8962 2.88001 10.9601 2.94386 10.9601 3.02223V4.47885C10.9601 4.64826 10.9036 4.8131 10.7993 4.94768L8.66023 7.70584C8.52597 7.87897 8.52596 8.12103 8.66022 8.29416L10.7987 11.0517C10.903 11.1863 10.9594 11.3511 10.9594 11.5205V12.9778C10.9594 13.0562 10.8956 13.12 10.8172 13.12H4.62175C4.54338 13.12 4.47953 13.0562 4.47953 12.9778V11.4981C4.47953 11.3372 4.53055 11.1799 4.62482 11.0497L6.62837 8.28143C6.74992 8.1135 6.74992 7.88651 6.62837 7.71858L4.62471 4.95016C4.53044 4.82001 4.47953 4.66286 4.47953 4.50187V3.02223Z"
      fill="currentColor"
    />
  </svg>
);

export const IconWarningCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="8" fill="currentColor" />
    <path
      d="M8.89347 3.27273H6.99716L7.16761 9.38352H8.72727L8.89347 3.27273ZM7.94744 12.1108C8.4929 12.1108 8.96591 11.6548 8.97017 11.0881C8.96591 10.5298 8.4929 10.0739 7.94744 10.0739C7.38494 10.0739 6.92045 10.5298 6.92472 11.0881C6.92045 11.6548 7.38494 12.1108 7.94744 12.1108Z"
      fill="white"
    />
  </svg>
);

export const IconMapMarkerCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="16" height="16" rx="8" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.61765 13C8.61765 13 12.7353 10.2727 12.7353 7.09091C12.7353 6.00593 12.3015 4.96539 11.5293 4.1982C10.7571 3.43101 9.70972 3 8.61765 3C7.52558 3 6.47824 3.43101 5.70603 4.1982C4.93382 4.96539 4.5 6.00593 4.5 7.09091C4.5 10.2727 8.61765 13 8.61765 13ZM10.3824 7.11765C10.3824 8.09227 9.5923 8.88236 8.61768 8.88236C7.64306 8.88236 6.85297 8.09227 6.85297 7.11765C6.85297 6.14303 7.64306 5.35294 8.61768 5.35294C9.5923 5.35294 10.3824 6.14303 10.3824 7.11765Z"
      fill="white"
    />
  </svg>
);

export const IconWeightToolCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="8" fill="currentColor" />
    <path
      d="M3.69292 3V3.45198C3.69292 4.09039 4.21198 4.60974 4.85039 4.60974H10.9672C11.6056 4.60974 12.125 4.09039 12.125 3.45198V3H3.69292ZM6.46005 5.09439V6.47305H9.35747V5.09439H6.46005ZM4.55998 6.12088C4.37305 6.12088 4.21333 6.2543 4.18025 6.43822L3.21171 11.823C3.1014 12.4363 3.57278 13 4.19591 13H11.6215C12.2447 13 12.716 12.4363 12.6057 11.823L11.6372 6.43822C11.604 6.2543 11.4443 6.12088 11.2575 6.12088H4.55998ZM7.9087 6.85842C9.39851 6.85842 10.6104 8.07059 10.6104 9.5605C10.6104 11.0504 9.39849 12.2626 7.9087 12.2626C6.41891 12.2626 5.20701 11.0505 5.20701 9.5605C5.20701 8.07069 6.41891 6.85842 7.9087 6.85842ZM7.9087 7.63082C6.84464 7.63082 5.97914 8.49646 5.97914 9.56038C5.97914 10.6244 6.84466 11.4899 7.9087 11.4899C8.97267 11.4899 9.83827 10.6244 9.83827 9.56038C9.83827 8.49642 8.97263 7.63082 7.9087 7.63082ZM8.67042 8.6146C8.78156 8.6196 8.88978 8.67248 8.96189 8.76835C9.09009 8.93879 9.05587 9.18076 8.88543 9.30886L8.14085 9.86904C8.07127 9.92133 7.98981 9.94662 7.90896 9.94662C7.79182 9.94662 7.67598 9.89354 7.60005 9.79259C7.47195 9.62215 7.50607 9.38 7.67651 9.25179L8.42135 8.69188C8.49592 8.63579 8.58396 8.61071 8.67042 8.6146Z"
      fill="white"
    />
  </svg>
);

export const IconTwoBarsCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="16" height="16" rx="8" fill="currentColor" />
    <rect x="4.5" y="5" width="8" height="2" rx="1" fill="#F8F9FD" />
    <rect x="4.5" y="9" width="6" height="2" rx="1" fill="#F8F9FD" />
  </svg>
);

export const IconSnowFlakeCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="8" fill="currentColor" />
    <path
      d="M13.1979 10.2549L12.5602 9.89049L12.7879 9.79938C13.1068 9.66273 13.2434 9.29832 13.1068 8.97946C12.9701 8.6606 12.6057 8.52394 12.2868 8.66059L11.2392 9.11611L9.14379 7.93177L11.1936 6.74743L12.2413 7.20294C12.3324 7.2485 12.4235 7.2485 12.5146 7.2485C12.7424 7.2485 12.9701 7.11184 13.0612 6.88408C13.1979 6.56522 13.0612 6.20081 12.7424 6.06415L12.5146 5.9275L13.1523 5.56309C13.4256 5.38088 13.5623 5.01647 13.3801 4.74316C13.1979 4.46985 12.8335 4.33319 12.5602 4.5154L11.9224 4.92536L11.968 4.65206C12.0135 4.3332 11.7402 4.01433 11.4214 3.96878C11.1025 3.92323 10.7836 4.19654 10.7381 4.5154L10.647 5.65419L8.55162 6.83853V4.4243L9.46265 3.78658C9.73596 3.60437 9.78151 3.1944 9.5993 2.92109C9.4171 2.64778 9.00713 2.60224 8.73382 2.78444L8.50606 2.92109V2.19227C8.50606 1.87341 8.23276 1.6001 7.9139 1.6001C7.59503 1.6001 7.32172 1.87341 7.32172 2.19227V2.92109L7.09397 2.78444C6.82066 2.60224 6.45624 2.64778 6.22848 2.92109C6.04628 3.1944 6.09183 3.55882 6.36514 3.78658L7.27617 4.4243V6.83853L5.22635 5.65419L5.13525 4.5154C5.0897 4.19654 4.81639 3.92323 4.45198 3.96878C4.13311 4.01433 3.8598 4.28764 3.90535 4.65206L3.9509 4.92536L3.31319 4.56095C3.03988 4.37874 2.62991 4.5154 2.49326 4.78871C2.31105 5.06202 2.40215 5.47198 2.72101 5.60864L3.35874 5.97305L3.13098 6.06415C2.81212 6.20081 2.67546 6.56522 2.81212 6.88408C2.90322 7.11184 3.13098 7.2485 3.35874 7.2485C3.44984 7.2485 3.54094 7.2485 3.63205 7.20294L4.67973 6.74743L6.77511 7.93177L4.72528 9.11611L3.6776 8.66059C3.35873 8.52394 2.99432 8.6606 2.85767 8.97946C2.72101 9.29832 2.85767 9.66273 3.17653 9.79938L3.40429 9.93604L2.76656 10.3005C2.49325 10.4827 2.3566 10.8471 2.53881 11.1204C2.62991 11.3026 2.85767 11.4392 3.08543 11.4392C3.17653 11.4392 3.31318 11.3937 3.40429 11.3481L4.04201 10.9837L3.99646 11.257C3.95091 11.5759 4.22422 11.8948 4.54308 11.9403H4.58863C4.90749 11.9403 5.1808 11.7126 5.1808 11.3937L5.2719 10.2549L7.36727 9.07056V11.4848L6.45624 12.1681C6.18293 12.3503 6.13738 12.7602 6.31959 13.0335C6.45624 13.2158 6.63845 13.3069 6.82066 13.3069C6.95731 13.3069 7.04842 13.2613 7.18507 13.2158L7.41283 13.0791V13.8079C7.41283 14.1268 7.68614 14.4001 8.005 14.4001C8.32386 14.4001 8.59717 14.1268 8.59717 13.8079V13.0791L8.82493 13.2158C8.91603 13.3069 9.05268 13.3069 9.18934 13.3069C9.37154 13.3069 9.55375 13.2158 9.69041 13.0335C9.87261 12.7602 9.82706 12.3958 9.55375 12.1681L8.64272 11.5303V9.11611L10.6925 10.3005L10.7836 11.4392C10.8292 11.7581 11.057 11.9859 11.3758 11.9859H11.4214C11.7402 11.9403 12.0135 11.667 11.968 11.3026L11.9224 11.0293L12.5602 11.3937C12.6513 11.4392 12.7424 11.4848 12.879 11.4848C13.1068 11.4848 13.289 11.3937 13.4256 11.1659C13.5623 10.8015 13.4712 10.4371 13.1979 10.2549Z"
      fill="white"
    />
  </svg>
);

export const IconFireCircle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="16" height="16" rx="8" fill="currentColor" />
    <path
      d="M11.247 6.21619C11.2299 6.49776 11.1934 6.77847 11.136 7.05319C11.055 7.44276 10.7117 7.71062 10.3286 7.71062C10.2729 7.71062 10.2159 7.70504 10.1597 7.69347C9.71271 7.60047 9.42643 7.16333 9.519 6.71719C9.57857 6.43219 9.60814 6.13947 9.60814 5.8459C9.60814 4.1569 8.62286 2.69376 7.197 1.9999C8.18271 6.35976 4.5 6.3739 4.5 10.024C4.5 11.8618 5.67686 13.4209 7.31571 13.9999C7.06671 13.6896 6.91157 13.3013 6.91157 12.8728C6.91157 12.2055 7.31786 11.608 7.63629 11.2412C7.65514 11.536 7.72371 11.8232 7.84157 12.0949C7.90071 12.2282 8.031 12.3083 8.16729 12.3083C8.21486 12.3083 8.26114 12.2989 8.30786 12.2788C8.48657 12.2003 8.56843 11.9925 8.49257 11.8133C8.39014 11.5819 8.33914 11.3363 8.33914 11.0826C8.33914 10.3583 8.76171 9.73176 9.37414 9.43433C8.95071 11.3029 10.5287 11.3089 10.5287 12.8728C10.5287 13.3013 10.3736 13.69 10.1246 13.9999C11.7639 13.4209 12.9403 11.8618 12.9403 10.0245C12.9403 8.46619 11.9923 7.07204 11.247 6.21619Z"
      fill="white"
    />
  </svg>
);

export const IconSettings = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0557 1.05566C16.1296 -0.0182292 17.8704 -0.0182292 18.9443 1.05566C20.0182 2.12956 20.0182 3.87043 18.9443 4.94432C17.8704 6.01822 16.1296 6.01822 15.0557 4.94432C13.9818 3.87043 13.9818 2.12956 15.0557 1.05566ZM16.1163 2.11632C16.6044 1.62822 17.3956 1.62822 17.8837 2.11632C18.3718 2.60443 18.3718 3.39556 17.8837 3.88366C17.3956 4.37177 16.6044 4.37177 16.1163 3.88366C15.6282 3.39556 15.6282 2.60443 16.1163 2.11632Z"
      fill="currentColor"
    />
    <path
      d="M1 2.24999C0.585786 2.24999 0.25 2.58578 0.25 2.99999C0.25 3.41421 0.585786 3.74999 1 3.74999H11C11.4142 3.74999 11.75 3.41421 11.75 2.99999C11.75 2.58578 11.4142 2.24999 11 2.24999H1Z"
      fill="currentColor"
    />
    <path
      d="M9 9.24999C8.58579 9.24999 8.25 9.58578 8.25 9.99999C8.25 10.4142 8.58579 10.75 9 10.75H19C19.4142 10.75 19.75 10.4142 19.75 9.99999C19.75 9.58578 19.4142 9.24999 19 9.24999H9Z"
      fill="currentColor"
    />
    <path
      d="M0.25 17C0.25 16.5858 0.585786 16.25 1 16.25H11C11.4142 16.25 11.75 16.5858 11.75 17C11.75 17.4142 11.4142 17.75 11 17.75H1C0.585786 17.75 0.25 17.4142 0.25 17Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.94432 8.05566C3.87043 6.98177 2.12956 6.98177 1.05566 8.05566C-0.0182292 9.12956 -0.0182292 10.8704 1.05566 11.9443C2.12956 13.0182 3.87043 13.0182 4.94432 11.9443C6.01822 10.8704 6.01822 9.12956 4.94432 8.05566ZM3.88366 9.11632C3.39556 8.62822 2.60443 8.62822 2.11632 9.11632C1.62822 9.60443 1.62822 10.3956 2.11632 10.8837C2.60443 11.3718 3.39556 11.3718 3.88366 10.8837C4.37177 10.3956 4.37177 9.60443 3.88366 9.11632Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0557 15.0557C16.1296 13.9818 17.8704 13.9818 18.9443 15.0557C20.0182 16.1296 20.0182 17.8704 18.9443 18.9443C17.8704 20.0182 16.1296 20.0182 15.0557 18.9443C13.9818 17.8704 13.9818 16.1296 15.0557 15.0557ZM16.1163 16.1163C16.6044 15.6282 17.3956 15.6282 17.8837 16.1163C18.3718 16.6044 18.3718 17.3956 17.8837 17.8837C17.3956 18.3718 16.6044 18.3718 16.1163 17.8837C15.6282 17.3956 15.6282 16.6044 16.1163 16.1163Z"
      fill="currentColor"
    />
  </svg>
);
export const IconCheckCircleDash = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.51 1.22093C10.1473 0.758928 12.8068 1.90849 14.2773 4.14598C15.7477 6.38348 15.7477 9.28086 14.2773 11.5184C12.8068 13.7558 10.1473 14.9054 7.51 14.4434C7.24888 14.3977 7.07428 14.1489 7.12002 13.8878C7.16577 13.6267 7.41453 13.4521 7.67565 13.4978C9.9357 13.8937 12.2149 12.9086 13.475 10.9911C14.7351 9.07365 14.7351 6.59068 13.475 4.67322C12.2149 2.75575 9.9357 1.77061 7.67565 2.16653C7.41453 2.21227 7.16577 2.03767 7.12002 1.77655C7.07428 1.51543 7.24888 1.26667 7.51 1.22093Z"
      fill="currentColor"
    />
    <path
      d="M5.30291 3.14692C5.51885 2.99315 5.56924 2.69344 5.41547 2.4775C5.2617 2.26156 4.96198 2.21116 4.74604 2.36494C4.13443 2.80047 3.59994 3.33521 3.16469 3.94703C3.01102 4.16304 3.06156 4.46273 3.27757 4.6164C3.49359 4.77007 3.79327 4.71954 3.94694 4.50352C4.32016 3.97891 4.77846 3.52038 5.30291 3.14692Z"
      fill="currentColor"
    />
    <path
      d="M2.56443 6.39993C2.78179 6.43938 2.92602 6.64757 2.88657 6.86493C2.77049 7.50452 2.77049 8.15979 2.88657 8.79938C2.92602 9.01674 2.78179 9.22493 2.56443 9.26438C2.34707 9.30383 2.13888 9.1596 2.09943 8.94224C1.96621 8.20818 1.96621 7.45613 2.09943 6.72207C2.13888 6.50471 2.34707 6.36048 2.56443 6.39993Z"
      fill="currentColor"
    />
    <path
      d="M3.27736 11.0481C3.49328 10.8943 3.793 10.9447 3.94679 11.1606C4.32025 11.685 4.77859 12.1433 5.30294 12.5168C5.51887 12.6705 5.56924 12.9703 5.41545 13.1862C5.26165 13.4021 4.96194 13.4525 4.74601 13.2987C4.13467 12.8633 3.60027 12.3289 3.16485 11.7175C3.01106 11.5016 3.06143 11.2019 3.27736 11.0481Z"
      fill="currentColor"
    />
    <path
      d="M11.4593 6.761C11.6338 6.56143 11.6135 6.25819 11.4139 6.0837C11.2143 5.9092 10.9111 5.92952 10.7366 6.12909L8.07139 9.17722L6.61376 7.51546C6.43895 7.31617 6.13567 7.29633 5.93638 7.47114C5.73709 7.64595 5.71725 7.94922 5.89206 8.14851L7.71111 10.2223C7.80234 10.3263 7.934 10.3859 8.07234 10.3858C8.21068 10.3857 8.34225 10.3259 8.43331 10.2217L11.4593 6.761Z"
      fill="currentColor"
    />
  </svg>
);

export const IconHot = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.20491 1.41831C8.75163 1.03891 9.47127 1.01991 10.0372 1.36985C12.6292 2.95941 14.2251 5.76708 14.2647 8.80746C14.2648 8.81276 14.2648 8.81805 14.2647 8.82335C14.2001 12.0371 11.6829 14.665 8.47484 14.8676C5.2668 15.0701 2.43899 12.7799 1.97064 9.59975L1.96937 9.59112L1.96945 9.59111C1.68064 7.34814 2.67369 5.13261 4.54019 3.85571C4.54634 3.8515 4.55258 3.84744 4.55892 3.84353C4.91157 3.62564 5.34539 3.58376 5.73321 3.73018C6.11675 3.87498 6.41235 4.18772 6.53554 4.57821C6.6158 4.80341 6.67718 5.15797 6.73229 5.51496C6.76134 5.70309 6.78773 5.88609 6.81471 6.07314C6.84671 6.29501 6.87954 6.52259 6.91859 6.77123C6.96023 7.0364 7.00426 7.29272 7.05213 7.5265C7.05291 7.52383 7.0537 7.52116 7.05448 7.51848C7.19224 7.04692 7.31141 6.48888 7.4015 5.91896C7.49152 5.34944 7.55113 4.77675 7.57222 4.27719C7.59372 3.76778 7.57349 3.36831 7.52056 3.12835L7.51847 3.1189L7.51857 3.11888C7.38829 2.46593 7.6579 1.79792 8.20491 1.41831ZM9.53274 2.18661C9.29172 2.03738 8.98513 2.04539 8.75223 2.20701C8.52041 2.36788 8.40561 2.65042 8.45925 2.92719C8.53858 3.29122 8.55369 3.78892 8.53136 4.31768C8.50851 4.85902 8.44461 5.46856 8.34972 6.06884C8.2549 6.66872 8.12776 7.26805 7.97596 7.78768C7.82788 8.29457 7.64373 8.7709 7.41674 9.09123C7.3375 9.20305 7.21424 9.27567 7.07803 9.29078C6.94182 9.3059 6.80564 9.26207 6.70382 9.17034C6.56177 9.04237 6.46714 8.87084 6.40077 8.72063C6.33065 8.56192 6.27193 8.37956 6.22137 8.19062C6.12023 7.81265 6.03939 7.36067 5.97021 6.92017C5.93389 6.6889 5.89663 6.43179 5.86162 6.19026C5.83359 5.99691 5.80702 5.81355 5.78353 5.66143C5.72339 5.27187 5.67275 5.01323 5.6299 4.89676C5.62675 4.88818 5.62383 4.8795 5.62117 4.87075C5.5872 4.75909 5.50332 4.66953 5.39413 4.6283C5.2878 4.58816 5.16919 4.59829 5.07136 4.6555C3.51083 5.72904 2.68068 7.58487 2.92103 9.46419C3.31856 12.1481 5.70603 14.0805 8.41434 13.9095C11.1215 13.7385 13.2462 11.523 13.3047 8.81195C13.2667 6.10376 11.8439 3.60357 9.53455 2.18772L9.53274 2.18661Z"
      fill="currentColor"
    />
  </svg>
);

export const IconNoteClip = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.92987 1.59998C1.9303 1.59998 1.12 2.41028 1.12 3.40985V12.7189C1.12 13.7185 1.9303 14.5288 2.92987 14.5288H5.58961C5.8547 14.5288 6.06961 14.3139 6.06961 14.0488C6.06961 13.7837 5.8547 13.5688 5.58961 13.5688H2.92987C2.46049 13.5688 2.08 13.1883 2.08 12.7189V3.40985C2.08 2.94048 2.46049 2.55998 2.92987 2.55998H11.574C12.0434 2.55998 12.4239 2.94048 12.4239 3.40985V5.40465C12.4239 5.66975 12.6388 5.88465 12.9039 5.88465C13.169 5.88465 13.3839 5.66975 13.3839 5.40465V3.40985C13.3839 2.41028 12.5736 1.59998 11.574 1.59998H2.92987Z"
      fill="currentColor"
    />
    <path
      d="M4.25971 4.92465C3.99462 4.92465 3.77971 5.13955 3.77971 5.40465C3.77971 5.66975 3.99462 5.88465 4.25971 5.88465H10.2441C10.5092 5.88465 10.7241 5.66975 10.7241 5.40465C10.7241 5.13955 10.5092 4.92465 10.2441 4.92465H4.25971Z"
      fill="currentColor"
    />
    <path
      d="M3.77971 8.06439C3.77971 7.79929 3.99462 7.58439 4.25971 7.58439H5.58958C5.85468 7.58439 6.06958 7.79929 6.06958 8.06439C6.06958 8.32949 5.85468 8.54439 5.58958 8.54439H4.25971C3.99462 8.54439 3.77971 8.32949 3.77971 8.06439Z"
      fill="currentColor"
    />
    <path
      d="M4.25971 10.2441C3.99462 10.2441 3.77971 10.459 3.77971 10.7241C3.77971 10.9892 3.99462 11.2041 4.25971 11.2041H5.58958C5.85468 11.2041 6.06958 10.9892 6.06958 10.7241C6.06958 10.459 5.85468 10.2441 5.58958 10.2441H4.25971Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.27063 9.86439C7.27063 8.60518 8.29142 7.58439 9.55063 7.58439H12.6C13.8592 7.58439 14.88 8.60518 14.88 9.86439V12.2488C14.88 13.508 13.8592 14.5288 12.6 14.5288H9.55063C8.29142 14.5288 7.27063 13.508 7.27063 12.2488V9.86439ZM11.5927 8.54439H10.5579V9.5792H11.5927V8.54439ZM9.59793 8.54439V9.72673C9.59793 10.1754 9.96168 10.5392 10.4104 10.5392H11.7403C12.189 10.5392 12.5527 10.1754 12.5527 9.72673V8.54439H12.6C13.329 8.54439 13.92 9.13538 13.92 9.86439V12.2488C13.92 12.9778 13.329 13.5688 12.6 13.5688H9.55063C8.82161 13.5688 8.23063 12.9778 8.23063 12.2488V9.86439C8.23063 9.13538 8.82161 8.54439 9.55063 8.54439H9.59793Z"
      fill="currentColor"
    />
  </svg>
);

export const IconReturnCheck = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.43424 1.26058C5.62169 1.44804 5.62169 1.75195 5.43424 1.93941L4.2326 3.14105H7.78952C11.0311 3.14105 13.659 5.7689 13.659 9.01052C13.659 12.2521 11.0311 14.88 7.78952 14.88C4.5479 14.88 1.92004 12.2521 1.92004 9.01052C1.92004 8.74542 2.13495 8.53052 2.40004 8.53052C2.66514 8.53052 2.88004 8.74542 2.88004 9.01052C2.88004 11.7219 5.07809 13.92 7.78952 13.92C10.5009 13.92 12.699 11.7219 12.699 9.01052C12.699 6.29909 10.5009 4.10105 7.78952 4.10105H4.2326L5.43424 5.30269C5.62169 5.49014 5.62169 5.79406 5.43424 5.98151C5.24679 6.16896 4.94287 6.16896 4.75542 5.98151L2.73832 3.96441C2.71791 3.94448 2.69927 3.92274 2.68267 3.89945C2.67408 3.88742 2.66611 3.87507 2.65877 3.86247C2.61742 3.79155 2.59373 3.70906 2.59373 3.62105C2.59373 3.53358 2.61712 3.45158 2.658 3.38095C2.66556 3.36789 2.67378 3.3551 2.68267 3.34265L2.68658 3.33724C2.70217 3.31601 2.71946 3.29611 2.73826 3.27774L4.75542 1.26058C4.94287 1.07313 5.24679 1.07313 5.43424 1.26058Z"
      fill="currentColor"
    />
    <path
      d="M9.63322 8.57587C9.82067 8.38841 9.82067 8.0845 9.63322 7.89704C9.44576 7.70959 9.14185 7.70959 8.95439 7.89704L7.41362 9.43782L6.62259 8.64962C6.4348 8.4625 6.13088 8.46304 5.94377 8.65083C5.75665 8.83862 5.75719 9.14254 5.94498 9.32965L7.07542 10.4561C7.26297 10.6429 7.56642 10.6427 7.75364 10.4554L9.63322 8.57587Z"
      fill="currentColor"
    />
  </svg>
);

export const IconDeliveryClockWise = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 1.12C4.69988 1.12 1.62 4.20063 1.62 8C1.62 11.7994 4.69988 14.88 8.5 14.88C12.3001 14.88 15.38 11.7994 15.38 8C15.38 7.7349 15.1651 7.51999 14.9 7.51999C14.6349 7.51999 14.42 7.7349 14.42 8C14.42 11.2692 11.7698 13.92 8.5 13.92C5.23014 13.92 2.58 11.2692 2.58 8C2.58 4.73076 5.23014 2.08 8.5 2.08C10.4414 2.08 12.1646 3.01455 13.2445 4.45954H12.4334C12.1683 4.45954 11.9534 4.67444 11.9534 4.93954C11.9534 5.20464 12.1683 5.41954 12.4334 5.41954H14.1126C14.1189 5.41966 14.1253 5.41966 14.1316 5.41954H14.4907C14.7558 5.41954 14.9707 5.20464 14.9707 4.93954V2.88232C14.9707 2.61723 14.7558 2.40232 14.4907 2.40232C14.2256 2.40232 14.0107 2.61723 14.0107 2.88232V3.88113C12.7565 2.20578 10.7556 1.12 8.5 1.12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.05668 4.46892C8.71185 4.26998 8.28725 4.2704 7.94258 4.46856L5.71998 5.75204C5.3754 5.95092 5.16252 6.31918 5.16252 6.71767V9.28302C5.16252 9.68158 5.37504 10.0491 5.71998 10.2487L7.94195 11.5318C8.09949 11.6227 8.27368 11.6719 8.4493 11.6798C8.46596 11.6815 8.48287 11.6824 8.5 11.6824C8.51763 11.6824 8.53504 11.6814 8.55218 11.6796C8.72665 11.6713 8.89958 11.6221 9.05605 11.5321L11.2789 10.2485C11.6241 10.0488 11.8361 9.6806 11.8361 9.28302V6.71767C11.8361 6.52029 11.784 6.33051 11.6895 6.16498L11.6867 6.16017L11.6838 6.1551C11.5876 5.99066 11.4493 5.85077 11.2786 5.75204L9.05668 4.46892ZM10.3962 6.351L8.57694 5.30046C8.52963 5.2732 8.46991 5.27286 8.42105 5.30082L6.60311 6.35063L8.49995 7.44574L10.3962 6.351ZM6.12252 7.18168V9.28302C6.12252 9.33839 6.15164 9.38927 6.20027 9.41743L8.01999 10.4683V8.27715L6.12252 7.18168ZM8.97999 10.4675L10.7983 9.41748C10.8467 9.38946 10.8761 9.33799 10.8761 9.28302V7.18242L8.97999 8.2771V10.4675Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAttachment = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6967 6.77856L6.74393 11.6547C5.99821 12.3888 5.99821 13.5799 6.74393 14.314V14.314C7.48964 15.0482 8.6994 15.0482 9.44511 14.314L15.9742 7.88604C17.3419 6.53946 17.3419 4.3565 15.9742 3.00993V3.00993C14.6064 1.66336 12.3892 1.66336 11.0214 3.00993L4.49233 9.43793C2.50256 11.3969 2.50256 14.5718 4.49233 16.5308V16.5308C6.48211 18.4897 9.70693 18.4897 11.6967 16.5308L15.6591 12.6297"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBell = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8315 4.33684C12.3337 4.00033 11.2852 3.66699 10.167 3.66699C9.0522 3.66699 8.00033 4.00033 7.50767 4.34397C6.93586 4.69226 6.43404 5.15087 6.03357 5.69725C5.38843 6.57746 5.03972 7.63994 5.0378 8.73126V12.8649L3.80778 14.3052C3.73529 14.3888 3.68843 14.4916 3.67278 14.6011C3.65713 14.7107 3.67337 14.8224 3.71956 14.923C3.76574 15.0236 3.83991 15.1087 3.93321 15.1683C4.0265 15.2278 4.13497 15.2592 4.24564 15.2587H7.94721C7.98775 15.8223 8.24026 16.3497 8.65392 16.7347C9.06758 17.1196 9.6117 17.3337 10.1768 17.3337C10.7419 17.3337 11.286 17.1196 11.6997 16.7347C12.1133 16.3497 12.3658 15.8223 12.4064 15.2587H16.1079C16.2186 15.2592 16.3271 15.2278 16.4204 15.1683C16.5137 15.1087 16.5878 15.0236 16.634 14.923C16.6802 14.8224 16.6964 14.7107 16.6808 14.6011C16.6652 14.4916 16.6183 14.3888 16.5458 14.3052L15.3158 12.8649V8.73414C15.3145 7.62969 14.9578 6.55498 14.2984 5.66894C13.8979 5.13077 13.3987 4.67956 12.8315 4.33684ZM9.46399 15.9253C9.66108 16.0985 9.91437 16.1943 10.1768 16.1949C10.4392 16.1943 10.6925 16.0985 10.8896 15.9253C11.0867 15.752 11.2142 15.5131 11.2484 15.2529H9.10521C9.1394 15.5131 9.2669 15.752 9.46399 15.9253Z"
      fill="currentColor"
    />
  </svg>
);

export const IconChatFill = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2 12.9333C17.7289 11.8861 18.003 10.7288 18 9.55557V9.11112C17.8978 7.25837 17.1157 5.50843 15.8037 4.19634C14.4916 2.88426 12.7416 2.10224 10.8889 2.00003H10.4444C9.27122 1.99697 8.11387 2.27107 7.06666 2.80002C5.81178 3.42719 4.75629 4.39135 4.01841 5.58451C3.28054 6.77766 2.88943 8.15269 2.88889 9.55557C2.88583 10.7288 3.15994 11.8861 3.68889 12.9333L2 18L7.06666 16.3111C8.11387 16.8401 9.27122 17.1142 10.4444 17.1111C11.8473 17.1106 13.2223 16.7195 14.4155 15.9816C15.6086 15.2437 16.5728 14.1882 17.2 12.9333ZM7 8H14V9H7V8ZM7 11H12V12H7V11Z"
      fill="currentColor"
    />
  </svg>
);

export const IconLink = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.927 0.135118C11.4909 -0.241924 9.9632 0.183156 8.92826 1.24742L5.89544 4.28024C5.12278 5.05243 4.68867 6.10002 4.68867 7.1924C4.68867 8.23979 5.08777 9.24602 5.80172 10.0078C5.82683 10.0474 5.85658 10.0844 5.89062 10.1177C6.2237 10.4445 6.61044 10.7116 7.03396 10.9074C7.34233 11.0499 7.70789 10.9155 7.85045 10.6071C7.993 10.2987 7.85858 9.93318 7.5502 9.79062C7.28891 9.66984 7.04768 9.51017 6.83464 9.31723C6.81412 9.28786 6.79093 9.26014 6.76523 9.23446C6.22339 8.69301 5.91896 7.9584 5.91896 7.1924C5.91896 6.42639 6.22354 5.69164 6.76538 5.15018L9.80141 2.11426L9.80789 2.10757C10.5337 1.35941 11.6064 1.06037 12.6146 1.32508C13.6228 1.58978 14.4102 2.37718 14.6749 3.3854C14.9396 4.39363 14.6405 5.46622 13.8924 6.19206L12.4663 7.61817C12.226 7.85839 12.226 8.24788 12.4663 8.48811C12.7065 8.72834 13.096 8.72834 13.3362 8.48811L14.7526 7.07176C15.8168 6.03682 16.2419 4.50908 15.8649 3.07298C15.4874 1.63533 14.3647 0.51257 12.927 0.135118Z"
      fill="currentColor"
    />
    <path
      d="M8.88226 5.17612C8.57397 5.03337 8.20834 5.16757 8.06559 5.47586C7.92284 5.78415 8.05703 6.14979 8.36532 6.29254C8.66021 6.42908 8.92952 6.61512 9.16159 6.84258C9.70223 7.38385 10.0059 8.11762 10.0059 8.88272C10.0059 9.64872 9.70135 10.3835 9.15951 10.9249L6.12701 13.9574C4.99406 15.0533 3.19127 15.0386 2.07632 13.9237C0.961379 12.8087 0.946697 11.006 2.04255 9.87302L3.45862 8.45695C3.69885 8.21672 3.69885 7.82723 3.45862 7.58701C3.21839 7.34678 2.82891 7.34678 2.58868 7.58701L1.16911 9.00648L1.16262 9.01316C-0.404416 10.6284 -0.384933 13.2023 1.20638 14.7936C2.79768 16.3849 5.37168 16.4045 6.9869 14.8374L10.0295 11.7949C10.8021 11.0227 11.2362 9.97509 11.2362 8.88272C11.2362 7.79027 10.8021 6.74259 10.0293 5.97038L10.0255 5.96662C9.69247 5.63961 9.30578 5.37223 8.88226 5.17612Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSaveOutline = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00037 7.40002C6.59512 7.40002 5.45593 8.53921 5.45593 9.94446C5.45593 11.3497 6.59512 12.4889 8.00037 12.4889C9.40563 12.4889 10.5448 11.3497 10.5448 9.94446C10.5448 8.53921 9.40563 7.40002 8.00037 7.40002ZM6.65593 9.94446C6.65593 9.20195 7.25786 8.60002 8.00037 8.60002C8.74288 8.60002 9.34481 9.20195 9.34481 9.94446C9.34481 10.687 8.74288 11.2889 8.00037 11.2889C7.25786 11.2889 6.65593 10.687 6.65593 9.94446Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2453 0.400024H2.55603C1.98151 0.400024 1.43081 0.629395 1.02613 1.03711C0.621433 1.44484 0.396243 1.99729 0.400448 2.5717L0.48138 13.4606C0.490031 14.6448 1.45279 15.6002 2.63708 15.6L13.4448 15.6C14.0164 15.6 14.5648 15.3732 14.9692 14.9688C15.3736 14.5644 15.6004 14.016 15.6004 13.4444V4.75492C15.6002 4.18335 15.373 3.63523 14.9689 3.23108L12.7693 1.03154C12.3652 0.627188 11.817 0.400024 11.2453 0.400024ZM2.55603 1.60002C2.30139 1.60002 2.05725 1.70169 1.87782 1.88246C1.69843 2.0632 1.59857 2.30809 1.60042 2.56278L1.68135 13.4516C1.68516 13.9765 2.11183 14.4001 2.63675 14.4H13.4448C13.6985 14.4 13.9415 14.2993 14.1206 14.1202C14.2997 13.9411 14.4004 13.6981 14.4004 13.4444V4.75533C14.4003 4.50195 14.2995 4.25879 14.1204 4.07962L11.9208 1.88006C11.8566 1.81583 11.7842 1.76165 11.706 1.71859V4.11113C11.7057 4.87182 11.0891 5.48863 10.3285 5.4889L5.66159 5.4889C4.9009 5.48863 4.28409 4.87203 4.28381 4.11134V1.60002H2.55603ZM10.506 4.11091V1.60002H5.48381V4.11091C5.48385 4.2092 5.56352 4.28887 5.6618 4.2889H10.328C10.4263 4.28887 10.506 4.2092 10.506 4.11091Z"
      fill="currentColor"
    />
  </svg>
);

export const IconLoads = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.7 4.1556C9.7 3.82423 9.43137 3.5556 9.1 3.5556C8.76863 3.5556 8.5 3.82423 8.5 4.1556V8.6328L7.54926 7.68163C7.315 7.44726 6.9351 7.44718 6.70073 7.68144C6.46637 7.9157 6.46628 8.2956 6.70054 8.52997L8.67153 10.5018C8.78042 10.6129 8.93216 10.6818 9.1 10.6818C9.26695 10.6818 9.41798 10.6136 9.52675 10.5036L11.4995 8.52997C11.7337 8.2956 11.7337 7.9157 11.4993 7.68144C11.2649 7.44718 10.885 7.44726 10.6508 7.68163L9.7 8.63282V4.1556Z"
      fill="currentColor"
    />
    <path
      d="M4.65554 10.4693C4.98691 10.4693 5.25554 10.7379 5.25554 11.0693C5.25554 11.4341 5.4005 11.784 5.65852 12.0419C5.91654 12.2998 6.26646 12.4446 6.63127 12.4444H11.5693C12.3288 12.4444 12.9444 11.8288 12.9444 11.0693C12.9444 10.7379 13.2131 10.4693 13.5444 10.4693C13.8758 10.4693 14.1444 10.7379 14.1444 11.0693C14.1444 12.4915 12.9915 13.6444 11.5693 13.6444H6.63181C5.94875 13.6446 5.2933 13.3735 4.81018 12.8906C4.32701 12.4076 4.05554 11.7525 4.05554 11.0693C4.05554 10.7379 4.32417 10.4693 4.65554 10.4693Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.1 0C3.00721 0 0.5 2.50721 0.5 5.6V11.6C0.5 14.6928 3.00721 17.2 6.1 17.2H12.1C15.1928 17.2 17.7 14.6928 17.7 11.6V5.6C17.7 2.50721 15.1928 0 12.1 0H6.1ZM1.7 5.6C1.7 3.16995 3.66995 1.2 6.1 1.2H12.1C14.5301 1.2 16.5 3.16995 16.5 5.6V11.6C16.5 14.0301 14.5301 16 12.1 16H6.1C3.66995 16 1.7 14.0301 1.7 11.6V5.6Z"
      fill="currentColor"
    />
  </svg>
);

export const IconBookMark = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.05554 6.6C4.05554 5.16406 5.2196 4 6.65554 4H11.5444C12.9804 4 14.1444 5.16406 14.1444 6.6V10.6C14.1444 12.0359 12.9804 13.2 11.5444 13.2H6.65554C5.2196 13.2 4.05554 12.0359 4.05554 10.6V6.6ZM6.65554 5.2H7.16663V7.71111C7.16663 7.90398 7.25934 8.08509 7.4158 8.19786C7.57226 8.31063 7.77339 8.34131 7.95636 8.28032L9.09996 7.89912L10.2436 8.28032C10.4265 8.34131 10.6277 8.31063 10.7841 8.19786C10.9406 8.08509 11.0333 7.90398 11.0333 7.71111V5.2H11.5444C12.3176 5.2 12.9444 5.8268 12.9444 6.6V10.6C12.9444 11.3732 12.3176 12 11.5444 12H6.65554C5.88234 12 5.25554 11.3732 5.25554 10.6V6.6C5.25554 5.8268 5.88234 5.2 6.65554 5.2ZM9.83329 6.87866V5.2H8.36663V6.87866L8.91022 6.69746C9.03338 6.6564 9.16654 6.6564 9.2897 6.69746L9.83329 6.87866Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.21111 0C2.16152 0 0.5 1.66152 0.5 3.71111V13.4889C0.5 15.5385 2.16152 17.2 4.21111 17.2H13.9889C16.0385 17.2 17.7 15.5385 17.7 13.4889V3.71111C17.7 1.66152 16.0385 0 13.9889 0H4.21111ZM1.7 3.71111C1.7 2.32426 2.82426 1.2 4.21111 1.2H13.9889C15.3757 1.2 16.5 2.32426 16.5 3.71111V13.4889C16.5 14.8757 15.3757 16 13.9889 16H4.21111C2.82426 16 1.7 14.8757 1.7 13.4889V3.71111Z"
      fill="currentColor"
    />
  </svg>
);

export const IconUsers = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="19"
    height="14"
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.63531 1.05279C5.00289 -0.41999 7.34032 -0.269287 8.7304 1.01873L8.74145 1.02914L8.75199 1.03954C10.1645 2.45496 10.187 4.71581 8.73326 6.06574C7.34386 7.35589 5.08911 7.50843 3.72031 6.03433C2.42309 4.63732 2.29565 2.4955 3.63531 1.05279ZM4.51466 1.86933C5.35384 0.965605 6.91784 0.981108 7.90856 1.8932C8.86534 2.8581 8.83949 4.32952 7.91671 5.18638C6.92611 6.10623 5.44086 6.1237 4.59966 5.21779C3.68688 4.2348 3.64432 2.80663 4.51466 1.86933Z"
      fill="currentColor"
    />
    <path
      d="M1.7 12.511C1.7 10.9724 2.96137 9.71105 4.5 9.71105H7.9C9.43863 9.71105 10.7 10.9724 10.7 12.511C10.7 12.8424 10.9686 13.111 11.3 13.111C11.6314 13.111 11.9 12.8424 11.9 12.511C11.9 10.3097 10.1014 8.51105 7.9 8.51105H4.5C2.29863 8.51105 0.5 10.3097 0.5 12.511C0.5 12.8424 0.768629 13.111 1.1 13.111C1.43137 13.111 1.7 12.8424 1.7 12.511Z"
      fill="currentColor"
    />
    <path
      d="M12.4 8.26101C12.4 7.92964 12.6687 7.66101 13 7.66101H15.55C17.3264 7.66101 18.7 9.03464 18.7 10.811C18.7 11.1424 18.4314 11.411 18.1 11.411C17.7687 11.411 17.5 11.1424 17.5 10.811C17.5 9.69738 16.6637 8.86101 15.55 8.86101H13C12.6687 8.86101 12.4 8.59238 12.4 8.26101Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4169 1.62067C13.428 0.622479 15.1405 0.654738 16.2022 1.6064C16.2075 1.61109 16.2128 1.61589 16.218 1.6208C16.2231 1.62569 16.2282 1.63064 16.2331 1.63567C17.3005 2.70723 17.333 4.46312 16.2064 5.47705C15.1729 6.40717 13.4233 6.58723 12.384 5.43246C11.457 4.40249 11.2751 2.66122 12.4169 1.62067ZM13.2543 2.48034C13.7702 1.96439 14.7567 1.93126 15.3919 2.4916C16.0091 3.12056 15.9723 4.07331 15.4036 4.5851C14.7371 5.18499 13.7667 5.17493 13.276 4.6297C12.6761 3.96316 12.6861 2.99276 13.2314 2.50205C13.2392 2.49502 13.2468 2.48778 13.2543 2.48034Z"
      fill="currentColor"
    />
  </svg>
);

export const IconHomeCheck = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3689 1.63543C9.62259 1.05486 8.57741 1.05486 7.83107 1.63543L2.49773 5.78388C1.99462 6.17525 1.70025 6.77689 1.7 7.4143V13.9333C1.7 15.0747 2.62528 16 3.76667 16H14.4333C15.5747 16 16.5 15.0747 16.5 13.9333V7.41448C16.4997 6.77708 16.2054 6.17527 15.7023 5.78389L10.3689 1.63543ZM11.1057 0.688252C9.92602 -0.229417 8.27398 -0.229417 7.09429 0.688252L1.76095 4.8367C0.965629 5.45538 0.500308 6.40649 0.5 7.41411V13.9333C0.5 15.7375 1.96254 17.2 3.76667 17.2H14.4333C16.2375 17.2 17.7 15.7375 17.7 13.9333V7.4143C17.6997 6.40667 17.2344 5.45539 16.4391 4.83671L11.1057 0.688252Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3021 8.62024C11.5364 8.85456 11.5364 9.23446 11.3021 9.46877L9.07983 11.691C8.96731 11.8035 8.8147 11.8667 8.65557 11.8667C8.49644 11.8667 8.34382 11.8035 8.2313 11.691L6.89797 10.3577C6.66366 10.1233 6.66366 9.74345 6.89797 9.50913C7.13228 9.27482 7.51218 9.27482 7.7465 9.50913L8.65557 10.4182L10.4535 8.62024C10.6878 8.38593 11.0677 8.38593 11.3021 8.62024Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSendMessage = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.84509 1.44733C0.0224804 1.61062 -0.637968 3.88161 0.727431 5.04124L5.5843 9.16757L6.73266 15.4423C7.05359 17.2049 9.35133 17.7669 10.4037 16.2706L19.5499 3.25481C20.5499 1.83258 19.4213 -0.122326 17.6896 0.0325928L1.84509 1.44733ZM1.69848 3.89797C1.31084 3.5688 1.52887 2.98186 1.97871 2.94137L17.2333 1.5793L6.35908 7.85755L1.69848 3.89797ZM7.10738 9.15757L8.20828 15.173C8.29905 15.6715 8.9162 15.7781 9.17655 15.408L17.9797 2.88045L7.10738 9.15757Z"
      fill="currentColor"
    />
  </svg>
);

export const IconUserBox = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.37816 2.51556C8.01121 0.744003 10.8 0.92803 12.4553 2.47285L12.4688 2.48564L12.4822 2.49894C14.1626 4.19531 14.1905 6.90443 12.4588 8.5242C10.8044 10.0717 8.11307 10.258 6.4785 8.4848C4.93591 6.81138 4.7833 4.24568 6.37816 2.51556ZM7.48106 3.53223C8.45277 2.4781 10.2688 2.49151 11.424 3.56217C12.5397 4.69624 12.5076 6.42462 11.4342 7.42873C10.2791 8.50916 8.5556 8.52497 7.5814 7.46813C6.5152 6.31151 6.46714 4.63215 7.48106 3.53223Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3921 12.6777C10.2697 12.9067 10.2021 13.1656 10.201 13.4344V15.8867H10.951L10.201 15.8882C10.2022 16.4721 10.5189 17.0105 11.0284 17.2958L13.239 18.5392C13.7308 18.816 14.3318 18.8158 14.8236 18.539L17.0358 17.2952C17.5444 17.01 17.8604 16.4732 17.863 15.8899L17.863 13.4372L17.863 13.4358C17.8618 12.8514 17.5452 12.3132 17.0351 12.0283L17.0336 12.0274L14.8241 10.7847L14.8226 10.7838C14.3314 10.509 13.7327 10.509 13.2414 10.7838L11.0284 12.0286C10.7933 12.1603 10.5994 12.3457 10.4585 12.5647C10.4431 12.5864 10.4286 12.6091 10.4153 12.6328C10.407 12.6476 10.3993 12.6626 10.3921 12.6777ZM11.701 14.2145L13.2788 15.1001V16.8406L11.7622 15.9876L11.7607 15.9867C11.7241 15.9662 11.7013 15.9276 11.701 15.8856V14.2145ZM14.7788 15.1003V16.8434L16.302 15.9869C16.3392 15.9661 16.3625 15.9269 16.363 15.8843V14.2111L14.7788 15.1003ZM15.5797 12.9307L14.0902 12.0929C14.0543 12.0729 14.0097 12.0729 13.9738 12.0929L12.4813 12.9324L14.029 13.801L15.5797 12.9307Z"
      fill="currentColor"
    />
    <path
      d="M5.99621 12.9678C4.20156 12.9678 2.7467 14.4227 2.7467 16.2173C2.7467 16.6315 2.41092 16.9673 1.9967 16.9673C1.58249 16.9673 1.2467 16.6315 1.2467 16.2173C1.2467 13.5942 3.37313 11.4678 5.99621 11.4678H8.29193C8.70614 11.4678 9.04193 11.8036 9.04193 12.2178C9.04193 12.632 8.70614 12.9678 8.29193 12.9678H5.99621Z"
      fill="currentColor"
    />
  </svg>
);

export const IconLock = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.1501 5.33343C7.1501 3.85158 8.35158 2.6501 9.83343 2.6501C11.3153 2.6501 12.5168 3.85158 12.5168 5.33343V7.18344H7.1501V5.33343ZM5.8501 7.18344V5.33343C5.8501 3.13361 7.63361 1.3501 9.83343 1.3501C12.0332 1.3501 13.8168 3.13361 13.8168 5.33343V7.18344H14.0001C15.2799 7.18344 16.3168 8.22029 16.3168 9.50011V15.3334C16.3168 16.6133 15.2799 17.6501 14.0001 17.6501H5.66676C4.38695 17.6501 3.3501 16.6133 3.3501 15.3334V9.50011C3.3501 8.22029 4.38695 7.18344 5.66676 7.18344H5.8501ZM4.6501 9.50011C4.6501 8.93826 5.10492 8.48344 5.66676 8.48344H14.0001C14.5619 8.48344 15.0168 8.93826 15.0168 9.50011V15.3334C15.0168 15.8953 14.5619 16.3501 14.0001 16.3501H5.66676C5.10492 16.3501 4.6501 15.8953 4.6501 15.3334V9.50011Z"
      fill="currentColor"
    />
  </svg>
);

export const IconUsersGroup = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2186 4.5C14.7863 4.5 15.3308 4.7255 15.7322 5.1269C16.5682 5.96287 16.5683 7.31832 15.7323 8.15428C14.8963 8.99025 13.5409 8.99025 12.705 8.15428C11.869 7.31832 11.869 5.96295 12.705 5.12698C13.1064 4.72553 13.6509 4.5 14.2186 4.5ZM13.4121 5.83408C13.626 5.62017 13.9161 5.5 14.2186 5.5C14.5211 5.5 14.8113 5.62017 15.0252 5.83408C15.4706 6.27953 15.4706 7.00173 15.0252 7.44718C14.5797 7.89262 13.8575 7.89262 13.4121 7.44718C12.9666 7.00173 12.9666 6.27953 13.4121 5.83408Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.48629 9.34567C9.32226 8.50971 10.6776 8.50971 11.5136 9.34567C12.1258 9.95789 12.309 10.8786 11.9776 11.6785C11.6463 12.4784 10.8657 13 9.99995 13C9.13414 13 8.35359 12.4784 8.02226 11.6785C7.69093 10.8786 7.87408 9.95789 8.48629 9.34567ZM9.1934 10.0528C9.63884 9.60734 10.361 9.60734 10.8065 10.0528C11.1327 10.379 11.2303 10.8696 11.0538 11.2958C10.8772 11.7221 10.4613 12 9.99995 12C9.5386 12 9.12269 11.7221 8.94614 11.2958C8.76959 10.8696 8.86718 10.379 9.1934 10.0528Z"
      fill="currentColor"
    />
    <path
      d="M17.1975 12.1616C16.4768 11.6143 15.5953 11.3205 14.6904 11.3259C14.4142 11.3276 14.189 11.1051 14.1874 10.8289C14.1857 10.5528 14.4083 10.3276 14.6844 10.3259C15.8098 10.3192 16.9059 10.6846 17.8023 11.3652C18.0222 11.5322 18.0651 11.8459 17.8981 12.0658C17.7311 12.2857 17.4174 12.3286 17.1975 12.1616Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.78113 4.70086C6.96337 4.70086 7.92176 5.65925 7.92176 6.84149C7.92176 8.02372 6.96337 8.98212 5.78113 8.98212C4.5989 8.98212 3.6405 8.02372 3.6405 6.84149C3.6405 5.65925 4.5989 4.70086 5.78113 4.70086ZM4.6405 6.84149C4.6405 6.21153 5.15118 5.70086 5.78113 5.70086C6.41109 5.70086 6.92176 6.21153 6.92176 6.84149C6.92176 7.47144 6.41109 7.98212 5.78113 7.98212C5.15118 7.98212 4.6405 7.47144 4.6405 6.84149Z"
      fill="currentColor"
    />
    <path
      d="M5.2619 11.342C4.37408 11.3366 3.50938 11.6248 2.80223 12.1616C2.58229 12.3286 2.26863 12.2857 2.10166 12.0657C1.93469 11.8458 1.97764 11.5321 2.19758 11.3651C3.08029 10.695 4.15965 10.3353 5.26788 10.342C5.54402 10.3436 5.76653 10.5688 5.76488 10.8449C5.76323 11.1211 5.53804 11.3436 5.2619 11.342Z"
      fill="currentColor"
    />
    <path
      d="M13.1124 15.1135C11.268 13.7301 8.73186 13.7301 6.88741 15.1135C6.66649 15.2791 6.62172 15.5925 6.78741 15.8135C6.95309 16.0344 7.26649 16.0791 7.48741 15.9135C8.9763 14.7968 11.0235 14.7968 12.5124 15.9135C12.7333 16.0791 13.0467 16.0344 13.2124 15.8135C13.3781 15.5925 13.3333 15.2791 13.1124 15.1135Z"
      fill="currentColor"
    />
  </svg>
);

export const IconMapWithMarker = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6432 5.74193C10.2872 5.38854 9.71144 5.38739 9.35518 5.74366C8.9992 6.09963 8.9992 6.67741 9.35518 7.03338C9.71115 7.38936 10.2889 7.38936 10.6449 7.03338C11.0006 6.67766 11.0009 6.10044 10.6457 5.74441L10.6449 5.74366L10.6432 5.74193Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.29253 11.0727C9.15242 10.6531 8.89824 10.2801 8.5586 9.99653L7.51217 9.12413C6.4627 8.247 6.2402 7.03083 6.26628 6.46594C6.27328 4.1259 8.22327 2.79169 9.99973 2.79169C11.7799 2.79169 13.7339 4.13138 13.7339 6.48071C13.7339 7.85985 12.9361 8.79837 12.4736 9.13688L11.4417 9.99722C11.1019 10.2809 10.8476 10.6535 10.7077 11.0734L10.5133 11.6534C10.4393 11.8744 10.2323 12.0232 9.99931 12.023C9.76631 12.0229 9.55954 11.8737 9.48586 11.6527L9.29253 11.0727ZM9.99973 3.87502C8.6939 3.87502 7.34898 4.84647 7.34959 6.47977C7.3496 6.48989 7.34932 6.50002 7.34875 6.51013C7.33191 6.8122 7.46912 7.67607 8.20611 8.29223L9.25252 9.16461C9.54979 9.41278 9.80218 9.70809 10.0002 10.0366C10.1983 9.70823 10.4503 9.41357 10.7474 9.16558L11.7943 8.29278C11.805 8.28389 11.816 8.27542 11.8273 8.26738C12.0687 8.09572 12.6506 7.45205 12.6506 6.48071C12.6506 4.8464 11.3054 3.87502 9.99973 3.87502Z"
      fill="currentColor"
    />
    <path
      d="M5.55603 9.45825C4.59185 9.45825 3.76145 10.1391 3.57231 11.0848L2.83158 14.7884C2.58078 16.0402 3.53896 17.2081 4.8153 17.2081H15.1848C16.4612 17.2081 17.4194 16.04 17.1684 14.7882L16.4277 11.0848C16.2386 10.1391 15.4082 9.45825 14.444 9.45825C14.1449 9.45825 13.9024 9.70076 13.9024 9.99992C13.9024 10.2991 14.1449 10.5416 14.444 10.5416C14.8917 10.5416 15.2776 10.8578 15.3655 11.2972L16.1062 15.0011C16.2227 15.5819 15.7779 16.1248 15.1848 16.1248H4.8153C4.22212 16.1248 3.77744 15.5816 3.89388 15.0009L4.6346 11.2972C4.72249 10.8578 5.10837 10.5416 5.55603 10.5416C5.85518 10.5416 6.09769 10.2991 6.09769 9.99992C6.09769 9.70076 5.85518 9.45825 5.55603 9.45825Z"
      fill="currentColor"
    />
  </svg>
);

export const IconEye = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.72057 10.1391C3.51897 8.66262 4.65453 7.28871 5.94618 6.29051C7.24168 5.28935 8.64827 4.6998 10.0002 4.6998C11.352 4.6998 12.7586 5.28934 14.0541 6.2906C15.3457 7.28884 16.4812 8.66286 17.2796 10.1397C17.3071 10.1909 17.3073 10.2541 17.2797 10.3053C16.4813 11.7818 15.3458 13.1557 14.0541 14.1539C12.7586 15.1551 11.352 15.7446 10.0002 15.7446C8.64828 15.7446 7.24169 15.1551 5.94621 14.1538C4.65465 13.1556 3.51916 11.7816 2.72077 10.3047C2.69325 10.2536 2.69298 10.1903 2.72057 10.1391ZM10.0002 3.2998C8.24529 3.2998 6.54513 4.0583 5.0901 5.18275C3.63124 6.31017 2.3722 7.84002 1.48877 9.47381C1.23729 9.93994 1.23756 10.5041 1.48904 10.9702C2.37247 12.6045 3.6312 14.134 5.09008 15.2615C6.54512 16.3861 8.24528 17.1446 10.0002 17.1446C11.755 17.1446 13.4552 16.3861 14.9102 15.2616C16.3691 14.1342 17.6281 12.6044 18.5115 10.9706C18.763 10.5045 18.7628 9.94032 18.5113 9.4742C17.6278 7.83995 16.3691 6.31043 14.9102 5.18288C13.4552 4.0583 11.755 3.2998 10.0002 3.2998ZM8.57404 8.79614C9.36162 8.00856 10.6386 8.00856 11.4261 8.79614C12.2137 9.58373 12.2137 10.8607 11.4261 11.6482C10.6386 12.4358 9.36162 12.4358 8.57404 11.6482C7.78645 10.8607 7.78645 9.58373 8.57404 8.79614ZM7.6548 7.87691C8.95006 6.58164 11.0501 6.58164 12.3454 7.87691C13.6406 9.17217 13.6406 11.2722 12.3454 12.5675C11.0501 13.8628 8.95006 13.8628 7.6548 12.5675C6.35953 11.2722 6.35953 9.17217 7.6548 7.87691Z"
      fill="currentColor"
    />
  </svg>
);

export const IconMonitor = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 3.57143C1 2.13436 2.18112 1 3.6 1H16.4C17.8189 1 19 2.13436 19 3.57143V11.4286C19 12.8656 17.8189 14 16.4 14H11V16H13.2C13.7523 16 14.2 16.4477 14.2 17C14.2 17.5523 13.7523 18 13.2 18H6.80005C6.24776 18 5.80005 17.5523 5.80005 17C5.80005 16.4477 6.24776 16 6.80005 16H9V14H3.6C2.18112 14 1 12.8656 1 11.4286V3.57143ZM3.6 3C3.25157 3 3 3.27275 3 3.57143V11.4286C3 11.7273 3.25157 12 3.6 12H16.4C16.7484 12 17 11.7273 17 11.4286V3.57143C17 3.27275 16.7484 3 16.4 3H3.6Z"
      fill="currentColor"
    />
  </svg>
);

export const IconUserAlt = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.81816 2C5.65922 2 3.90906 3.75016 3.90906 5.9091C3.90906 8.06804 5.65922 9.8182 7.81816 9.8182C9.97709 9.8182 11.7273 8.06804 11.7273 5.9091C11.7273 3.75016 9.97709 2 7.81816 2ZM5.90906 5.9091C5.90906 4.85473 6.76379 4 7.81816 4C8.87252 4 9.72726 4.85473 9.72726 5.9091C9.72726 6.96347 8.87252 7.8182 7.81816 7.8182C6.76379 7.8182 5.90906 6.96347 5.90906 5.9091Z"
      fill="currentColor"
    />
    <path
      d="M4.9091 10.7273C3.87234 10.7273 2.87805 11.1391 2.14495 11.8722C1.41185 12.6053 1 13.5996 1 14.6364V16.0909C1 16.6432 1.44772 17.0909 2 17.0909C2.55228 17.0909 3 16.6432 3 16.0909V14.6364C3 14.1301 3.20114 13.6445 3.55916 13.2865C3.91719 12.9284 4.40277 12.7273 4.9091 12.7273H10.7273C11.2336 12.7273 11.7192 12.9284 12.0772 13.2865C12.4353 13.6445 12.6364 14.1301 12.6364 14.6364V16.0909C12.6364 16.6432 13.0841 17.0909 13.6364 17.0909C14.1887 17.0909 14.6364 16.6432 14.6364 16.0909V14.6364C14.6364 13.5996 14.2245 12.6053 13.4914 11.8722C12.7583 11.1391 11.7641 10.7273 10.7273 10.7273H4.9091Z"
      fill="currentColor"
    />
    <path
      d="M14.8499 11.5718C14.9879 11.037 15.5334 10.7155 16.0681 10.8535C16.9067 11.0701 17.6497 11.559 18.1804 12.2435C18.711 12.9281 18.9993 13.7695 18.9999 14.6356V16.0909C18.9999 16.6432 18.5522 17.0909 17.9999 17.0909C17.4477 17.0909 16.9999 16.6432 16.9999 16.0909V14.6368C16.9996 14.2139 16.8588 13.8031 16.5997 13.4689C16.3405 13.1345 15.9777 12.8958 15.5681 12.79C15.0334 12.6519 14.7118 12.1065 14.8499 11.5718Z"
      fill="currentColor"
    />
    <path
      d="M13.1572 2.12573C12.6222 1.98874 12.0774 2.31141 11.9404 2.84644C11.8034 3.38147 12.1261 3.92624 12.6611 4.06323C13.0718 4.16837 13.4358 4.4072 13.6957 4.74206C13.9556 5.07692 14.0967 5.48877 14.0967 5.91267C14.0967 6.33657 13.9556 6.74841 13.6957 7.08328C13.4358 7.41814 13.0718 7.65696 12.6611 7.76211C12.1261 7.8991 11.8034 8.44387 11.9404 8.9789C12.0774 9.51392 12.6222 9.8366 13.1572 9.69961C13.9981 9.48431 14.7434 8.99528 15.2756 8.30962C15.8078 7.62396 16.0967 6.78066 16.0967 5.91267C16.0967 5.04468 15.8078 4.20138 15.2756 3.51572C14.7434 2.83005 13.9981 2.34102 13.1572 2.12573Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTruckFront = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22363 12.2C5.80942 12.2 5.47363 12.5357 5.47363 12.95C5.47363 13.3642 5.80942 13.7 6.22363 13.7H7.02363C7.43784 13.7 7.77363 13.3642 7.77363 12.95C7.77363 12.5357 7.43784 12.2 7.02363 12.2H6.22363Z"
      fill="currentColor"
    />
    <path
      d="M11.8735 12.95C11.8735 12.5357 12.2093 12.2 12.6235 12.2H13.4235C13.8377 12.2 14.1735 12.5357 14.1735 12.95C14.1735 13.3642 13.8377 13.7 13.4235 13.7H12.6235C12.2093 13.7 11.8735 13.3642 11.8735 12.95Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.5H2.55C1.69419 11.5 1 10.8058 1 9.95V9.15C1 8.29419 1.69419 7.60001 2.55 7.60001H3.40002V4.35C3.40002 3.05178 4.45181 2 5.75002 2H13.75C15.0482 2 16.1 3.05178 16.1 4.35V7.60001H16.9501C17.8059 7.60001 18.5 8.29419 18.5 9.15V9.95C18.5 10.8058 17.8059 11.5 16.9501 11.5H16.5V13.95C16.5 14.5469 16.2776 15.0917 15.9112 15.5061V16.75C15.9112 17.6058 15.217 18.3 14.3612 18.3H13.5612C12.7054 18.3 12.0112 17.6058 12.0112 16.75V16.3H7.48874V16.75C7.48874 17.6058 6.79455 18.3 5.93874 18.3H5.13874C4.28293 18.3 3.58875 17.6058 3.58875 16.75V15.5061C3.22234 15.0917 3 14.5469 3 13.95V11.5ZM4.90002 4.35C4.90002 3.88021 5.28024 3.5 5.75002 3.5H13.75C14.2198 3.5 14.6 3.88021 14.6 4.35V5.40557C14.3047 5.27305 13.9786 5.20001 13.638 5.20001H5.86199C5.52143 5.20001 5.19526 5.27304 4.90002 5.40555V4.35ZM4.87973 8.12401C4.88383 8.10675 4.88734 8.08926 4.89022 8.07155L5.02783 7.3835C5.10729 6.98621 5.45616 6.70001 5.86199 6.70001H13.638C14.0438 6.70001 14.3927 6.98621 14.4721 7.3835L14.61 8.07298C14.6128 8.08972 14.6161 8.10626 14.62 8.1226L14.6904 8.47462C14.693 8.49026 14.6961 8.50573 14.6996 8.52103L14.8354 9.19998H4.66454L4.79987 8.52332C4.80384 8.50652 4.80725 8.48951 4.81007 8.4723L4.87973 8.12401ZM3.15483 9.10001H2.55C2.52261 9.10001 2.5 9.12262 2.5 9.15V9.95C2.5 9.97739 2.52261 10 2.55 10H3.02383C3.04628 9.72547 3.08456 9.45239 3.13845 9.18186L3.15483 9.10001ZM12.7644 14.8L12.7612 14.8L12.758 14.8H6.74194L6.73874 14.8L6.73554 14.8H5.35C5.1655 14.8 4.99482 14.7413 4.85556 14.6417C4.82868 14.6161 4.79991 14.5925 4.76948 14.5711C4.60361 14.4161 4.5 14.1952 4.5 13.95V10.7H15V13.95C15 14.1952 14.8964 14.4161 14.7305 14.5711C14.7001 14.5925 14.6713 14.6161 14.6444 14.6417C14.5051 14.7413 14.3345 14.8 14.15 14.8H12.7644ZM13.5112 16.3V16.75C13.5112 16.7774 13.5338 16.8 13.5612 16.8H14.3612C14.3886 16.8 14.4112 16.7774 14.4112 16.75V16.2856C14.3254 16.2951 14.2383 16.3 14.15 16.3H13.5112ZM5.35 16.3C5.26169 16.3 5.17452 16.2951 5.08875 16.2856V16.75C5.08875 16.7774 5.11136 16.8 5.13874 16.8H5.93874C5.96613 16.8 5.98874 16.7774 5.98874 16.75V16.3H5.35ZM16.4761 10H16.9501C16.9774 10 17 9.97739 17 9.95V9.15C17 9.12262 16.9774 9.10001 16.9501 9.10001H16.3451L16.3614 9.18132C16.4153 9.45191 16.4536 9.72525 16.4761 10Z"
      fill="currentColor"
    />
  </svg>
);

export const IconBillingCheck = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6296 9.1667L10.0096 10.7867L9.03711 9.8142"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.83398 13.3334H12.834"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0411 17.5V3.93071C17.0411 3.7806 16.9603 3.64209 16.8297 3.56813C16.699 3.49417 16.5387 3.4962 16.41 3.57343L15.2341 4.27896C14.9702 4.43731 14.6405 4.43731 14.3766 4.27896L12.9984 3.45206C12.7345 3.29371 12.4048 3.29371 12.1409 3.45206L10.7628 4.27896C10.4988 4.43731 10.1692 4.43731 9.90525 4.27896L8.52707 3.45206C8.26317 3.29371 7.93347 3.29371 7.66957 3.45206L6.29139 4.27896C6.02748 4.43731 5.69779 4.43731 5.43389 4.27896L4.25799 3.57343C4.12927 3.4962 3.96896 3.49417 3.83833 3.56813C3.7077 3.64209 3.62695 3.7806 3.62695 3.93071V17.5"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.834 17.5H2.83398"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconLocation = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9497 5.05025C17.6834 7.78392 17.6834 12.2161 14.9497 14.9497C12.2161 17.6834 7.78392 17.6834 5.05025 14.9497C2.31658 12.2161 2.31658 7.78392 5.05025 5.05025C7.78392 2.31658 12.2161 2.31658 14.9497 5.05025"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4142 8.58579C12.1953 9.36684 12.1953 10.6332 11.4142 11.4142C10.6332 12.1953 9.36684 12.1953 8.58579 11.4142C7.80474 10.6332 7.80474 9.36684 8.58579 8.58579C9.36684 7.80474 10.6332 7.80474 11.4142 8.58579Z"
      fill="currentColor"
    />
    <path
      d="M10 19V15"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 1V5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 10H1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 10H15"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconLocationCancel = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0041 19.0075V15.0059"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0041 1V5.00167"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00167 10.0036H1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0075 10.0036H15.0059"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3.00098L17.0058 17.0068"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.50501 7.50684C2.54161 10.0079 3.03382 12.9381 5.05166 14.9549C7.0695 16.9728 9.99872 17.465 12.4998 16.5016"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5026 12.5007C17.466 9.99969 16.9738 7.06947 14.9559 5.05263C12.9381 3.03479 10.0089 2.54259 7.50781 3.50599"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconUserSingle = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 14.584C5.569 13.059 7.692 12.121 10.023 12.121C12.331 12.121 14.431 13.04 16 14.537C14.431 16.062 12.308 17 9.977 17C7.669 17 5.569 16.081 4 14.584Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1213 3.87868C13.2929 5.05025 13.2929 6.94975 12.1213 8.12132C10.9497 9.29289 9.05025 9.29289 7.87868 8.12132C6.70711 6.94975 6.70711 5.05025 7.87868 3.87868C9.05025 2.70711 10.9497 2.70711 12.1213 3.87868"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const IconMapMarkerOutline = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4447 10.7778V10.7778C9.15588 10.7778 8.11133 9.73319 8.11133 8.44442V8.44442C8.11133 7.15564 9.15588 6.11108 10.4447 6.11108V6.11108C11.7334 6.11108 12.778 7.15564 12.778 8.44442V8.44442C12.778 9.73319 11.7334 10.7778 10.4447 10.7778Z"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4444 17C10.4444 17 5 12.5278 5 8.44444C5 5.43756 7.43756 3 10.4444 3C13.4513 3 15.8889 5.43756 15.8889 8.44444C15.8889 12.5278 10.4444 17 10.4444 17Z"
      stroke="currentColor"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const IconNotesArrowRight = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.14433 1.59998C3.13145 1.59998 2.37988 2.47541 2.37988 3.46734V11.0187C2.37988 11.3059 2.61269 11.5387 2.89988 11.5387C3.18707 11.5387 3.41988 11.3059 3.41988 11.0187V3.46734C3.41988 2.97043 3.78209 2.63998 4.14433 2.63998H12.8554C13.2177 2.63998 13.5799 2.97043 13.5799 3.46734V12.2252C13.5799 12.7221 13.2177 13.0526 12.8554 13.0526H10.1799C9.89269 13.0526 9.65988 13.2854 9.65988 13.5726C9.65988 13.8598 9.89269 14.0926 10.1799 14.0926H12.8554C13.8683 14.0926 14.6199 13.2172 14.6199 12.2252V3.46734C14.6199 2.47541 13.8683 1.59998 12.8554 1.59998H4.14433Z"
      fill="currentColor"
    />
    <path
      d="M4.8688 7.50943C4.8688 7.22224 5.10161 6.98943 5.3888 6.98943H8.49991C8.7871 6.98943 9.01991 7.22224 9.01991 7.50943C9.01991 7.79662 8.7871 8.02943 8.49991 8.02943H5.3888C5.10161 8.02943 4.8688 7.79662 4.8688 7.50943Z"
      fill="currentColor"
    />
    <path
      d="M2.37988 13.5726C2.37988 13.2854 2.61269 13.0526 2.89988 13.0526H6.68953L6.25124 12.5781C6.05638 12.3671 6.06945 12.0381 6.28042 11.8433C6.49139 11.6484 6.82038 11.6615 7.01523 11.8724L8.25968 13.2198C8.29372 13.2567 8.32146 13.2972 8.34291 13.3401C8.37219 13.3986 8.39078 13.4634 8.39609 13.5319C8.39825 13.5595 8.39821 13.5873 8.39597 13.6149C8.39085 13.6785 8.37431 13.7388 8.34839 13.7938C8.32626 13.8409 8.29669 13.8854 8.25968 13.9254L7.01523 15.2728C6.82038 15.4838 6.49139 15.4968 6.28042 15.302C6.06945 15.1071 6.05638 14.7781 6.25124 14.5672L6.68955 14.0926H2.89988C2.61269 14.0926 2.37988 13.8598 2.37988 13.5726Z"
      fill="currentColor"
    />
    <path
      d="M4.8688 4.8147C4.8688 4.52751 5.10161 4.2947 5.3888 4.2947H11.611C11.8982 4.2947 12.131 4.52751 12.131 4.8147C12.131 5.10189 11.8982 5.3347 11.611 5.3347H5.3888C5.10161 5.3347 4.8688 5.10189 4.8688 4.8147Z"
      fill="currentColor"
    />
  </svg>
);

export const IconAmount = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1226 4.4211C11.1226 4.13391 11.3554 3.9011 11.6426 3.9011H11.9794C12.2666 3.9011 12.4994 4.13391 12.4994 4.4211C12.4994 4.70829 12.2666 4.9411 11.9794 4.9411H11.6426C11.3554 4.9411 11.1226 4.70829 11.1226 4.4211Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.08052 6.26378C7.08052 5.23246 7.91657 4.39641 8.94789 4.39641C9.97921 4.39641 10.8153 5.23246 10.8153 6.26378C10.8153 7.2951 9.97921 8.13115 8.94789 8.13115C7.91657 8.13115 7.08052 7.2951 7.08052 6.26378ZM8.94789 5.43641C8.49094 5.43641 8.12052 5.80684 8.12052 6.26378C8.12052 6.72072 8.49094 7.09115 8.94789 7.09115C9.40483 7.09115 9.77526 6.72072 9.77526 6.26378C9.77526 5.80684 9.40483 5.43641 8.94789 5.43641Z"
      fill="currentColor"
    />
    <path
      d="M5.91629 7.60637C5.6291 7.60637 5.39629 7.83918 5.39629 8.12637C5.39629 8.41356 5.6291 8.64637 5.91629 8.64637H6.25313C6.54032 8.64637 6.77313 8.41356 6.77313 8.12637C6.77313 7.83918 6.54032 7.60637 6.25313 7.60637H5.91629Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.89524 1.88C4.50349 1.88 3.37524 3.00825 3.37524 4.4V4.59628C2.3044 4.74672 1.48047 5.66661 1.48047 6.77894V11.4947C1.48047 12.7121 2.46733 13.6989 3.68468 13.6989H11.0952C12.3126 13.6989 13.2994 12.7121 13.2994 11.4947V10.3073C14.0311 9.86628 14.5205 9.06398 14.5205 8.14738V4.4C14.5205 3.00825 13.3923 1.88 12.0005 1.88H5.89524ZM2.52047 6.77894C2.52047 6.24311 2.88247 5.79182 3.37524 5.6563V8.14738C3.37524 9.53914 4.50349 10.6674 5.89525 10.6674H12.0005C12.0879 10.6674 12.1743 10.6629 12.2594 10.6542V11.4947C12.2594 12.1377 11.7382 12.6589 11.0952 12.6589H3.68468C3.0417 12.6589 2.52047 12.1377 2.52047 11.4947V6.77894ZM4.41524 4.4C4.41524 3.58262 5.07786 2.92 5.89524 2.92H12.0005C12.8179 2.92 13.4805 3.58262 13.4805 4.4V8.14738C13.4805 8.96476 12.8179 9.62738 12.0005 9.62738H5.89525C5.07786 9.62738 4.41524 8.96476 4.41524 8.14738V4.4Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCombineBills = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.69988 5.3467C5.41269 5.3467 5.17988 5.57952 5.17988 5.8667C5.17988 6.15389 5.41269 6.3867 5.69988 6.3867H11.2999C11.5871 6.3867 11.8199 6.15389 11.8199 5.8667C11.8199 5.57952 11.5871 5.3467 11.2999 5.3467H5.69988Z"
      fill="currentColor"
    />
    <path
      d="M5.17988 8C5.17988 7.71282 5.41269 7.48 5.69988 7.48H11.2999C11.5871 7.48 11.8199 7.71282 11.8199 8C11.8199 8.28719 11.5871 8.52001 11.2999 8.52001H5.69988C5.41269 8.52001 5.17988 8.28719 5.17988 8Z"
      fill="currentColor"
    />
    <path
      d="M5.69988 9.61331C5.41269 9.61331 5.17988 9.84612 5.17988 10.1333C5.17988 10.4205 5.41269 10.6533 5.69988 10.6533H9.19988C9.48707 10.6533 9.71988 10.4205 9.71988 10.1333C9.71988 9.84612 9.48707 9.61331 9.19988 9.61331H5.69988Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.8366 2.00902C4.49168 1.83575 4.08592 1.83708 3.74215 2.01258L3.04914 2.36638C2.63589 2.57734 2.37989 3.00381 2.37988 3.46491V12.5351C2.37989 12.9962 2.63591 13.4227 3.04918 13.6336L3.74216 13.9874C4.08594 14.1629 4.4917 14.1643 4.83662 13.991L5.70208 13.5562L6.54619 13.987C6.89097 14.163 7.298 14.1637 7.64343 13.989L8.49988 13.5559L9.35635 13.989C9.70178 14.1637 10.1088 14.163 10.4536 13.987L11.2977 13.5562L12.1632 13.991C12.5081 14.1643 12.9138 14.1629 13.2576 13.9874L13.9506 13.6336C14.3639 13.4227 14.6199 12.9962 14.6199 12.5351V3.46491C14.6199 3.0038 14.3638 2.57732 13.9506 2.36636L13.2576 2.01258C12.9138 1.83708 12.5081 1.83575 12.1631 2.00902L11.2977 2.44378L10.4536 2.01301C10.1088 1.83706 9.70177 1.8363 9.35634 2.011L8.49988 2.44414L7.64341 2.011C7.29798 1.8363 6.89096 1.83706 6.54617 2.01301L5.70207 2.44378L4.8366 2.00902ZM3.52202 3.29265L4.21502 2.93886C4.26393 2.9139 4.32073 2.91372 4.36976 2.93835L5.47049 3.4913C5.6184 3.5656 5.79285 3.56505 5.94028 3.48981L7.01892 2.93936C7.06797 2.91433 7.12495 2.91423 7.17406 2.93907L8.26521 3.49089C8.41276 3.56551 8.58701 3.56551 8.73456 3.49089L9.82569 2.93907C9.87481 2.91423 9.93179 2.91433 9.98084 2.93936L11.0595 3.48981C11.2069 3.56505 11.3814 3.5656 11.5293 3.4913L12.63 2.93835C12.679 2.91372 12.7358 2.9139 12.7847 2.93886L13.4778 3.29266C13.5374 3.32312 13.5799 3.38835 13.5799 3.46492V12.5351C13.5799 12.6117 13.5374 12.6769 13.4777 12.7074L12.7847 13.0612C12.7358 13.0861 12.679 13.0863 12.63 13.0617L11.5293 12.5087C11.3814 12.4344 11.2069 12.435 11.0595 12.5102L9.98085 13.0607C9.9318 13.0857 9.87482 13.0858 9.8257 13.0609L8.73456 12.5091C8.587 12.4345 8.41276 12.4345 8.26521 12.5091L7.17407 13.0609C7.12496 13.0858 7.06797 13.0857 7.01893 13.0607L5.9403 12.5102C5.79286 12.435 5.61842 12.4344 5.47051 12.5087L4.36977 13.0617C4.32074 13.0863 4.26394 13.0861 4.21503 13.0611L3.52201 12.7073C3.46235 12.6769 3.41988 12.6117 3.41988 12.5351V3.46491C3.41989 3.38834 3.46237 3.3231 3.52202 3.29265Z"
      fill="currentColor"
    />
  </svg>
);

export const IconSelected = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.67532 7.6207C9.88481 7.81716 9.89537 8.14623 9.69891 8.35572L5.19744 13.1557C5.09912 13.2606 4.96177 13.32 4.81803 13.32C4.67429 13.32 4.53697 13.2604 4.43869 13.1556L1.74016 10.2756C1.54379 10.066 1.5545 9.73691 1.76406 9.54055C1.97363 9.34419 2.3027 9.35489 2.49907 9.56446L4.81831 12.0397L8.94031 7.64429C9.13676 7.43481 9.46584 7.42425 9.67532 7.6207Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.46631 3.95556C3.46631 2.80926 4.39557 1.88 5.54187 1.88H9.97727C10.6103 1.88001 11.2173 2.13146 11.6649 2.57904L13.1406 4.05475C13.5882 4.50234 13.8396 5.10939 13.8396 5.74238V12.0444C13.8396 13.1907 12.9104 14.12 11.7641 14.12H8.96409C8.6769 14.12 8.44409 13.8872 8.44409 13.6C8.44409 13.3128 8.6769 13.08 8.96409 13.08H11.7641C12.336 13.08 12.7996 12.6164 12.7996 12.0444V5.74238C12.7996 5.38522 12.6578 5.04269 12.4052 4.79014L10.9295 3.31443C10.677 3.06189 10.3344 2.92 9.97727 2.92H5.54187C4.96994 2.92 4.50631 3.38364 4.50631 3.95556V6.13334C4.50631 6.42053 4.2735 6.65334 3.98631 6.65334C3.69912 6.65334 3.46631 6.42053 3.46631 6.13334V3.95556Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2085 1.89465C10.4957 1.89465 10.7285 2.12747 10.7285 2.41465V4.57773C10.7285 4.80601 10.9135 4.99107 11.1418 4.99107H13.3049C13.5921 4.99107 13.8249 5.22388 13.8249 5.51107C13.8249 5.79826 13.5921 6.03107 13.3049 6.03107H11.1418C10.3392 6.03107 9.68848 5.38039 9.68848 4.57773V2.41465C9.68848 2.12747 9.92129 1.89465 10.2085 1.89465Z"
      fill="currentColor"
    />
  </svg>
);

export const IconApproved = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="20"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83554 7.01571C6.06985 6.78139 6.44975 6.78139 6.68407 7.01571L10.0441 10.3757C10.2784 10.61 10.2784 10.9899 10.0441 11.2242C9.80975 11.4586 9.42985 11.4586 9.19554 11.2242L5.83554 7.86424C5.60122 7.62992 5.60122 7.25002 5.83554 7.01571Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5241 5.89571C14.7584 6.13003 14.7584 6.50992 14.5241 6.74424L10.0441 11.2242C9.93154 11.3368 9.77894 11.4 9.61981 11.4C9.46068 11.4 9.30806 11.3368 9.19554 11.2242L5.92851 7.9572C5.69419 7.72288 5.69419 7.34298 5.92851 7.10867C6.16282 6.87436 6.54272 6.87436 6.77703 7.10867L9.61981 9.95144L13.6755 5.89571C13.9099 5.6614 14.2898 5.6614 14.5241 5.89571Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.47554 8.13571C2.70986 7.90139 3.08975 7.90139 3.32407 8.13571L5.56407 10.3757C5.79838 10.61 5.79838 10.9899 5.56407 11.2242C5.32975 11.4586 4.94985 11.4586 4.71554 11.2242L2.47554 8.98424C2.24123 8.74992 2.24123 8.37002 2.47554 8.13571Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1641 4.77571C11.3984 5.01003 11.3984 5.38993 11.1641 5.62424L10.0441 6.74424C9.80975 6.97855 9.42985 6.97855 9.19554 6.74424C8.96122 6.50992 8.96122 6.13003 9.19554 5.89571L10.3155 4.77571C10.5498 4.5414 10.9297 4.5414 11.1641 4.77571Z"
      fill="currentColor"
    />
  </svg>
);

export const IconShip = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    className={`cicon ${className}`}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6012 3.15C10.6012 2.79101 10.332 2.5 10 2.5C9.66804 2.5 9.3989 2.79101 9.3989 3.15V3.91284H8.45363C7.71756 3.91284 7.12741 4.5613 7.12741 5.352V6.85468H6.90827C5.77103 6.85468 4.85616 7.85656 4.85616 9.08389V11.0372L3.2766 11.467C3.08749 11.5184 2.93321 11.6659 2.86276 11.8625C2.7923 12.0591 2.81443 12.2804 2.92211 12.4562L4.52495 15.073L4.82978 16.0128C3.99626 15.8563 3.10564 15.9647 2.35118 16.3379C2.04928 16.4873 1.91651 16.873 2.05465 17.1994C2.19278 17.5259 2.5495 17.6694 2.8514 17.5201C3.59687 17.1513 4.5652 17.1513 5.31067 17.5201C6.37377 18.046 7.70726 18.046 8.77037 17.5201C9.51583 17.1513 10.4842 17.1513 11.2296 17.5201C12.2927 18.046 13.6262 18.046 14.6893 17.5201C15.4348 17.1513 16.4031 17.1513 17.1486 17.5201C17.4505 17.6694 17.8072 17.5259 17.9454 17.1994C18.0835 16.873 17.9507 16.4873 17.6488 16.3379C16.8501 15.9428 15.8988 15.8445 15.0242 16.0431L15.4542 15.1068L17.0777 12.4562C17.1854 12.2804 17.2076 12.0591 17.1371 11.8625C17.0666 11.6659 16.9124 11.5184 16.7233 11.467L15.1449 11.0375V9.08389C15.1449 7.85656 14.23 6.85468 13.0928 6.85468H12.8725V5.352C12.8725 4.5613 12.2824 3.91284 11.5463 3.91284H10.6012V3.15ZM13.4372 16.5759L14.394 14.4925C14.405 14.4684 14.4175 14.445 14.4312 14.4226L15.6066 12.5037L14.4164 12.1798C14.4031 12.1767 14.3899 12.1731 14.3769 12.1691L9.99993 10.9781L5.63106 12.1669C5.61355 12.1726 5.59571 12.1774 5.57757 12.1814L4.39323 12.5037L5.56864 14.4226C5.59608 14.4674 5.61828 14.5157 5.63473 14.5664L6.2653 16.5106C6.92265 16.6929 7.66889 16.6354 8.27015 16.3379C9.33326 15.812 10.6667 15.812 11.7299 16.3379C12.242 16.5913 12.8593 16.6706 13.4372 16.5759ZM9.85323 9.67749L6.05845 10.71V9.08389C6.05845 8.56648 6.44246 8.15468 6.90827 8.15468H13.0928C13.5586 8.15468 13.9426 8.56648 13.9426 9.08389V10.7104L10.1466 9.67749C10.0503 9.65129 9.94953 9.65129 9.85323 9.67749ZM8.45363 5.21284C8.38899 5.21284 8.3297 5.27122 8.3297 5.352V6.85468H11.6702V5.352C11.6702 5.27122 11.6109 5.21284 11.5463 5.21284H8.45363Z"
      fill="#172A41"
    />
  </svg>
);

export const IconMap = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M7.0908 2c.1673 0 .325.041.4635.1136l5.3233 2.6617 4.6263-2.6435A.9999.9999 0 0 1 19 3v11.6364a1 1 0 0 1-.5039.8682l-5.0731 2.899a.9958.9958 0 0 1-.5139.1419.996.996 0 0 1-.4688-.1164l-5.318-2.659-4.6262 2.6436A1 1 0 0 1 1 17.5455V5.9091a1 1 0 0 1 .5039-.8682l5.0736-2.8993A.9954.9954 0 0 1 7.0908 2Zm6.8183 13.8223L17 14.056V4.7232l-3.0909 1.7662v9.3329Zm-2-9.2952v9.4003l-3.8183-1.9091V4.618l3.8183 1.9091ZM3 6.4894l3.0908-1.7662v9.3329L3 15.8223V6.4894Z"
      clip-rule="evenodd"
    />
  </svg>
);

export const IconArrowLongRight = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
  >
    <path
      fill="currentColor"
      d="m17 10-.0002-.0193a.9605.9605 0 0 0-.0038-.07L17 10a1.016 1.016 0 0 0-.0202-.2007.9319.9319 0 0 0-.0295-.1114.9512.9512 0 0 0-.044-.1111 1.0075 1.0075 0 0 0-.116-.1897l-.01-.0126-.0732-.0816-3-3c-.3905-.3905-1.0237-.3905-1.4142 0-.3605.3605-.3882.9277-.0832 1.32l.0832.0942L13.585 9H5c-.5523 0-1 .4477-1 1 0 .5128.386.9355.8834.9933L5 11h8.585l-1.2921 1.2929c-.3605.3605-.3882.9277-.0832 1.32l.0832.0942c.3605.3605.9277.3882 1.32.0832l.0942-.0832 3-3 .0732-.0817a.6475.6475 0 0 0 .0069-.0086l-.0801.0903a1.0125 1.0125 0 0 0 .0966-.1118 1.0343 1.0343 0 0 0 .0716-.1112 1.0251 1.0251 0 0 0 .0752-.1724 1.116 1.116 0 0 0 .0137-.0457.9217.9217 0 0 0 .0248-.1175A.9747.9747 0 0 0 17 10Z"
    />
  </svg>
);
export const IconShipAnchor = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 21"
    className={`cicon ${className}`}
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M11.025 4.5743c-.5662-.5663-1.4843-.5663-2.0506 0-.5662.5663-.5662 1.4844 0 2.0506.5663.5663 1.4844.5663 2.0506 0 .5663-.5663.5663-1.4843 0-2.0506Zm.9193-.9192c-1.074-1.074-2.8152-1.074-3.8891 0-1.074 1.074-1.074 2.8151 0 3.889 1.074 1.074 2.8151 1.074 3.8891 0 1.0739-1.0739 1.0739-2.815 0-3.889Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9.9996 7.0496a.65.65 0 0 1 .65.65v9.8a.65.65 0 1 1-1.3 0v-9.8a.65.65 0 0 1 .65-.65Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2.3496 10.4996a.65.65 0 0 1 .65-.65h2.1a.65.65 0 1 1 0 1.3H3.6825c.3255 3.2015 3.0298 5.7 6.3171 5.7s5.9916-2.4985 6.3171-5.7h-1.4171a.65.65 0 1 1 0-1.3h2.1a.65.65 0 0 1 .65.65c0 4.2247-3.4253 7.65-7.65 7.65s-7.65-3.4253-7.65-7.65Z"
      clip-rule="evenodd"
    />
  </svg>
);

export const IconFileCheck = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M1.1001 3.7779C1.1001 2.2986 2.2986 1.1 3.7779 1.1h12.4444c1.4793 0 2.6778 1.1985 2.6778 2.6778v4.4444a.9.9 0 0 1-.9.9.9.9 0 0 1-.9-.9V3.778a.8773.8773 0 0 0-.8778-.8778h-2.6556v3.0413c0 .9878-.8012 1.789-1.7889 1.789H8.2222c-.9877 0-1.7889-.8013-1.7889-1.789V2.9001H3.778a.8773.8773 0 0 0-.8778.8778v11.5555c0 .4852.3926.8778.8778.8778h3.5555a.9.9 0 0 1 0 1.8H3.778c-1.4793 0-2.6778-1.1985-2.6778-2.6778V3.7779Zm7.1332 2.1524V2.9001h3.5334v3.0302H8.2333Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.6001 13.2669a.9001.9001 0 0 0 0-1.2728.9.9 0 0 0-1.2728 0l-1.3085 1.3085-.5307-.5307a.9.9 0 0 0-1.2728 0 .8998.8998 0 0 0 0 1.2727l1.1671 1.1672a.9001.9001 0 0 0 1.2728 0l1.9449-1.9449Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M18.3081 13.4083a4.8772 4.8772 0 0 1-.8575 2.7697l1.1859 1.1859a.9.9 0 0 1 0 1.2728.9.9 0 0 1-1.2728 0l-1.1859-1.1859a4.8772 4.8772 0 0 1-2.7697.8575c-2.706 0-4.9-2.1941-4.9-4.9s2.194-4.9 4.9-4.9c2.7059 0 4.9 2.1941 4.9 4.9Zm-4.9-3.1c-1.7119 0-3.1 1.3882-3.1 3.1s1.3881 3.1 3.1 3.1c1.7118 0 3.1-1.3882 3.1-3.1s-1.3882-3.1-3.1-3.1Z"
      clip-rule="evenodd"
    />
  </svg>
);

export const IconBookings = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9.8438 4.5713a1.0059 1.0059 0 0 0-.177-.0156H7.3334c-1.534 0-2.7777 1.2436-2.7777 2.7777v3.5556c0 1.5341 1.2436 2.7778 2.7777 2.7778h5.3334c1.5341 0 2.7778-1.2437 2.7778-2.7778V7.3334c0-1.534-1.2437-2.7777-2.7778-2.7777h-2.3334c-.0604 0-.1195.0053-.177.0156h-.3126ZM7.3334 6.5557a.7778.7778 0 0 0-.7777.7777v3.5556c0 .4296.3482.7778.7777.7778h5.3334a.7778.7778 0 0 0 .7778-.7778V7.3334a.7778.7778 0 0 0-.7778-.7777H12V9l-2-1-2 1V6.5557h-.6666Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M1 4.6667C1 2.6417 2.6416 1 4.6667 1h10.6666C17.3584 1 19 2.6416 19 4.6667v8.8889c0 2.025-1.6416 3.6666-3.6667 3.6666h-2.7731l-1.2246 1.2245c-.7376.7377-1.9336.7377-2.6712.0001l-1.2246-1.2246H4.6668C2.6417 17.2222 1 15.5806 1 13.5556v-8.889ZM4.6667 3C3.7462 3 3 3.7462 3 4.6667v8.8889c0 .9204.7462 1.6666 1.6667 1.6666H7.854c.2652 0 .5195.1054.707.2929L10 16.9539l1.4388-1.4388a1.0003 1.0003 0 0 1 .7071-.2929h3.1874c.9205 0 1.6667-.7462 1.6667-1.6666v-8.889C17 3.7463 16.2538 3 15.3333 3H4.6667Z"
      clip-rule="evenodd"
    />
  </svg>
);

export const IconEmpty = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.0979 1.1001a2.9032 2.9032 0 0 0-2.6667 1.7606l-1.098 2.5692a2.9019 2.9019 0 0 0-.2331 1.139v9.4312c0 1.6016 1.2984 2.8999 2.9 2.8999h6.8889a.9.9 0 0 0 0-1.8H4c-.6074 0-1.0999-.4924-1.0999-1.0999V8.2222c0-.4848.393-.8778.8778-.8778h6.2087L10 7.3445h6.2224c.4848 0 .8777.393.8777.8777v2.6667a.9.9 0 0 0 1.8 0v-4.32c0-.3924-.0803-.781-.2348-1.141L17.568 2.8606A2.9012 2.9012 0 0 0 14.9014 1.1H5.0979Zm11.6847 4.503-.8696-2.035a1.1009 1.1009 0 0 0-1.0116-.668h-4.0015v2.6443h5.3224c.1921 0 .3796.0203.5603.0587Zm-7.6827-.0587V2.9001H5.0982a1.1018 1.1018 0 0 0-1.0118.6679l-.8698 2.0354c.181-.0386.3687-.059.5613-.059h5.322Z"
      clip-rule="evenodd"
    />
    <path
      fill="currentColor"
      d="M4.6558 14.4444a.9.9 0 0 1 .9-.9h1.7777a.9.9 0 0 1 0 1.8H5.5558a.9.9 0 0 1-.9-.9ZM13.9507 12.6558l.2414-.2415a.9.9 0 0 0 0-1.2728.9001.9001 0 0 0-1.2728 0l-1.7778 1.7778a.8985.8985 0 0 0-.2636.6365.8965.8965 0 0 0 .2698.6425l1.7716 1.7716a.9001.9001 0 0 0 1.2728 0 .9.9 0 0 0 0-1.2728l-.2413-.2413h1.8271c.7303 0 1.3222.5919 1.3222 1.3222 0 .7302-.5919 1.3222-1.3222 1.3222h-1.3333a.9.9 0 0 0 0 1.8h1.3333c1.7244 0 3.1222-1.3979 3.1222-3.1222 0-1.7244-1.3978-3.1222-3.1222-3.1222h-1.8272Z"
    />
  </svg>
);

export const IconAppointment = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    className={`cicon ${className}`}
  >
    <path
      fill="CurrentColor"
      d="M9 13.5557c0-.5523.4477-1 1-1h4.4444c.5523 0 1 .4477 1 1 0 .5522-.4477 1-1 1H10c-.5523 0-1-.4478-1-1ZM7.0079 14.3411c.4339-.4339.4339-1.1374 0-1.5713-.434-.4339-1.1375-.4339-1.5714 0-.4339.4339-.4339 1.1374 0 1.5713.434.4339 1.1375.4339 1.5714 0ZM9 9.111c0-.5522.4477-1 1-1h4.4444c.5523 0 1 .4478 1 1 0 .5524-.4477 1.0001-1 1.0001H10c-.5523 0-1-.4477-1-1ZM7.0079 9.8968c.4339-.434.4339-1.1375 0-1.5714-.434-.4339-1.1375-.4339-1.5714 0-.4339.434-.4339 1.1375 0 1.5714.434.4339 1.1375.4339 1.5714 0Z"
    />
    <path
      fill="CurrentColor"
      fill-rule="evenodd"
      d="M14.5496 1.889c-.0553-.5-.4792-.889-.9939-.889-.5148 0-.9387.389-.9939.889h-1.5679C10.9386 1.389 10.5147 1 10 1c-.5147 0-.9386.389-.9939.889H7.4382C7.383 1.389 6.9591 1 6.4443 1c-.5147 0-.9386.389-.9939.889H3.7778C2.2433 1.889 1 3.1321 1 4.6666v11.5555C1 17.7568 2.2433 19 3.7778 19h12.4444C17.7567 19 19 17.7568 19 16.2222V4.6667c0-1.5345-1.2433-2.7778-2.7778-2.7778h-1.6726Zm-9.1053 2H3.7778A.7773.7773 0 0 0 3 4.6666v11.5555c0 .43.3478.7778.7778.7778h12.4444c.43 0 .7778-.3478.7778-.7778V4.6667a.7773.7773 0 0 0-.7778-.7778h-1.6665v.7778c0 .5523-.4478 1-1 1-.5523 0-1-.4477-1-1v-.7778H11v.7778c0 .5523-.4477 1-1 1s-1-.4477-1-1v-.7778H7.4443v.7778c0 .5523-.4477 1-1 1-.5522 0-1-.4477-1-1v-.7778Z"
      clip-rule="evenodd"
    />
  </svg>
);

export const IconEyeClosed = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg className={`cicon ${className}`} width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00022 0.350098C7.25974 0.350098 5.57006 1.10256 4.12071 2.22274C2.66781 3.34567 1.41348 4.86964 0.533084 6.49828C0.289596 6.94958 0.289344 7.49584 0.532832 7.94714C1.29617 9.35843 2.34039 10.6914 3.55071 11.7528L2.31818 12.9853C2.06434 13.2391 2.06434 13.6507 2.31818 13.9045C2.57203 14.1584 2.98358 14.1584 3.23742 13.9045L4.95361 12.1883C4.96851 12.1748 4.98288 12.1604 4.99668 12.1453L13.9356 3.20638C13.9405 3.20155 13.9455 3.19663 13.9503 3.19162L15.6822 1.45972C15.9361 1.20588 15.9361 0.794319 15.6822 0.540478C15.4284 0.286637 15.0168 0.286637 14.763 0.540478L13.4185 1.88492C12.0775 0.953764 10.5589 0.350098 9.00022 0.350098ZM12.4824 2.82104C11.3532 2.07808 10.1581 1.6501 9.00022 1.6501C7.63395 1.6501 6.21687 2.24567 4.9157 3.25133C3.61815 4.25419 2.47824 5.63377 1.67681 7.11625C1.64134 7.18218 1.64135 7.26375 1.67683 7.32968C2.38583 8.64038 3.35924 9.87044 4.47216 10.8313L6.14458 9.15888C5.23205 7.81631 5.37084 5.97247 6.56094 4.78238C7.75104 3.59228 9.59487 3.45349 10.9374 4.36602L12.4824 2.82104ZM7.48018 5.70162C8.15952 5.02228 9.18086 4.89266 9.99071 5.31275L7.09131 8.21215C6.67122 7.4023 6.80084 6.38095 7.48018 5.70162Z" fill="#172A41"/>
    <path d="M14.8707 3.99133C15.1436 3.75818 15.5539 3.79046 15.7871 4.06343C16.4288 4.81477 17.0013 5.63636 17.4673 6.49826C17.7108 6.94957 17.7111 7.49589 17.4676 7.9472L17.4657 7.9506C16.5854 9.57768 15.3317 11.1003 13.8797 12.2224C12.4304 13.3425 10.7407 14.0949 9.00022 14.0949C8.64123 14.0949 8.35022 13.8039 8.35022 13.4449C8.35022 13.0859 8.64123 12.7949 9.00022 12.7949C10.3665 12.7949 11.7836 12.1993 13.0848 11.1938C14.3824 10.191 15.5224 8.8115 16.3238 7.32936L16.3243 7.32847C16.3591 7.26275 16.3589 7.18178 16.3236 7.11626C15.9043 6.3409 15.3852 5.59457 14.7986 4.90774C14.5654 4.63478 14.5977 4.22449 14.8707 3.99133Z" fill="#172A41"/>
  </svg>

);

export const IconReward = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
  <svg className={`cicon ${className}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4">
    <path d="M16 3V10.74" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 10.74V3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.9991 19.326L15.0071 20.907C15.5931 21.215 16.2771 20.717 16.1651 20.065L15.5901 16.716L18.0241 14.345C18.4981 13.883 18.2371 13.078 17.5821 12.983L14.2191 12.494L12.7151 9.44501C12.4221 8.85101 11.5761 8.85101 11.2831 9.44501L9.78012 12.494L6.41712 12.983C5.76212 13.078 5.50112 13.883 5.97512 14.345L8.40912 16.716L7.83412 20.065C7.72212 20.717 8.40612 21.214 8.99212 20.907L12.0001 19.326" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.062 11.922L6.005 9.596C5.384 9.24 5 8.578 5 7.861V5C5 3.895 5.895 3 7 3H17C18.105 3 19 3.895 19 5V7.861C19 8.578 18.617 9.24 17.995 9.596L13.938 11.922" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>
);

export const IconShare = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
<svg width="20" height="21" className={`cicon ${className}`} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.68575 3.66164C10.2425 3.39183 10.9045 3.46389 11.3902 3.84715L17.6977 8.82763C18.078 9.12737 18.3 9.58492 18.3 10.0692C18.3 10.5535 18.078 11.011 17.6977 11.3107L11.3903 16.2911C10.9047 16.6744 10.2425 16.7465 9.68575 16.4767C9.12898 16.2069 8.77533 15.6427 8.77518 15.024V13.1634C6.58952 13.3735 4.56394 14.4385 3.15013 16.1417C2.9752 16.3524 2.68692 16.4309 2.42931 16.3379C2.17169 16.2449 2 16.0004 2 15.7265V15.2433C2.00209 11.2268 4.87896 7.82163 8.77518 7.10414V5.11451C8.77533 4.49581 9.12898 3.93144 9.68575 3.66164ZM10.5847 4.86755C10.4901 4.79296 10.3611 4.77896 10.2527 4.83152C10.1442 4.88408 10.0753 4.99398 10.0752 5.11451C10.0752 5.11456 10.0752 5.11446 10.0752 5.11451V7.66448C10.0752 7.99526 9.82677 8.27328 9.49808 8.31038C6.37025 8.66338 3.91911 11.0478 3.40121 14.0582C5.07902 12.6616 7.19681 11.8632 9.41437 11.8264C9.58861 11.8235 9.75672 11.8906 9.88096 12.0128C10.0052 12.135 10.0752 12.302 10.0752 12.4763V15.0237C10.0752 15.0238 10.0752 15.0237 10.0752 15.0237C10.0753 15.1442 10.1442 15.2543 10.2527 15.3069C10.3611 15.3594 10.4901 15.3454 10.5847 15.2708M10.5847 15.2708L16.8925 10.2901C16.9601 10.2369 17 10.1552 17 10.0692C17 9.98317 16.9606 9.9019 16.893 9.84866L10.5847 4.86755" fill="#172A41"/>
</svg>

);

export const IconCopy = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
<svg width="20" height="20" className={`cicon ${className}`} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.5286 4.5286C4.65362 4.40357 4.82319 4.33333 5 4.33333H11C11.1768 4.33333 11.3464 4.40357 11.4714 4.5286C11.5964 4.65362 11.6667 4.82319 11.6667 5V5.66667C11.6667 6.03486 11.9651 6.33333 12.3333 6.33333C12.7015 6.33333 13 6.03486 13 5.66667V5C13 4.46957 12.7893 3.96086 12.4142 3.58579C12.0391 3.21071 11.5304 3 11 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V11C3 11.5304 3.21071 12.0391 3.58579 12.4142C3.96086 12.7893 4.46957 13 5 13H5.66667C6.03486 13 6.33333 12.7015 6.33333 12.3333C6.33333 11.9651 6.03486 11.6667 5.66667 11.6667H5C4.82319 11.6667 4.65362 11.5964 4.5286 11.4714C4.40357 11.3464 4.33333 11.1768 4.33333 11V5C4.33333 4.82319 4.40357 4.65362 4.5286 4.5286Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.66675 7.66663C8.56218 7.66663 7.66675 8.56206 7.66675 9.66663V15.6666C7.66675 16.7712 8.56218 17.6666 9.66675 17.6666H15.6667C16.7713 17.6666 17.6667 16.7712 17.6667 15.6666V9.66663C17.6667 8.56206 16.7713 7.66663 15.6667 7.66663H9.66675ZM9.00008 9.66663C9.00008 9.29844 9.29856 8.99996 9.66675 8.99996H15.6667C16.0349 8.99996 16.3334 9.29844 16.3334 9.66663V15.6666C16.3334 16.0348 16.0349 16.3333 15.6667 16.3333H9.66675C9.29856 16.3333 9.00008 16.0348 9.00008 15.6666V9.66663Z" fill="white"/>
</svg>
);

export const IconNewTab = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
<svg width="20" height="20" viewBox="0 0 20 20" className={`cicon ${className}`}  fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.834 3.99967C11.834 3.63148 12.1325 3.33301 12.5007 3.33301H16.5007C16.5784 3.33301 16.6531 3.34633 16.7225 3.37081C16.8137 3.40289 16.8992 3.45537 16.9721 3.52827C17.105 3.6611 17.17 3.83603 17.1673 4.0101V7.99967C17.1673 8.36786 16.8688 8.66634 16.5007 8.66634C16.1325 8.66634 15.834 8.36786 15.834 7.99967V5.60923L9.6388 11.8044C9.37845 12.0648 8.95634 12.0648 8.69599 11.8044C8.43565 11.5441 8.43565 11.122 8.69599 10.8616L14.8913 4.66634H12.5007C12.1325 4.66634 11.834 4.36786 11.834 3.99967ZM5.83398 6.66634C5.65717 6.66634 5.4876 6.73658 5.36258 6.8616C5.23756 6.98663 5.16732 7.1562 5.16732 7.33301V14.6663C5.16732 14.8432 5.23756 15.0127 5.36258 15.1377C5.4876 15.2628 5.65717 15.333 5.83398 15.333H13.1673C13.3441 15.333 13.5137 15.2628 13.6387 15.1377C13.7637 15.0127 13.834 14.8432 13.834 14.6663V10.6663C13.834 10.2982 14.1325 9.99967 14.5007 9.99967C14.8688 9.99967 15.1673 10.2982 15.1673 10.6663V14.6663C15.1673 15.1968 14.9566 15.7055 14.5815 16.0806C14.2065 16.4556 13.6978 16.6663 13.1673 16.6663H5.83398C5.30355 16.6663 4.79484 16.4556 4.41977 16.0806C4.0447 15.7055 3.83398 15.1968 3.83398 14.6663V7.33301C3.83398 6.80257 4.0447 6.29387 4.41977 5.91879C4.79484 5.54372 5.30355 5.33301 5.83398 5.33301H9.83398C10.2022 5.33301 10.5007 5.63148 10.5007 5.99967C10.5007 6.36786 10.2022 6.66634 9.83398 6.66634H5.83398Z" fill="#687D96"/>
</svg>

);

// export const drayosLiteLogo = ({ className,
// }: React.HTMLAttributes<HTMLDivElement>) =>(
//   <svg width="100" height="50" viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M82.0769 19.8421C82.0769 21.5069 81.7614 22.9233 81.1302 24.0911C80.5041 25.259 79.6493 26.151 78.5659 26.7673C77.4875 27.3785 76.2749 27.6842 74.9281 27.6842C73.5714 27.6842 72.3538 27.3761 71.2754 26.7598C70.197 26.1436 69.3447 25.2515 68.7186 24.0837C68.0924 22.9158 67.7793 21.5019 67.7793 19.8421C67.7793 18.1773 68.0924 16.7609 68.7186 15.593C69.3447 14.4252 70.197 13.5356 71.2754 12.9244C72.3538 12.3081 73.5714 12 74.9281 12C76.2749 12 77.4875 12.3081 78.5659 12.9244C79.6493 13.5356 80.5041 14.4252 81.1302 15.593C81.7614 16.7609 82.0769 18.1773 82.0769 19.8421ZM78.8044 19.8421C78.8044 18.7637 78.6429 17.8542 78.3199 17.1138C78.0018 16.3733 77.5521 15.8117 76.9706 15.4291C76.3892 15.0464 75.7084 14.8551 74.9281 14.8551C74.1479 14.8551 73.467 15.0464 72.8856 15.4291C72.3042 15.8117 71.8519 16.3733 71.5289 17.1138C71.2108 17.8542 71.0518 18.7637 71.0518 19.8421C71.0518 20.9205 71.2108 21.8299 71.5289 22.5704C71.8519 23.3109 72.3042 23.8725 72.8856 24.2551C73.467 24.6378 74.1479 24.8291 74.9281 24.8291C75.7084 24.8291 76.3892 24.6378 76.9706 24.2551C77.5521 23.8725 78.0018 23.3109 78.3199 22.5704C78.6429 21.8299 78.8044 20.9205 78.8044 19.8421Z" fill="white"/>
// <path d="M92.7499 16.5994C92.6902 15.9981 92.4343 15.5309 91.9821 15.198C91.5298 14.865 90.9161 14.6985 90.1408 14.6985C89.614 14.6985 89.1692 14.7731 88.8065 14.9221C88.4437 15.0663 88.1654 15.2675 87.9716 15.526C87.7827 15.7844 87.6883 16.0776 87.6883 16.4056C87.6783 16.6789 87.7355 16.9175 87.8597 17.1212C87.9889 17.325 88.1654 17.5014 88.389 17.6505C88.6126 17.7946 88.8711 17.9213 89.1643 18.0307C89.4575 18.135 89.7706 18.2245 90.1035 18.299L91.4752 18.627C92.1411 18.7761 92.7523 18.9749 93.3089 19.2234C93.8655 19.4719 94.3476 19.7775 94.7551 20.1403C95.1626 20.5031 95.4782 20.9304 95.7018 21.4224C95.9304 21.9144 96.0472 22.4785 96.0522 23.1146C96.0472 24.0489 95.8087 24.8589 95.3366 25.5447C94.8694 26.2256 94.1935 26.7549 93.3089 27.1325C92.4293 27.5053 91.3683 27.6916 90.1259 27.6916C88.8934 27.6916 87.82 27.5028 86.9056 27.1251C85.9961 26.7474 85.2855 26.1883 84.7736 25.4478C84.2667 24.7024 84.0008 23.7805 83.976 22.6822H87.0994C87.1342 23.1941 87.2808 23.6215 87.5392 23.9644C87.8026 24.3023 88.1529 24.5583 88.5903 24.7322C89.0326 24.9012 89.532 24.9857 90.0886 24.9857C90.6353 24.9857 91.1099 24.9061 91.5124 24.7471C91.9199 24.5881 92.2355 24.3669 92.4591 24.0837C92.6828 23.8004 92.7946 23.4749 92.7946 23.1071C92.7946 22.7642 92.6927 22.476 92.489 22.2424C92.2902 22.0089 91.997 21.8101 91.6093 21.6461C91.2267 21.4821 90.757 21.333 90.2004 21.1988L88.5381 20.7814C87.251 20.4683 86.2347 19.9788 85.4892 19.3128C84.7438 18.6469 84.3735 17.7499 84.3785 16.6218C84.3735 15.6974 84.6195 14.8898 85.1165 14.1991C85.6184 13.5083 86.3067 12.9691 87.1814 12.5814C88.056 12.1938 89.05 12 90.1632 12C91.2962 12 92.2852 12.1938 93.13 12.5814C93.9798 12.9691 94.6408 13.5083 95.1129 14.1991C95.585 14.8898 95.8286 15.69 95.8435 16.5994H92.7499Z" fill="white"/>
// <path d="M67.8555 30.5818V29.2639H74.0647V30.5818H71.7501V36.8243H70.1701V30.5818H67.8555Z" fill="white"/>
// <path d="M74.469 36.8243V31.154H75.9936V32.1434H76.0527C76.156 31.7914 76.3295 31.5256 76.5732 31.346C76.8168 31.1639 77.0974 31.0728 77.4149 31.0728C77.4936 31.0728 77.5785 31.0777 77.6696 31.0876C77.7606 31.0974 77.8406 31.1109 77.9095 31.1282V32.5236C77.8357 32.5014 77.7336 32.4818 77.6031 32.4645C77.4727 32.4473 77.3533 32.4387 77.245 32.4387C77.0137 32.4387 76.807 32.4891 76.6249 32.59C76.4452 32.6885 76.3025 32.8263 76.1966 33.0035C76.0933 33.1807 76.0416 33.385 76.0416 33.6163V36.8243H74.469Z" fill="white"/>
// <path d="M80.1771 36.9314C79.8153 36.9314 79.4929 36.8686 79.2099 36.7431C78.9269 36.6151 78.7029 36.4268 78.538 36.1783C78.3756 35.9272 78.2944 35.6147 78.2944 35.2406C78.2944 34.9256 78.3522 34.661 78.4679 34.4469C78.5835 34.2328 78.7411 34.0605 78.9404 33.9301C79.1397 33.7997 79.3662 33.7012 79.6197 33.6348C79.8756 33.5683 80.1439 33.5216 80.4244 33.4945C80.7542 33.46 81.02 33.428 81.2218 33.3985C81.4236 33.3665 81.57 33.3197 81.6611 33.2582C81.7522 33.1967 81.7977 33.1056 81.7977 32.985V32.9629C81.7977 32.7291 81.7239 32.5482 81.5762 32.4202C81.431 32.2923 81.2243 32.2283 80.956 32.2283C80.673 32.2283 80.4478 32.291 80.2805 32.4165C80.1131 32.5396 80.0024 32.6946 79.9482 32.8817L78.4937 32.7635C78.5676 32.419 78.7128 32.1212 78.9293 31.8702C79.1459 31.6167 79.4252 31.4223 79.7673 31.2869C80.1119 31.1491 80.5106 31.0802 80.9634 31.0802C81.2784 31.0802 81.5799 31.1171 81.8678 31.1909C82.1582 31.2648 82.4154 31.3792 82.6394 31.5342C82.8658 31.6893 83.0442 31.8886 83.1747 32.1323C83.3051 32.3735 83.3703 32.6626 83.3703 32.9998V36.8243H81.8789V36.038H81.8346C81.7436 36.2152 81.6217 36.3715 81.4691 36.5068C81.3166 36.6397 81.1332 36.7443 80.9191 36.8206C80.705 36.8944 80.4576 36.9314 80.1771 36.9314ZM80.6275 35.846C80.8588 35.846 81.0631 35.8005 81.2403 35.7094C81.4175 35.6159 81.5565 35.4904 81.6574 35.3329C81.7583 35.1754 81.8088 34.997 81.8088 34.7976V34.1959C81.7596 34.2279 81.6919 34.2574 81.6057 34.2845C81.5221 34.3091 81.4273 34.3325 81.3215 34.3546C81.2157 34.3743 81.1098 34.3928 81.004 34.41C80.8982 34.4248 80.8022 34.4383 80.7161 34.4506C80.5315 34.4777 80.3703 34.5207 80.2325 34.5798C80.0946 34.6389 79.9876 34.7189 79.9113 34.8198C79.835 34.9182 79.7969 35.0413 79.7969 35.1889C79.7969 35.403 79.8744 35.5667 80.0294 35.6799C80.1869 35.7907 80.3863 35.846 80.6275 35.846Z" fill="white"/>
// <path d="M87.1524 36.935C86.5715 36.935 86.0719 36.812 85.6536 36.5659C85.2376 36.3173 84.9177 35.9728 84.6938 35.5322C84.4723 35.0917 84.3615 34.5847 84.3615 34.0113C84.3615 33.4305 84.4735 32.9211 84.6974 32.483C84.9239 32.0425 85.245 31.6991 85.661 31.453C86.0769 31.2045 86.5715 31.0802 87.145 31.0802C87.6396 31.0802 88.0728 31.17 88.4444 31.3497C88.816 31.5293 89.1101 31.7816 89.3267 32.1064C89.5433 32.4313 89.6626 32.8128 89.6848 33.2508H88.2008C88.1589 32.9678 88.0482 32.7402 87.8685 32.5679C87.6913 32.3932 87.4588 32.3058 87.1708 32.3058C86.9272 32.3058 86.7143 32.3722 86.5322 32.5051C86.3525 32.6356 86.2122 32.8263 86.1113 33.0773C86.0104 33.3284 85.96 33.6323 85.96 33.9892C85.96 34.3509 86.0092 34.6586 86.1076 34.9121C86.2085 35.1655 86.35 35.3587 86.5322 35.4916C86.7143 35.6245 86.9272 35.691 87.1708 35.691C87.3505 35.691 87.5117 35.6541 87.6544 35.5802C87.7996 35.5064 87.919 35.3993 88.0125 35.2591C88.1085 35.1163 88.1712 34.9453 88.2008 34.7459H89.6848C89.6602 35.1791 89.542 35.5605 89.3304 35.8903C89.1212 36.2176 88.832 36.4736 88.4629 36.6582C88.0937 36.8428 87.6569 36.935 87.1524 36.935Z" fill="white"/>
// <path d="M92.1166 35.1926L92.1203 33.3062H92.3492L94.1655 31.154H95.9706L93.5305 34.0039H93.1577L92.1166 35.1926ZM90.6917 36.8243V29.2639H92.2643V36.8243H90.6917ZM94.2356 36.8243L92.567 34.3546L93.6154 33.2435L96.0777 36.8243H94.2356Z" fill="white"/>
// <path d="M10.173 32.5404C9.01702 32.5404 7.97002 32.2431 7.03201 31.6486C6.10061 31.0475 5.36077 30.1657 4.8125 29.0031C4.27083 27.8338 4 26.4004 4 24.7027C4 22.9588 4.28074 21.5089 4.84223 20.3529C5.40371 19.1903 6.15015 18.3216 7.08156 17.747C8.01956 17.1657 9.04675 16.875 10.1631 16.875C11.0152 16.875 11.7254 17.0203 12.2934 17.311C12.8681 17.595 13.3305 17.9517 13.6806 18.3811C14.0373 18.8039 14.3082 19.22 14.4931 19.6296H14.622V12H18.8331V32.2927H14.6715V29.8552H14.4931C14.295 30.278 14.0142 30.6974 13.6509 31.1136C13.2942 31.5231 12.8285 31.8633 12.2538 32.1341C11.6857 32.405 10.9921 32.5404 10.173 32.5404ZM11.5107 29.1814C12.1911 29.1814 12.7658 28.9964 13.2348 28.6265C13.7104 28.25 14.0737 27.7248 14.3247 27.0511C14.5823 26.3773 14.7111 25.5879 14.7111 24.6829C14.7111 23.7779 14.5856 22.9919 14.3346 22.3247C14.0836 21.6575 13.7203 21.1423 13.2447 20.779C12.7691 20.4157 12.1911 20.234 11.5107 20.234C10.8171 20.234 10.2325 20.4223 9.75686 20.7988C9.28125 21.1753 8.92124 21.6972 8.67683 22.3643C8.43242 23.0315 8.31021 23.8044 8.31021 24.6829C8.31021 25.5681 8.43242 26.3509 8.67683 27.0313C8.92785 27.705 9.28786 28.2335 9.75686 28.6166C10.2325 28.9931 10.8171 29.1814 11.5107 29.1814Z" fill="#172A41"/>
// <path d="M22.3035 32.2927V17.0732H26.3958V19.7287H26.5543C26.8317 18.784 27.2974 18.0706 27.9514 17.5884C28.6054 17.0996 29.3584 16.8552 30.2106 16.8552C30.4219 16.8552 30.6498 16.8684 30.8942 16.8948C31.1387 16.9212 31.3533 16.9576 31.5383 17.0038V20.7492C31.3401 20.6898 31.066 20.6369 30.7159 20.5907C30.3658 20.5445 30.0454 20.5213 29.7548 20.5213C29.1338 20.5213 28.579 20.6568 28.0901 20.9276C27.6079 21.1918 27.2248 21.5617 26.9407 22.0373C26.6633 22.513 26.5246 23.0612 26.5246 23.6822V32.2927H22.3035Z" fill="#172A41"/>
// <path d="M37.6246 32.58C36.6536 32.58 35.7882 32.4116 35.0286 32.0747C34.2689 31.7312 33.6678 31.2259 33.2252 30.5587C32.7893 29.8849 32.5713 29.046 32.5713 28.0419C32.5713 27.1964 32.7265 26.4863 33.037 25.9116C33.3474 25.3369 33.7702 24.8745 34.3053 24.5244C34.8403 24.1743 35.448 23.9101 36.1284 23.7317C36.8154 23.5534 37.5354 23.4278 38.2885 23.3552C39.1737 23.2627 39.8871 23.1768 40.4287 23.0976C40.9704 23.0117 41.3634 22.8862 41.6079 22.721C41.8523 22.5559 41.9745 22.3115 41.9745 21.9878V21.9284C41.9745 21.3008 41.7763 20.8153 41.38 20.4718C40.9902 20.1283 40.4353 19.9566 39.7153 19.9566C38.9557 19.9566 38.3512 20.125 37.9021 20.4619C37.4529 20.7922 37.1556 21.2083 37.0103 21.7104L33.1063 21.3933C33.3045 20.4685 33.6942 19.6692 34.2755 18.9954C34.8568 18.315 35.6066 17.7932 36.5248 17.4299C37.4496 17.06 38.5197 16.875 39.7351 16.875C40.5807 16.875 41.3899 16.9741 42.1627 17.1723C42.9422 17.3704 43.6325 17.6776 44.2336 18.0938C44.8413 18.5099 45.3203 19.045 45.6704 19.6989C46.0205 20.3463 46.1955 21.1225 46.1955 22.0274V32.2927H42.1925V30.1822H42.0736C41.8291 30.6578 41.5022 31.0772 41.0926 31.4405C40.6831 31.7973 40.1909 32.078 39.6162 32.2828C39.0415 32.4809 38.3777 32.58 37.6246 32.58ZM38.8335 29.6669C39.4544 29.6669 40.0027 29.5447 40.4783 29.3003C40.9539 29.0493 41.3271 28.7124 41.5979 28.2896C41.8688 27.8669 42.0042 27.388 42.0042 26.8529V25.2378C41.8721 25.3237 41.6904 25.4029 41.4592 25.4756C41.2346 25.5417 40.9803 25.6044 40.6963 25.6639C40.4122 25.7167 40.1282 25.7663 39.8441 25.8125C39.5601 25.8521 39.3025 25.8885 39.0713 25.9215C38.5758 25.9942 38.1432 26.1098 37.7733 26.2683C37.4033 26.4268 37.116 26.6415 36.9112 26.9123C36.7064 27.1766 36.604 27.5069 36.604 27.9032C36.604 28.4779 36.8121 28.9172 37.2283 29.221C37.651 29.5183 38.1861 29.6669 38.8335 29.6669Z" fill="#172A41"/>
// <path d="M51.5312 38C50.9962 38 50.4942 37.9571 50.0252 37.8712C49.5628 37.7919 49.1796 37.6895 48.8758 37.564L49.827 34.4131C50.3224 34.565 50.7683 34.6476 51.1646 34.6608C51.5676 34.674 51.9144 34.5816 52.205 34.3834C52.5023 34.1852 52.7434 33.8483 52.9284 33.3727L53.1761 32.7287L47.7165 17.0732H52.1555L55.3064 28.25H55.4649L58.6456 17.0732H63.1143L57.1989 33.9375C56.9149 34.7566 56.5285 35.47 56.0396 36.0777C55.5574 36.6921 54.9464 37.1644 54.2066 37.4947C53.4667 37.8316 52.575 38 51.5312 38Z" fill="#172A41"/>
// </svg>
// );


export const IconDrayos = ({
  className,
}: React.HTMLAttributes<HTMLDivElement>) => (
<svg width="100" height="50" viewBox="0 0 100 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M82.0769 19.8421C82.0769 21.5069 81.7614 22.9233 81.1302 24.0911C80.5041 25.259 79.6493 26.151 78.5659 26.7673C77.4875 27.3785 76.2749 27.6842 74.9281 27.6842C73.5714 27.6842 72.3538 27.3761 71.2754 26.7598C70.197 26.1436 69.3447 25.2515 68.7186 24.0837C68.0924 22.9158 67.7793 21.5019 67.7793 19.8421C67.7793 18.1773 68.0924 16.7609 68.7186 15.593C69.3447 14.4252 70.197 13.5356 71.2754 12.9244C72.3538 12.3081 73.5714 12 74.9281 12C76.2749 12 77.4875 12.3081 78.5659 12.9244C79.6493 13.5356 80.5041 14.4252 81.1302 15.593C81.7614 16.7609 82.0769 18.1773 82.0769 19.8421ZM78.8044 19.8421C78.8044 18.7637 78.6429 17.8542 78.3199 17.1138C78.0018 16.3733 77.5521 15.8117 76.9706 15.4291C76.3892 15.0464 75.7084 14.8551 74.9281 14.8551C74.1479 14.8551 73.467 15.0464 72.8856 15.4291C72.3042 15.8117 71.8519 16.3733 71.5289 17.1138C71.2108 17.8542 71.0518 18.7637 71.0518 19.8421C71.0518 20.9205 71.2108 21.8299 71.5289 22.5704C71.8519 23.3109 72.3042 23.8725 72.8856 24.2551C73.467 24.6378 74.1479 24.8291 74.9281 24.8291C75.7084 24.8291 76.3892 24.6378 76.9706 24.2551C77.5521 23.8725 78.0018 23.3109 78.3199 22.5704C78.6429 21.8299 78.8044 20.9205 78.8044 19.8421Z" fill="white"/>
<path d="M92.7499 16.5994C92.6902 15.9981 92.4343 15.5309 91.9821 15.198C91.5298 14.865 90.9161 14.6985 90.1408 14.6985C89.614 14.6985 89.1692 14.7731 88.8065 14.9221C88.4437 15.0663 88.1654 15.2675 87.9716 15.526C87.7827 15.7844 87.6883 16.0776 87.6883 16.4056C87.6783 16.6789 87.7355 16.9175 87.8597 17.1212C87.9889 17.325 88.1654 17.5014 88.389 17.6505C88.6126 17.7946 88.8711 17.9213 89.1643 18.0307C89.4575 18.135 89.7706 18.2245 90.1035 18.299L91.4752 18.627C92.1411 18.7761 92.7523 18.9749 93.3089 19.2234C93.8655 19.4719 94.3476 19.7775 94.7551 20.1403C95.1626 20.5031 95.4782 20.9304 95.7018 21.4224C95.9304 21.9144 96.0472 22.4785 96.0522 23.1146C96.0472 24.0489 95.8087 24.8589 95.3366 25.5447C94.8694 26.2256 94.1935 26.7549 93.3089 27.1325C92.4293 27.5053 91.3683 27.6916 90.1259 27.6916C88.8934 27.6916 87.82 27.5028 86.9056 27.1251C85.9961 26.7474 85.2855 26.1883 84.7736 25.4478C84.2667 24.7024 84.0008 23.7805 83.976 22.6822H87.0994C87.1342 23.1941 87.2808 23.6215 87.5392 23.9644C87.8026 24.3023 88.1529 24.5583 88.5903 24.7322C89.0326 24.9012 89.532 24.9857 90.0886 24.9857C90.6353 24.9857 91.1099 24.9061 91.5124 24.7471C91.9199 24.5881 92.2355 24.3669 92.4591 24.0837C92.6828 23.8004 92.7946 23.4749 92.7946 23.1071C92.7946 22.7642 92.6927 22.476 92.489 22.2424C92.2902 22.0089 91.997 21.8101 91.6093 21.6461C91.2267 21.4821 90.757 21.333 90.2004 21.1988L88.5381 20.7814C87.251 20.4683 86.2347 19.9788 85.4892 19.3128C84.7438 18.6469 84.3735 17.7499 84.3785 16.6218C84.3735 15.6974 84.6195 14.8898 85.1165 14.1991C85.6184 13.5083 86.3067 12.9691 87.1814 12.5814C88.056 12.1938 89.05 12 90.1632 12C91.2962 12 92.2852 12.1938 93.13 12.5814C93.9798 12.9691 94.6408 13.5083 95.1129 14.1991C95.585 14.8898 95.8286 15.69 95.8435 16.5994H92.7499Z" fill="white"/>
<path d="M67.8555 30.5818V29.2639H74.0647V30.5818H71.7501V36.8243H70.1701V30.5818H67.8555Z" fill="white"/>
<path d="M74.469 36.8243V31.154H75.9936V32.1434H76.0527C76.156 31.7914 76.3295 31.5256 76.5732 31.346C76.8168 31.1639 77.0974 31.0728 77.4149 31.0728C77.4936 31.0728 77.5785 31.0777 77.6696 31.0876C77.7606 31.0974 77.8406 31.1109 77.9095 31.1282V32.5236C77.8357 32.5014 77.7336 32.4818 77.6031 32.4645C77.4727 32.4473 77.3533 32.4387 77.245 32.4387C77.0137 32.4387 76.807 32.4891 76.6249 32.59C76.4452 32.6885 76.3025 32.8263 76.1966 33.0035C76.0933 33.1807 76.0416 33.385 76.0416 33.6163V36.8243H74.469Z" fill="white"/>
<path d="M80.1771 36.9314C79.8153 36.9314 79.4929 36.8686 79.2099 36.7431C78.9269 36.6151 78.7029 36.4268 78.538 36.1783C78.3756 35.9272 78.2944 35.6147 78.2944 35.2406C78.2944 34.9256 78.3522 34.661 78.4679 34.4469C78.5835 34.2328 78.7411 34.0605 78.9404 33.9301C79.1397 33.7997 79.3662 33.7012 79.6197 33.6348C79.8756 33.5683 80.1439 33.5216 80.4244 33.4945C80.7542 33.46 81.02 33.428 81.2218 33.3985C81.4236 33.3665 81.57 33.3197 81.6611 33.2582C81.7522 33.1967 81.7977 33.1056 81.7977 32.985V32.9629C81.7977 32.7291 81.7239 32.5482 81.5762 32.4202C81.431 32.2923 81.2243 32.2283 80.956 32.2283C80.673 32.2283 80.4478 32.291 80.2805 32.4165C80.1131 32.5396 80.0024 32.6946 79.9482 32.8817L78.4937 32.7635C78.5676 32.419 78.7128 32.1212 78.9293 31.8702C79.1459 31.6167 79.4252 31.4223 79.7673 31.2869C80.1119 31.1491 80.5106 31.0802 80.9634 31.0802C81.2784 31.0802 81.5799 31.1171 81.8678 31.1909C82.1582 31.2648 82.4154 31.3792 82.6394 31.5342C82.8658 31.6893 83.0442 31.8886 83.1747 32.1323C83.3051 32.3735 83.3703 32.6626 83.3703 32.9998V36.8243H81.8789V36.038H81.8346C81.7436 36.2152 81.6217 36.3715 81.4691 36.5068C81.3166 36.6397 81.1332 36.7443 80.9191 36.8206C80.705 36.8944 80.4576 36.9314 80.1771 36.9314ZM80.6275 35.846C80.8588 35.846 81.0631 35.8005 81.2403 35.7094C81.4175 35.6159 81.5565 35.4904 81.6574 35.3329C81.7583 35.1754 81.8088 34.997 81.8088 34.7976V34.1959C81.7596 34.2279 81.6919 34.2574 81.6057 34.2845C81.5221 34.3091 81.4273 34.3325 81.3215 34.3546C81.2157 34.3743 81.1098 34.3928 81.004 34.41C80.8982 34.4248 80.8022 34.4383 80.7161 34.4506C80.5315 34.4777 80.3703 34.5207 80.2325 34.5798C80.0946 34.6389 79.9876 34.7189 79.9113 34.8198C79.835 34.9182 79.7969 35.0413 79.7969 35.1889C79.7969 35.403 79.8744 35.5667 80.0294 35.6799C80.1869 35.7907 80.3863 35.846 80.6275 35.846Z" fill="white"/>
<path d="M87.1524 36.935C86.5715 36.935 86.0719 36.812 85.6536 36.5659C85.2376 36.3173 84.9177 35.9728 84.6938 35.5322C84.4723 35.0917 84.3615 34.5847 84.3615 34.0113C84.3615 33.4305 84.4735 32.9211 84.6974 32.483C84.9239 32.0425 85.245 31.6991 85.661 31.453C86.0769 31.2045 86.5715 31.0802 87.145 31.0802C87.6396 31.0802 88.0728 31.17 88.4444 31.3497C88.816 31.5293 89.1101 31.7816 89.3267 32.1064C89.5433 32.4313 89.6626 32.8128 89.6848 33.2508H88.2008C88.1589 32.9678 88.0482 32.7402 87.8685 32.5679C87.6913 32.3932 87.4588 32.3058 87.1708 32.3058C86.9272 32.3058 86.7143 32.3722 86.5322 32.5051C86.3525 32.6356 86.2122 32.8263 86.1113 33.0773C86.0104 33.3284 85.96 33.6323 85.96 33.9892C85.96 34.3509 86.0092 34.6586 86.1076 34.9121C86.2085 35.1655 86.35 35.3587 86.5322 35.4916C86.7143 35.6245 86.9272 35.691 87.1708 35.691C87.3505 35.691 87.5117 35.6541 87.6544 35.5802C87.7996 35.5064 87.919 35.3993 88.0125 35.2591C88.1085 35.1163 88.1712 34.9453 88.2008 34.7459H89.6848C89.6602 35.1791 89.542 35.5605 89.3304 35.8903C89.1212 36.2176 88.832 36.4736 88.4629 36.6582C88.0937 36.8428 87.6569 36.935 87.1524 36.935Z" fill="white"/>
<path d="M92.1166 35.1926L92.1203 33.3062H92.3492L94.1655 31.154H95.9707L93.5305 34.0039H93.1577L92.1166 35.1926ZM90.6917 36.8243V29.2639H92.2643V36.8243H90.6917ZM94.2356 36.8243L92.567 34.3546L93.6154 33.2435L96.0777 36.8243H94.2356Z" fill="white"/>
<path d="M10.173 32.5404C9.01702 32.5404 7.97002 32.2431 7.03201 31.6486C6.10061 31.0475 5.36077 30.1657 4.8125 29.0031C4.27083 27.8338 4 26.4004 4 24.7027C4 22.9588 4.28074 21.5089 4.84223 20.3529C5.40371 19.1903 6.15015 18.3216 7.08156 17.747C8.01956 17.1657 9.04675 16.875 10.1631 16.875C11.0152 16.875 11.7254 17.0203 12.2934 17.311C12.8681 17.595 13.3305 17.9517 13.6806 18.3811C14.0373 18.8039 14.3082 19.22 14.4931 19.6296H14.622V12H18.8331V32.2927H14.6715V29.8552H14.4931C14.295 30.2779 14.0142 30.6974 13.6509 31.1136C13.2942 31.5231 12.8285 31.8633 12.2538 32.1341C11.6857 32.405 10.9921 32.5404 10.173 32.5404ZM11.5107 29.1814C12.1911 29.1814 12.7658 28.9964 13.2348 28.6265C13.7104 28.25 14.0737 27.7248 14.3247 27.0511C14.5823 26.3773 14.7111 25.5879 14.7111 24.6829C14.7111 23.7779 14.5856 22.9919 14.3346 22.3247C14.0836 21.6575 13.7203 21.1423 13.2447 20.779C12.7691 20.4157 12.1911 20.234 11.5107 20.234C10.8171 20.234 10.2325 20.4223 9.75686 20.7988C9.28125 21.1753 8.92124 21.6972 8.67683 22.3643C8.43242 23.0315 8.31021 23.8044 8.31021 24.6829C8.31021 25.5681 8.43242 26.3509 8.67683 27.0313C8.92785 27.705 9.28786 28.2335 9.75686 28.6166C10.2325 28.9931 10.8171 29.1814 11.5107 29.1814Z" fill="#172A41"/>
<path d="M22.3035 32.2927V17.0732H26.3958V19.7287H26.5543C26.8317 18.784 27.2974 18.0706 27.9514 17.5884C28.6054 17.0996 29.3584 16.8552 30.2106 16.8552C30.4219 16.8552 30.6498 16.8684 30.8942 16.8948C31.1387 16.9212 31.3533 16.9576 31.5383 17.0038V20.7492C31.3401 20.6898 31.066 20.6369 30.7159 20.5907C30.3658 20.5445 30.0454 20.5213 29.7548 20.5213C29.1338 20.5213 28.579 20.6568 28.0901 20.9276C27.6079 21.1918 27.2248 21.5617 26.9407 22.0373C26.6633 22.513 26.5246 23.0612 26.5246 23.6822V32.2927H22.3035Z" fill="#172A41"/>
<path d="M37.6246 32.58C36.6536 32.58 35.7882 32.4116 35.0286 32.0747C34.2689 31.7312 33.6678 31.2259 33.2252 30.5587C32.7893 29.8849 32.5713 29.046 32.5713 28.0419C32.5713 27.1964 32.7265 26.4863 33.037 25.9116C33.3474 25.3369 33.7702 24.8745 34.3053 24.5244C34.8403 24.1743 35.448 23.9101 36.1284 23.7317C36.8154 23.5534 37.5354 23.4278 38.2885 23.3552C39.1737 23.2627 39.8871 23.1768 40.4287 23.0976C40.9704 23.0117 41.3634 22.8862 41.6079 22.721C41.8523 22.5559 41.9745 22.3115 41.9745 21.9878V21.9284C41.9745 21.3008 41.7763 20.8153 41.38 20.4718C40.9902 20.1283 40.4353 19.9566 39.7153 19.9566C38.9557 19.9566 38.3512 20.125 37.9021 20.4619C37.4529 20.7922 37.1556 21.2083 37.0103 21.7104L33.1063 21.3933C33.3045 20.4685 33.6942 19.6692 34.2755 18.9954C34.8568 18.315 35.6066 17.7932 36.5248 17.4299C37.4496 17.06 38.5197 16.875 39.7351 16.875C40.5807 16.875 41.3899 16.9741 42.1627 17.1723C42.9422 17.3704 43.6325 17.6776 44.2336 18.0938C44.8413 18.5099 45.3203 19.045 45.6704 19.6989C46.0205 20.3463 46.1955 21.1225 46.1955 22.0274V32.2927H42.1925V30.1822H42.0736C41.8291 30.6578 41.5022 31.0772 41.0926 31.4405C40.6831 31.7973 40.1909 32.078 39.6162 32.2828C39.0415 32.4809 38.3777 32.58 37.6246 32.58ZM38.8335 29.6669C39.4544 29.6669 40.0027 29.5447 40.4783 29.3003C40.9539 29.0493 41.3271 28.7124 41.5979 28.2896C41.8688 27.8669 42.0042 27.388 42.0042 26.8529V25.2378C41.8721 25.3237 41.6904 25.4029 41.4592 25.4756C41.2346 25.5417 40.9803 25.6044 40.6963 25.6639C40.4122 25.7167 40.1282 25.7663 39.8441 25.8125C39.5601 25.8521 39.3025 25.8885 39.0713 25.9215C38.5758 25.9942 38.1432 26.1098 37.7732 26.2683C37.4033 26.4268 37.116 26.6415 36.9112 26.9123C36.7064 27.1766 36.604 27.5069 36.604 27.9032C36.604 28.4779 36.8121 28.9172 37.2283 29.221C37.651 29.5183 38.1861 29.6669 38.8335 29.6669Z" fill="#172A41"/>
<path d="M51.5313 38C50.9962 38 50.4942 37.9571 50.0252 37.8712C49.5628 37.7919 49.1796 37.6895 48.8758 37.564L49.827 34.4131C50.3224 34.565 50.7683 34.6476 51.1646 34.6608C51.5676 34.674 51.9144 34.5816 52.205 34.3834C52.5023 34.1852 52.7434 33.8483 52.9284 33.3727L53.1761 32.7287L47.7165 17.0732H52.1555L55.3064 28.25H55.4649L58.6456 17.0732H63.1143L57.1989 33.9375C56.9149 34.7566 56.5285 35.47 56.0396 36.0777C55.5574 36.6921 54.9464 37.1644 54.2066 37.4947C53.4667 37.8316 52.575 38 51.5313 38Z" fill="#172A41"/>
</svg>


);







